import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import * as CookieService from '../CookieService';
import * as OrderStatusAction from '../actions/OrderStatusAction';
import OrderStatusStore from '../stores/OrderStatusStore';
import Autocomplete from 'react-autocomplete';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import SDIConstants from '../SDIConstants';

//import { MultiSelect } from 'multiselect-react-dropdown';
import MultiSelect from "react-multi-select-component";
import {
    PDFDownloadLink
} from '@react-pdf/renderer';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import PDFPreviewComponent from './PDFPreviewComponent';
import Switch from '@material-ui/core/Switch';
import "react-datepicker/dist/react-datepicker.css";
//import { DropdownMultiselectModule } from 'ng2-dropdown-multiselect';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import ImageGallery from 'react-image-gallery';
import { withTranslation, Trans } from 'react-i18next';
//[2/16/22], WW-330, Dhevanesam R
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import { RotatingLines } from 'react-loader-spinner';
import swal from 'sweetalert';
import Select from 'react-select';
import Copy from 'copy-to-clipboard';
import { grey } from '@material-ui/core/colors';

//import Switch from "react-switch";
let currentPagePath;
let searchTxt = "";
let searchTrTxt = "";
let searchTrOption = "";
let FilterPopupBoolean = false;
let searchTrBy = "OrderNo";
let searchTrCriteria = "";
let Addr = "";
let isPostback = false;
let isPrioritySearch = false;
let Session_BUSUNIT = "";
let OrderSuccessCOunt = 0
let radio = "ExactValue";
let radiochange = false;
let GlobalSearchCol = "";
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
let OrderLevelQuoteClick = false;
class OrderStatusComponent extends Component {
    /**
     * OS_PC_03
     * Declare a “constructor” method with “props” as its parameters.
     */
    constructor(props) {
        super(props);
        this.assignPref = this.assignPref.bind(this);
        this.SavePreferenceClick = this.SavePreferenceClick.bind(this);
        this.Sorting = this.Sorting.bind(this);
        this.FileExport = this.FileExport.bind(this);
        this.data = this.data.bind(this);
        this.ApplyFilter = this.ApplyFilter.bind(this);
        this.PODetail = this.PODetail.bind(this);
        this.ApplyFilterbutton = this.ApplyFilterbutton.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.AnykeyHeaderPress = this.AnykeyHeaderPress.bind(this);
        this.handleHeaderSearch = this.handleHeaderSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.Approvalhistory = this.Approvalhistory.bind(this);
        this.bindApproveHistoryPopupDetail = this.bindApproveHistoryPopupDetail.bind(this);
        this.clearButtonClick = this.clearButtonClick.bind(this);
        this.addFavItemsToCart = this.addFavItemsToCart.bind(this);
        this.PODetailPopup = this.PODetailPopup.bind(this);
        this.AnykeyPress = this.AnykeyPress.bind(this);
        this.AddedToCart = this.AddedToCart.bind(this);
        this.searchTr = this.searchTr.bind(this);
        this.PassThroughAutheResponse = this.PassThroughAutheResponse.bind(this);
        this.linedatagrid = this.linedatagrid.bind(this);
        this.handleToggleChange = this.handleToggleChange.bind(this);
        //WW-1230 - WO searvice channel navigation -Nandhini L
        this.WOClick = this.WOClick.bind(this)
        this.bindAttachments = this.bindAttachments.bind(this)
        const maxDate = new Date(); // Get the current date
        maxDate.setDate(maxDate.getDate() + 10);
        this.state = {

            FilterPopupModal: false,
            ApprovalPopup: false,
            ShipmentBOLPopup: false,
            PODetailPopup: false,
            toggleChecked: false,
            filterDisplayName: "All", STrDisplayName: "Order Number",
            ReportDateField: "X",
            OrderTypeField: "All",
            ReportTypeField: "Site",
            EmpIdField: "",
            BusUnitField: "",
            SearchOption: "ExactValue", isSearch: true,/*[07/25/22, PC_WW-455-01]Priyanka D*/
            sSearchCriteria: "", searchColumn: "All",
            sortType: "DESC",
            sortColumn: "ORD_DATE_FILTER", PageNo: 1, RecCount: 10, totalCount: 0, OrdertotalCount: 0, pageCount: 0, totArr: [], checkbox: false, searchAval: false,
            BusUnitDropDown: [], CompanyBU: "",
            EmpIdDropDown: [], Emplist: [], EmpListPush: [], OrderStatus: [], status: "",
            ThirdPartyBU: [], isFilter: false, isExpand: false, isPOExpand: true,
            SavedPrefTable: [],
            FlagData: [], hiddenFlag: [],
            GridArr: [], InvGridArr: [], GridArr2: [], DetailTable: [], POData: [], VenderDetail: [], shipmentBOL: [], shipmentAddr: [], shipmentpopup: [], usernamedetail: [],
            ApprovalhistoryArr: [],
            selectedEmpId: [],
            OFromDate: null, OrderDateBoolean: false, NeedByDateBoolean: false, SearchTrFromDate: "", SearchTrToDate: "", alert: Date,
            OToDate: null,
            imagearray: [],
            NFromDate: "", blockprice: CookieService.getLocalStorageValues("Session_ISAPriceBlock"),
            NToDate: null, EmpString: "", showprice: CookieService.getLocalStorageValues("Session_ShowPrice"), EV: true, MN: false, DR: false,
            ApprovalHistoryL: "", POGridArr: [], isFilterOpen: false, isFavorited: false, lblTest: "", lblVersion: "", priorityFlag: 0, base64URL: "",
            Pickup_VendorList: [], Pickup_store_tbl: [], DivisionDD: [], RegionDD: [], SubRegionDD: [], Division: " ", Region: " ", SubRegion: " ", Manager: "", DivTbl: [], BuyAgainArray: [],
            //ExactValueRR: false, dateRangeRR:false, MonthRR:false,
            OrderNoList: [], LineNoList: [], IsLineLevel: false, CancelItemReasonDesc: "", ItemLevel: "", CancelItemReasonDrop: "Select", CancelItemReasonText: "", OrderStatusSearch: "", ApplyFilterClick: false, //WW-366_PC_02,
            HeaderGridArray: [], LineGridArray: [], HeaderUniqueGridArray: [], LineDetailsGrid: [], SearchedTxt: "", OrderCategory: " ", MainOrderStatus: " ", ASNdetails: [], ASNlineData: [], cancelBtnStatuses: "", showReasonPopup: "",
            PickupOrderNo: "", PickupLineNo: "", PickupIndex: "", //WW-644_PC_01 (3/6/2023) -Aparna
            PickupCoreCharge: false, IsConfirm: true, IprAlertMsge: "Do you want to cancel this order ?", reprintSuccessmsg: "'", coreReturns: [], isDropOff: true, serviceTypes: [], packageTypes: [],
            selectedService: "PRIORITY_OVERNIGHT", selectedPackage: [], maxDate: maxDate, filteredPackage: [], weightText: "", selectedShipdate: "", coreResponseErr: "",
            POTracking_no: [], CurrentUserName: "", CurrentUserLimit: "", NextApprover: "", NextApproverLimit: "", ApproverPopupFlag: true,
            ApproverListPopup: [], headerNotes: "", RemainderOrder: "", OrderApprover: "", Alternates: [], OrderedForData: [], RemainderApprover: "", ApproverListUser: "", OLEmployee: "", RemainderLineItems: "",
            fragileImgDetail: [],
            //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
            //11/22/2024, WW-1046 Start a return -Vishwa S
            RMAReasonDD: "Select",
            RMAReasonComment: "",
            RMAReasonDDOpt: [],
            startAReturnBODetail: {},
            returnSubmitBtn: false,
            OrderQuoteArray: [], OrderQuoteCheckedArray: [], //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
            reasonModal: "",
            inValidComments: false,
            notesHeader: "", orderNotes: [], requestorNotes: [], budgetaryNotes: [], cancelNotes: [], pdfarray : []
        }
        cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        OrderLevelQuoteClick = false;
    }
    componentWillUnmount() {

        OrderStatusStore.removeListener('OrdStatusload', this.assignPref);
        //;
        OrderStatusStore.removeListener('SavePreference', this.saveprefresponse);
        OrderStatusStore.removeListener('ApprovalHistory', this.bindApproveHistoryPopupDetail);
        OrderStatusStore.removeListener('POdetail', this.PODetail);
        OrderStatusStore.removeListener('data', this.data);
        OrderStatusStore.removeListener('BuyAgain', this.AddedToCart);
        OrderStatusStore.removeListener('Export', this.FileExport);
        OrderStatusStore.removeListener('OrderDetail', this.OrderDetailRsp);
        OrderStatusStore.removeListener('shipto', this.shiptoRsp);
        OrderStatusStore.removeListener('favpage', this.loadFavPageResponse);
        OrderStatusStore.removeListener('updateFavPage', this.updateFavPageResponse);
        OrderStatusStore.removeListener('PassThroughAuthe', this.PassThroughAutheResponse);
        OrderStatusStore.removeListener('CancelRequest', this.CancelRequestResponse);
        //Order Status Stored Procedure Integration Change - Deepthi
        OrderStatusStore.removeListener('HeaderData', this.HeaderDataResponse);
        OrderStatusStore.removeListener('LineData', this.LineDataResponse);
        OrderStatusStore.removeListener('PickupOrder', this.PickupOrderResponse);
        OrderStatusStore.removeListener('ReprintResponse', this.ReprintResponse);
        OrderStatusStore.removeListener('coreDetailsResponse', this.coreDetailsResponse);
        OrderStatusStore.removeListener('ApproverList', this.approverListResponse);
        OrderStatusStore.removeListener('ApprovalRemainder', this.RemainderResponse);
        OrderStatusStore.removeListener('StartAReturn', this.startAReturnResponse); //11/22/2024, WW-1046 Start a return -Vishwa S
        OrderStatusStore.removeListener('getNotes', this.getNotesResponse);



        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.on('Warehousecheck', this.warehouseqtyresponse);
    }

    componentDidMount() {
        /*******NEW******wal-158******/
        const queryParams = new URLSearchParams(window.location.search)
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        //console.log("window", window.location.pathname);
        const orderno_noti = queryParams.get('ordno');
        //if (orderno_noti == "" || orderno_noti == null) {
        //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //}
        console.log("orderno_noti", orderno_noti)
        //CPW-267 removed the HeaderData API call within notificationorderno since handled in assignPref method -Vishwa S
        //if (orderno_noti != "" && orderno_noti != null && orderno_noti != undefined) {
        //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //    this.notificationorderno(orderno_noti);
        //}
        /***********************END**********/


        $("#priorityDiv").hide();
        $("#sFT").hide();
        $("#sdrp").hide();
        $("#OR").hide();
        $("#status-dropdown").hide();
        $("#SearchTrTxt").show();

        Session_BUSUNIT = CookieService.getLocalStorageValues("Session_BUSUNIT");
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        OrderStatusAction.getCurrentFavPage(getFavPageBO);

        let OrderStatusPageLoadBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            IsWeb: true,
            Session_User_Division: CookieService.getLocalStorageValues("Session_User_Division") != undefined && CookieService.getLocalStorageValues("Session_User_Division") != null ? CookieService.getLocalStorageValues("Session_User_Division") : ""  //WW-1324 -Vishwa S
        }
        /**********NEW****wal-158****/
        console.log("sdiemp", CookieService.getLocalStorageValues("Session_SDIEMP"));
        //if (orderno_noti == "" || orderno_noti==null) {
        //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //}
        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
        /********END*************/
        console.log("orderno_noti", orderno_noti);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.GetOrderStatusPageLoad(OrderStatusPageLoadBO);

        //;
        OrderStatusStore.on('OrdStatusload', this.assignPref.bind(this));
        //;
        OrderStatusStore.on('SavePreference', this.saveprefresponse);
        OrderStatusStore.on('ApprovalHistory', this.bindApproveHistoryPopupDetail);
        OrderStatusStore.on('POdetail', this.PODetail);
        OrderStatusStore.on('data', this.data);
        OrderStatusStore.on('BuyAgain', this.AddedToCart);
        OrderStatusStore.on('Export', this.FileExport);
        OrderStatusStore.on('OrderDetail', this.OrderDetailRsp);
        OrderStatusStore.on('shipto', this.shiptoRsp);
        OrderStatusStore.on('favpage', this.loadFavPageResponse.bind(this));
        OrderStatusStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        OrderStatusStore.on('PassThroughAuthe', this.PassThroughAutheResponse);
        OrderStatusStore.on('CancelRequest', this.CancelRequestResponse);
        //Order Status Stored Procedure Integration Change - Deepthi
        OrderStatusStore.on('HeaderData', this.HeaderDataResponse);
        OrderStatusStore.on('LineData', this.LineDataResponse);
        OrderStatusStore.on('PickupOrder', this.PickupOrderResponse); //WW-644_PC_02 (3/6/2023) -Aparna
        OrderStatusStore.on('ReprintResponse', this.ReprintResponse.bind(this));
        OrderStatusStore.on('coreDetailsResponse', this.coreDetailsResponse.bind(this));
        OrderStatusStore.on('SubmitReturn', this.SubmitReturnRespone.bind(this));
        OrderStatusStore.on('ApproverList', this.approverListResponse)
        OrderStatusStore.on('ApprovalRemainder', this.RemainderResponse)

        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.on('Warehousecheck', this.warehouseqtyresponse);
        OrderStatusStore.on('StartAReturn', this.startAReturnResponse); //11/22/2024, WW-1046 Start a return -Vishwa S
        OrderStatusStore.on('getNotes', this.getNotesResponse);
    }
    //WW-644_PC_07 (3/6/2023) -Aparna
    OnPickupCancelBtnClick = () => {
        this.setState({ PickupOrderNo: "", PickupLineNo: "", PickupIndex: "", PickupCoreCharge: false })

    }
    //WW-644_PC_06 -Aparna
    OnPickupOkBtnClick = () => {
        let list = []
        //WW-644
        if (this.state.PickupCoreCharge) {
            list.push(parseInt(this.state.PickupLineNo))
            let corechangeLine = parseInt(this.state.PickupLineNo) + 1
            list.push(corechangeLine)
        }
        else {
            list.push(parseInt(this.state.PickupLineNo))
        }
        let BO = {
            Order_No: this.state.PickupOrderNo,
            LineList: list,
            Bus_Unit: "I0W01"

        }
        OrderStatusAction.PickupOrderAction(BO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

    }
    //WW-644_PC_08 (3/6/2023)-Aparna
    PickupOrderResponse = () => {
        let response = OrderStatusStore.PickupRslt
        console.log("resposne pickup", response);
        if (response == "false") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in updating satus"
            });
        }
        else {
            if (this.state.HeaderGridArray != null && this.state.HeaderGridArray != undefined) {
                let { HeaderGridArray } = this.state;
                HeaderGridArray.forEach((x, i) => {
                    if (x.ORDER_NO == this.state.PickupOrderNo) {
                        HeaderGridArray[i].ORDER_STATUS = response
                        if (x.ISA_INTFC_LN == this.state.PickupLineNo) {
                            HeaderGridArray[i].ISA_LINE_STATUS = "DLF"
                        }
                    }
                })

                let st = response.split('^');
                // HeaderGridArray[this.state.PickupIndex].ISA_LINE_STATUS = st[0]
                //this.setState({ HeaderGridArray });
                let { LineDetailsGrid } = this.state;
                console.log("LineDetailsGrid", LineDetailsGrid)
                console.log("HeaderGridArray", HeaderGridArray)
                let ind = LineDetailsGrid.findIndex(x => x.ORDER_NO == this.state.PickupOrderNo && x.LINE_NBR == this.state.PickupLineNo);
                if (ind != null && ind != -1) {
                    LineDetailsGrid[ind].LINE_STATUS = "Delivered"
                    LineDetailsGrid[ind].ISA_LINE_STATUS = "DLF"
                    this.setState({ LineDetailsGrid });
                }
                this.setState({ HeaderGridArray });

            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Status updated successfully"
            });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');


    }
    //WW-644_PC_05 (3/6/2023)-Aparna
    onPickupClick = (OrderNo, LineNo, Index, iscore) => {
        let ind = this.state.HeaderGridArray.findIndex(x => x.ORDER_NO == OrderNo && x.ISA_INTFC_LN == LineNo);

        this.setState({ PickupOrderNo: OrderNo, PickupLineNo: LineNo, PickupIndex: ind, PickupCoreCharge: iscore });
        $('#PickupConfirmation').modal('show');
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(OrderStatusStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (OrderStatusStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(OrderStatusStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(OrderStatusStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    handleToggleChange(checked) {
        if (this.state.OrderDateBoolean || this.state.NeedByDateBoolean) {
            FilterPopupBoolean = true;
        }
        else {
            FilterPopupBoolean = false;
        }
        let searchCol = this.state.searchColumn
        if (searchTxt != "") {
            searchCol = this.state.searchColumn;
            if (searchCol == "LINE_PRIOR") {
                if (this.state.priorityFlag == 1) {
                    searchTxt = `R`;
                }
                else if (this.state.priorityFlag == 2) {
                    searchTxt = ` `;
                }
                else {
                    searchCol = "";
                    searchTxt = ` `;
                }

            }
            else {
                searchTxt = $(`#searchTxt`).val();
                //WW -366_PC_10  (5/20/2022) - Aparna
                if (searchTxt == "" || searchTxt == null) {
                    searchCol = this.state.searchColumn;
                    if (searchCol != "LINE_PRIOR" && searchCol != "LINE_STATUS" && searchCol != "ORDER_TYPE") {
                        searchTxt = $(`#searchTxt`).val();
                    }
                    else if (searchCol == "LINE_STATUS" || searchCol == "ORDER_TYPE") {
                        searchTxt = this.state.OrderStatusSearch
                    }
                }
            }
        }


        console.log("buttonclick", FilterPopupBoolean);

        let pageNo = 1;
        this.setState({ PageNo: pageNo });
        //Order Status Stored Procedure Integration Change - Deepthi
        this.GetHeaderDetailes(false, searchTxt, checked, "Yes");

        this.setState({ toggleChecked: checked });
    }
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Check Order Status",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            OrderStatusAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            OrderStatusAction.deleteFavPage(deleteFavPageBO)
        }
    };
    FilterInventoryItems = () => {

        let InvArray = this.state.InvGridArr;
        //cyclecountResponse.Table[0].TOTAL_COUNT > 0 ? cyclecountResponse.Table[0].TOTAL_COUNT : 0,

        if (InvArray.length > 0) {
            let tc = InvArray.length;
            this.setState({
                InvFilteredArr: InvArray,
                InvtotalCount: tc,
                InvpageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.InvRecCount),
            });
        }
        else {
            this.setState({ InvtotalCount: "0" });
        }
    }
    data = () => {
        //;

        let PageLoadResponse = JSON.parse(OrderStatusStore.PageLoadData);

        console.log("totArr", PageLoadResponse);
        //$("#priorityDiv").hide();
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        //let OrderGrid = PageLoadResponse.ds;
        //let filtered = OrderGrid.filter((value, indexVal) => value.ORDER_NO == order.ORDER_NO).length;
        //WAL-704 APARNA
        //let count = PageLoadResponse.Count[0].TOTALCOUNT;
        //let linecount = PageLoadResponse.Count[0].LINECOUNT;
        //BUG_2111_PC_01 
        let applygrid = false;
        let FlagTable = [];
        let checkqty = false;
        let pickup_store_tbl = PageLoadResponse.Pickup_store_tbl.length > 0 ? PageLoadResponse.Pickup_store_tbl : [];
        let pickup_VendorList = PageLoadResponse.Pickup_VendorList.length > 0 ? PageLoadResponse.Pickup_VendorList : [];
        if (PageLoadResponse.ds.length > 0) {


            // let pg = Math.ceil((PageLoadResponse.Count[0].LINECOUNT > 0 ? PageLoadResponse.Count[0].LINECOUNT : 0) / this.state.RecCount);
            let count = PageLoadResponse.ds.length;
            //let linecount = PageLoadResponse.LineItemIDs.length;
            let linecount = PageLoadResponse.Count[0].LINECOUNT;
            //let linecount = PageLoadResponse.Count[0].TOTALCOUNT;
            //WW-399_PC_06 (5/16/2022) -Aparna
            let uniqueorder = PageLoadResponse.ds.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === v.ORDER_NO.trim().toUpperCase())) === i);
            let ordercount = uniqueorder.length
            let pg = Math.ceil((ordercount > 0 ? ordercount : 0) / this.state.RecCount);

            //let countno = count[0].COUNT(1);
            console.log("totArr", count);
            console.log("linecount", linecount);

            if (PageLoadResponse.ds.length > 0 || this.state.searchAval) {
                applygrid = true;
            }
            if (PageLoadResponse.FlagTable) {
                FlagTable = PageLoadResponse.FlagTable;
            }
            //;
            //WAL-704 APARNA
            //let total = PageLoadResponse.Count.length > 0 ? PageLoadResponse.Count[0].TOTALCOUNT : 0
            let total = count > 0 ? count : 0

            //console.log("search", this.state.searchAval)
            //*************NEW********wal-158****


            console.log("Pickup_VendorList", pickup_VendorList);

            //********************END************
            //To Get Item ID 
            if (PageLoadResponse) {
                if (PageLoadResponse.ds) {
                    if (PageLoadResponse.ds.length > 0) {
                        PageLoadResponse.ds.forEach((item, index) => {
                            let OrderfilteredItem = [];
                            if (PageLoadResponse.LineItemIDs)
                                OrderfilteredItem = PageLoadResponse.LineItemIDs.filter((x) => x.ORDER_NO == item.ORDER_NO && x.BUSINESS_UNIT_OM == item.BUSINESS_UNIT_OM && x.ISA_INTFC_LN == item.LINE_NBR);
                            if (OrderfilteredItem.length > 0) {
                                item.INV_ITEM_ID = OrderfilteredItem[0].ISA_ITEM;
                            }
                        });
                    }
                }
            }
            //[12/22/21], PC_OS_13, WW-286, Dhevanesam R
            let GridArrResponse = []
            GridArrResponse = PageLoadResponse.ds;
            //1898 - Unable to add Items from different pages through buy again - Deepthi 
            GridArrResponse.forEach((value, index) => {
                value.checked = false;
            });
            let Buyagaindata = this.state.BuyAgainArray
            if (Buyagaindata.length > 0) {
                Buyagaindata.forEach((Buyvalue, index) => {
                    GridArrResponse.forEach((value, index) => {
                        if (value.ORDER_NO === Buyvalue.ORDER_NO && value.LINE_NBR == Buyvalue.LINE_NBR) {
                            value.checked = true;
                        }
                    });
                });
            }
            GridArrResponse.forEach((value, index) => {
                //debugger
                value.hasCoreCharge = false;
                if (value.DESCR254.includes("Core Charges")) {
                    //debugger
                    //GridArrResponse.splice(index, 1);
                    value.hasCoreCharge = true;
                    //if (index - 1 != -1) {
                    //    GridArrResponse[index - 1].hasCoreCharge = true; 
                    //}

                }

            });
            //[2/16/22], WW-330, Dhevanesam R

            GridArrResponse.forEach((value, index) => {
                value.hasBenItemVal = "";
                value.InvItemQtyCheck = false
            });
            //debugger
            if (localStorage.getItem("StoreValue") != undefined || localStorage.getItem("StoreValue") != null) {
                //BenStoreVal = JSON.parse(localStorage.getItem("StoreValue"));
                let warehouse_item = GridArrResponse.filter((x) => x.SUPPLIER == "SDI Warehouse")
                let loacalloc = JSON.parse(localStorage.getItem("StoreValue"))

                if (warehouse_item.length > 0) {
                    checkqty = true;
                }
                if (checkqty) {
                    let itemids = []
                    warehouse_item.map((val, index) => {
                        //debugger
                        itemids.push(val.INV_ITEM_ID)
                    });
                    if (itemids.length > 0) {
                        //debugger
                        let BO = {
                            shipto_id: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//loacalloc, WAL-767-Aparna
                            supplier_part_number: itemids,
                            User_Id: CookieService.getLocalStorageValues("Session_UserID")
                        }
                        //debugger
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        ShoppingCartAction.WarehouseQTYCheck(BO)
                    }

                }
            }
            //let InvItemArray2 = PageLoadResponse.Invds;
            //let FiltInvItemArray =InvItemArray2.filter((x) => x.LINEFIELD == "REPLN");
            //////////
            this.setState({ GridArr: GridArrResponse, GridArr2: PageLoadResponse.ds2, OrdertotalCount: ordercount, totalCount: total, pageCount: pg, searchAval: applygrid, isExpand: false, shipmentpopup: FlagTable, Pickup_store_tbl: pickup_store_tbl, Pickup_VendorList: pickup_VendorList, ApplyFilterClick: true }); // WW-366 added ApplyFitlerClick(5/31/2022)-Aparna

        }
        else {
            //WW -399_PC_06
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "No data found"
            });
            //   alert("No data found");
            this.setState({ GridArr: [], GridArr2: [], totalCount: 0, OrdertotalCount: 0, pageCount: 0, searchAval: applygrid, isExpand: false, shipmentpopup: FlagTable, isExpand: false, shipmentpopup: FlagTable, Pickup_store_tbl: pickup_store_tbl, Pickup_VendorList: pickup_VendorList, alert: "", ApplyFilterClick: true }) // WW-366 added ApplyFitlerClick(5/31/2022)-Aparna
        }
        // this.setState({ GridArr2: PageLoadResponse.ds2 });
        ////;
        //;
        //let search=$('#searchTxt').val();
        //if (PageLoadResponse.ds == "") {
        //    if (!FilterPopupBoolean && searchTxt == "") {
        //        if (!this.state.OrderDateBoolean && !this.state.NeedByDateBoolean) {
        //            alert("No data g found");
        //        }
        //    }

        //    console.log("no data");
        //    //this.setState({ OFromDate: "", OToDate: "", NFromDate: "", NToDate: "", sFromDate: "", sToDate: "", alert: "" });
        //    this.setState({ alert: "" });
        //    //_____________________________
        //    //FilterPopupBoolean = false;
        //    //_____________________________
        //}
        // this.setState({  });
        //// //;
        // this.setState({ pageCount: Math.ceil((PageLoadResponse.Count[0].TOTALCOUNT > 0 ? PageLoadResponse.Count[0].TOTALCOUNT : 0) / this.state.RecCount) });
        //GridArr.Item.forEach((value, index) => {
        //    value.checked = false;
        //});

        //;
        if (!checkqty) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    }
    //[2/16/22], WW-330, Dhevanesam R
    warehouseqtyresponse = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Workorderresponse = JSON.parse(ShoppingCartStore.workorderresponse);
        let local = Workorderresponse.Table
        let st = 0
        let GridArrResponse = this.state.HeaderGridArray
        if (local.length > 0) {
            //debugger
            local.forEach((x) => {
                //debugger
                if (x.QTY != null) {
                    st = x.QTY.split('^')[0];
                    //debugger
                    console.log("hasBenItemVal", x.QTY.slice(-1))
                    GridArrResponse.forEach((value, index) => {
                        if (GridArrResponse[index].INV_ITEM_ID == x.INV_ITEM_ID) {
                            value.hasBenItemVal = x.QTY.slice(-1);
                            //debugger
                            if (st == 0) {
                                //debugger
                                value.InvItemQtyCheck = true
                            }
                        }

                    });
                }
            })
        }
        this.setState({
            HeaderGridArray: GridArrResponse
        })
        //debugger
        console.log("GridArrResponseCribFavItem", GridArrResponse)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    assignPref = () => {

        let PageLoadResponse = JSON.parse(OrderStatusStore.PageLoadData);
        //Orderstatus dropdown AWS duplication -Aparna
        let OSD = []
        const { t } = this.props;

        /*[07/14/22, PC_WW-447_01-Sprint-23], Priyanka D */
        if (PageLoadResponse.FilterTable != null) {
            OSD = PageLoadResponse.FilterTable.filter((v, i, a) => a.findIndex(t => (t.MAIN_STATUS.trim().toUpperCase() === v.MAIN_STATUS.trim().toUpperCase())) === i)
        }
        //Order Status Stored Procedure Integration Change - Deepthi
        let pickup_store_tbl = PageLoadResponse.Pickup_store_tbl.length > 0 ? PageLoadResponse.Pickup_store_tbl : [];
        let pickup_VendorList = JSON.parse(localStorage.getItem("PickupVendor")) != undefined && JSON.parse(localStorage.getItem("PickupVendor")) != null ? JSON.parse(localStorage.getItem("PickupVendor")) : []; //WW-1324 -Vishwa S

        //11/22/2024, WW-1046 setting the return reason dropdown options -Vishwa S
        let locReturnReason = [];
        if (PageLoadResponse.StartReturnReasonTbl != undefined && PageLoadResponse.StartReturnReasonTbl != null) {
            locReturnReason = PageLoadResponse.StartReturnReasonTbl
        }
        this.setState({ BusUnitDropDown: [], EmpList: PageLoadResponse.EmpListTable, OrderStatus: OSD, hiddenFlag: [], Pickup_store_tbl: pickup_store_tbl, Pickup_VendorList: pickup_VendorList, RMAReasonDDOpt: locReturnReason });
        // this.setState({  });
        // this.setState({  });
        //;
        let environmentDataResponse;
        //;
        environmentDataResponse = JSON.parse(localStorage.getItem("SDIEnvironmentData"));
        environmentDataResponse = environmentDataResponse[0];
        console.log("buhist", environmentDataResponse);
        let length = [];
        length = PageLoadResponse.sisterSites;
        console.log("length", this.state.BusUnitDropDown);
        let EMP = [];
        //;
        //if (this.state.EmpList) {
        //    this.state.EmpList.map((val, index) => {

        //        let localArray = {
        //            value: val.EMP_ID,
        //            label: val.ISA_EMPLOYEE_NAME,

        //        }

        //        EMP.push(localArray)
        //    });
        //}
        let originalString = "";
        //;
        this.setState({ SavedPrefTable: PageLoadResponse.SavedPrefTable, ThirdPartyBU: PageLoadResponse.EmpListTable });

        // this.setState({  });

        let Thrid = [];
        //;
        if (this.state.ThirdPartyBU) {
            this.state.ThirdPartyBU.map((val, index) => {

                let third = {
                    value: val.EMP_ID,
                    label: val.ISA_EMPLOYEE_NAME,

                }

                EMP.push(third)
            });
        }
        //Array.prototype.push.apply(arr1, arr2);
        console.log("empdroplist", EMP);
        //;
        if (PageLoadResponse.SavedPrefTable != "") {
            //;

            let DivTab = PageLoadResponse.Division;
            let reg = DivTab.filter((ele, ind) => ele.DIVISION == PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL7 && ele.REGION != ' ' && ele.REGION != null && ele.SUB_REGION != ' ' && ele.SUB_REGION != null)
            let region = reg.filter((v, i, a) => a.findIndex(t => (t.REGION.trim().toUpperCase() === v.REGION.trim().toUpperCase())) === i)
            let subregion = reg.filter((v, i, a) => a.findIndex(t => (t.SUB_REGION.trim().toUpperCase() === v.SUB_REGION.trim().toUpperCase())) === i)
            let OrdStatus = (PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL11 == null || PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL11.toLowerCase == "select") ? "" : PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL11;
            let OrdCat = (PageLoadResponse.SavedPrefTable[0].ISA_ATTRLBL10 == null || PageLoadResponse.SavedPrefTable[0].ISA_ATTRLBL10.toLowerCase == "select") ? "" : PageLoadResponse.SavedPrefTable[0].ISA_ATTRLBL10;
            //WW-830 Order status screen not showing results until i search for an order number - Deepthi N H
            this.setState({
                ReportDateField: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL1, OrderTypeField: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL3,
                Division: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL7, Region: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL8,
                SubRegion: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL9, RegionDD: region, SubRegionDD: subregion,
                ReportTypeField: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL5, EmpString: PageLoadResponse.SavedPrefTable[0].ISA_LIST_EMPL_ID, MainOrderStatus: OrdStatus,
                OrderCategory: OrdCat
            });
            // this.setState({  }); 


            //this.setState({
            //    ReportTypeField: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL5, EmpString: PageLoadResponse.SavedPrefTable[0].ISA_LIST_EMPL_ID, MainOrderStatus: OrdStatus,
            //    OrderCategory: OrdCat
            //});
            //this.setState({ });
            console.log("bu", CookieService.getLocalStorageValues("Session_BUSUNIT"));
            if (PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL5 == "Company") {
                this.setState({ BusUnitField: CookieService.getLocalStorageValues("Session_BUSUNIT") });

            }
            else {
                this.setState({ BusUnitField: PageLoadResponse.SavedPrefTable[0].ISA_ATTRVAL6 });
            }

        } else {
            this.setState({ BusUnitField: CookieService.getLocalStorageValues("Session_BUSUNIT"), OrderTypeField: "My" });
        }

        let MultiSelectValue = [];
        if (this.state.EmpString != " ") {
            let separatedArray = [];
            //let EmpDD = [];
            //EmpDD=
            separatedArray = this.state.EmpString.split(',');
            console.log("splice arr", separatedArray);

            separatedArray.map((val, index) => {
                let ChildSiteValue = EMP.filter((item, index) => item.value == val);
                //;
                console.log("ChildSiteValue", ChildSiteValue);
                if (ChildSiteValue.length > 0) {
                    let localArray = {
                        value: ChildSiteValue[0].value,
                        label: ChildSiteValue[0].label
                    }
                    MultiSelectValue.push(localArray)
                }
            });
            console.log("MultiSelectValue", MultiSelectValue);
            //;

        }

        //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R Fetch Approvers popup data
        let user = "";
        let userLimit = "";
        let approver = "";
        let approverLimit = "";
        let popupFlag = true;
        let Session_ThirdParty_CompanyID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID");
        if (Session_ThirdParty_CompanyID != null && Session_ThirdParty_CompanyID != undefined) {
            Session_ThirdParty_CompanyID = Session_ThirdParty_CompanyID
        }
        if ((PageLoadResponse.ApproverData != null && PageLoadResponse.ApproverData.length > 0) && (Session_ThirdParty_CompanyID.trim != "" && Session_ThirdParty_CompanyID <= 99)) {
            user = PageLoadResponse.ApproverData[0].CURRENTUSER;
            approver = PageLoadResponse.ApproverData[0].NEXTAPPROVER;
            userLimit = PageLoadResponse.ApproverData[0].CURRENTUSERLIMIT;
            approverLimit = PageLoadResponse.ApproverData[0].NEXTAPPROVERLIMIT;
        }
        else {
            popupFlag = false;
        }

        /****NEW*****wal-336*****/
        let manager = PageLoadResponse.FlagTable[0].ATTRIB_MANAGER
        let division = [];
        let divisionD = [];
        let region = [];
        let subregion = [];
        let divtbl = [];
        //debugger
        if (PageLoadResponse.Division) {
            if (PageLoadResponse.Division.length > 0) {
                let div = [];
                divtbl = PageLoadResponse.Division
                div = PageLoadResponse.Division;
                division = div.filter((ele, ind) => ind === div.findIndex(elem => elem.DIVISION === ele.DIVISION && elem.DIVISION != ' ' && elem.DIVISION != null))
                // divisionD = division.filter((ele, ind) => ind === div.findIndex(elem => elem.DIVISION.trim() === ele.DIVISION.trim()))
                //[12/15/21, PC_OS_02, WW-300, Dhevanesam R - To filter the region and subregion on the pageload and set state it]
                region = div.filter((ele, ind) => ind === div.findIndex(elem => elem.REGION === ele.REGION && elem.REGION != ' ' && elem.REGION != null))
                subregion = div.filter((ele, ind) => ind === div.findIndex(elem => elem.SUB_REGION === ele.SUB_REGION && elem.SUB_REGION != ' ' && elem.SUB_REGION != null))
                //division = div.filter((v, i, a) => a.findIndex(t => (t.DIVISION === v.DIVISION)) === i)
                // region = div.filter((v, i, a) => a.findIndex(t => (t.REGION.trim() === v.REGION.trim())) === i)
                // subregion = div.filter((v, i, a) => a.findIndex(t => (t.SUB_REGION.trim().toUpperCase() === v.SUB_REGION.trim().toUpperCase())) === i)
            }
        }
        console.log("division", division);
        console.log("region", region);
        console.log("subregion", subregion);
        console.log("manager", manager);
        /****************END**************/
        this.setState({ CompanyBU: "", DivTbl: divtbl, EmpListPush: MultiSelectValue, EmpIdDropDown: EMP, DivisionDD: division, RegionDD: region, SubRegionDD: subregion, Manager: manager, managerdata: manager, CurrentUserName: user, CurrentUserLimit: userLimit, NextApprover: approver, NextApproverLimit: approverLimit, ApproverPopupFlag: popupFlag }); {/*, RegionDD: region, SubRegionDD: subregion,**/ }
        let lblVersion = "";
        lblVersion = environmentDataResponse.lblVersion;
        let ver = [];
        ver = lblVersion.split(' _Z_  :: SUAT :: ');
        this.setState({ searchAval: false, lblTest: environmentDataResponse.lblTest, lblVersion: ver[0] + ver[1] });
        //;
        console.log("CompanyBU", this.state.CompanyBU);
        console.log("BusUnitDropDown", this.state.BusUnitDropDown);
        /*******NEW******wal-158******/
        const queryParams = new URLSearchParams(window.location.search)


        let orderno_noti = queryParams.get('ordno');
        console.log("orderno_noti", orderno_noti)
        //CPW-267 -Vishwa S
        if (this.props.location.hasOwnProperty('state') && this.props.location.state != undefined && this.props.location.state.hasOwnProperty('origin')) {
            if (this.props.location.state.hasOwnProperty('ordno')) {
                orderno_noti = this.props.location.state.ordno;
            }
        }

        /***********************END**********/

        //$(`#${SDIConstants.SDILoader}`).addClass('hide');

        //    if (PageLoadResponse.SavedPrefTable.length > 0) {


        //    //if (this.state.SavedPrefTable[0].ISA_ATTRVAL7 != " " && this.state.SavedPrefTable[0].ISA_ATTRVAL8 != " " && this.state.SavedPrefTable[0].ISA_ATTRVAL9 != " ") {

        //    //    $(`#ordertype`).prop('disabled', true);

        //    //} else {
        //    //    $(`#ordertype`).prop('disabled', false);
        //    //}
        //}
        const userqueryParams = new URLSearchParams(window.location.search);
        let OrderNo = userqueryParams.get('ordno');
        //CPW-267 -Vishwa S
        if (this.props.location.hasOwnProperty('state') && this.props.location.state != undefined && this.props.location.state.hasOwnProperty('origin')) {
            if (this.props.location.state.hasOwnProperty('ordno')) {
                OrderNo = this.props.location.state.ordno;
            }
        }
        if (OrderNo != undefined && OrderNo != null && OrderNo != "") {
            console.log("usernotorder", OrderNo);
            let HeaderBO;
            HeaderBO = {
                FromDate: "",
                ToDate: "",
                SelectedReport: " ",
                OrderType: "All",
                sGroupList: [],
                UserId: CookieService.getLocalStorageValues("Session_UserID"),
                Division: "",
                Region: "",
                SubRegion: "",
                OrdStatus: "",
                OrdCat: "",
                SearchType: "All",
                SearchContent: OrderNo.trim(),
                IsInventory: 'False',
                Bus_Unit: 'I0W01'
            }

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            OrderStatusAction.HeaderData(HeaderBO);
        }
        else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }

    }

    OrderDetailRsp = () => {
        let PageLoadResponse = OrderStatusStore.Excel;
        //;
        OrderSuccessCOunt = OrderSuccessCOunt + 1
        $('#pdfPreview').modal('show');

        this.setState({ base64URL: PageLoadResponse })
        console.log("OrderDetailRsp", PageLoadResponse);
        //let win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1005,height=500,top=" + (window.screen.height - 200) + ",left=" + (window.screen.width - 300));
        //win.document.body.innerHTML = '<iframe width = "100%" height = "100%" src = "' + PageLoadResponse + '"></iframe>';


    }




    AddedToCart = () => {
        let addFavOrderdataRes = JSON.parse(OrderStatusStore.cartOrderSuccess);
        if (addFavOrderdataRes) {
            if (addFavOrderdataRes.Table1.length > 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Item added to cart successfully"
                });
                // alert("Item added to cart successfully");
                addFavOrderdataRes = addFavOrderdataRes.Table1[0];

                CookieService.updateLocalStorageValues("Session_CARTFAIL", addFavOrderdataRes.Session_CARTFAIL);
                //$(`#${SDIConstants.SDILoader}`).addClass('hide');

                this.RedirectTo("/shoppingcart");
            }
        }
    }

    RedirectTo = (pageName) => {
        let queryParamindex = pageName.indexOf("?");
        let pagePath = pageName;
        let queryParams = "";
        if (queryParamindex > 0) {
            pagePath = pageName.substring(0, queryParamindex);
            queryParams = pageName.substring(queryParamindex, pageName.length);
        };

        //event.preventDefault();
        this.props.history.push({
            pathname: pagePath,
            search: queryParams
        });
    };

    FileExport = () => {
        let addFavOrderdataRes = JSON.parse(OrderStatusStore.Excel);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //;
        //alert("file downloaded");
    }
    shiptoRsp = () => {
        let PageLoadResponse = JSON.parse(OrderStatusStore.Excel);
        if (PageLoadResponse) {
            if (PageLoadResponse.TotalData.length > 0) {
                this.setState({ shipmentBOL: PageLoadResponse.TotalData, shipmentAddr: PageLoadResponse.ResultanString });
                $('#shipmentBOL').modal('show');
            }
            if (PageLoadResponse.usernamedetail.length > 0) {


                this.setState({ usernamedetail: PageLoadResponse.usernamedetail });
                $('#shipmentpopup').modal('show');


            }
        }

    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
    GetApproversList = (EmpID, OrderNo, lineItems, WONo) => {

        let lineItemID = lineItems.findIndex((x) => x.ISA_LINE_STATUS == 'QTW')
        lineItemID = lineItemID == -1 ? 0 : lineItemID;
        let ApproverListBO = {
            EmployeeID: EmpID,
            EmployeeBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            ApproverListUser: lineItems[lineItemID].USERID,
            NextApprover: lineItems[lineItemID].NEXTAPPROVER,
            WONo: WONo,
            OrderNo: OrderNo
        }

        this.setState({ RemainderOrder: OrderNo, OrderApprover: lineItems[lineItemID].NEXTAPPROVER, ApproverListUser: lineItems[lineItemID].USERID, OLEmployee: EmpID, RemainderLineItems: lineItems[lineItemID].APR_CHAIN_LINEITEMID });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.GetApproversPopupList(ApproverListBO);

    }
    //PC_1044_154 WW-1044 Approval   [07/05/2024] Pavithra R
    approverListResponse = () => {
        let approverList = JSON.parse(OrderStatusStore.ApproverList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        if (approverList.ErrorTable[0].error == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue try again"
            })
            return;
        }

        let OrderedForData = approverList.FinalAlternates.filter((val) => val.USERID == this.state.OLEmployee);
        let Alternates = approverList.FinalAlternates != undefined && approverList.FinalAlternates != null ? approverList.FinalAlternates : [];
        this.setState({ ApproverListPopup: approverList.ApproverList, Alternates: Alternates, OrderedForData: OrderedForData })
        $('.approver-chain-details').modal('show')
    }


    //PC_1044_155 WW-1044 Approval   [07/05/2024] Pavithra R
    closeApproverspopup = (type) => {
        if (!$('#OrderApprover').hasClass('collapsed') && $('#multiCollapseExample1').hasClass('show')) {
            $("#OrderApprover").addClass("collapsed");
            $('#multiCollapseExample1').removeClass('show');
        }
        if (type == "remainder") {
            $('.approver-chain-details').modal('show');
        }
    }
    //PC_1044_156 WW-1044 Approval   [07/05/2024] Pavithra R
    bindApproverList = () => {
        if (this.state.ApproverListPopup.length > 0) {
            let length = this.state.ApproverListPopup.length;
            let OrderedFor = this.state.OrderedForData;
            return this.state.ApproverListPopup.map((val, index) => {
                if (val.NEXTAPPROVER == null) {
                    val.NEXTAPPROVER = "--"

                }
                return (
                    <>
                        {index == 0 ?
                            <div className="custom-approver-card-style current-user-style custom-mb">
                                <div className="d-flex align-items-center justify-content-start px-4">
                                    <div className="d-block mr-2">
                                        <img className="" src="images/user-icon.svg" alt="user-icon" />
                                    </div>
                                    <div className="d-block text-left">
                                        <p className="font-medium font-12 mb-0 mt-3 text-black" data-toggle="tooltip" title={OrderedFor[0].USERNAME} data-label="OrderedForName">{OrderedFor[0].USERNAME.length > 15 ? `${OrderedFor[0].USERNAME.substring(0, 15)}...` : OrderedFor[0].USERNAME}</p>
                                        <p className="mb-3">
                                            <span className="font-regular font-10 color-grey mr-1">
                                                Budgetary Limit:
                                        </span>
                                            <span className="Font-14 font-bold text-black">${OrderedFor[0].USERLIMIT}</span>
                                        </p>
                                    </div>
                                </div>
                            </div> : null}
                        {OrderedFor[0].USERID != val.ISA_EMPLOYEE_ID ?
                            val.ISA_EMPLOYEE_ID == this.state.OrderApprover ?
                                <div
                                    className="custom-approver-card-style attachment-remove-icon collapsed active card-after"
                                    data-toggle="collapse"
                                    data-target="#multiCollapseExample1"
                                    id="OrderApprover"
                                >
                                    <div className="d-flex align-items-center justify-content-start pl-4 pr-3">
                                        <div className="d-block mr-2">
                                            <img className="" src="images/user-icon.svg" alt="user-icon" />
                                        </div>
                                        <div className="d-block text-left w-100">
                                            <p className="font-medium font-12 mb-0 mt-3 text-black d-flex justify-content-between" data-toggle="tooltip" title={val.CURRENTUSER} data-label="CURRENTUSER">
                                                {val.CURRENTUSER.length > 15 ? `${val.CURRENTUSER.substring(0, 15)}...` : val.CURRENTUSER}
                                                <span>
                                                    <a className="" onClick={() => this.RemainderPopup(val.ISA_EMPLOYEE_ID,val.ACTIVE_STATUS)}>
                                                        <img src="images/notification.svg" alt="notification" />
                                                    </a>
                                                </span>
                                            </p>
                                            <p className="mb-3">
                                                <span className="font-regular font-10 color-grey mr-1">
                                                    Budgetary Limit:
                                        </span>
                                                <span className="Font-14 font-bold text-black">${val.CURRENTUSERLIMIT}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="custom-approver-card-style card-after">
                                    <div className="d-flex align-items-center justify-content-start px-4">
                                        <div className="d-block mr-2">
                                            <img className="" src="images/user-icon.svg" alt="user-icon" />
                                        </div>
                                        <div className="d-block text-left">
                                            <p className="font-medium font-12 mb-0 mt-3 text-black" data-toggle="tooltip" title={val.CURRENTUSER} data-label="CURRENTUSER">
                                                {val.CURRENTUSER.length > 15 ? `${val.CURRENTUSER.substring(0, 15)}...` : val.CURRENTUSER}</p>
                                            <p className="mb-3">
                                                <span className="font-regular font-10 color-grey mr-1">
                                                    Budgetary Limit:
        </span>
                                                <span className="Font-14 font-bold text-black">${val.CURRENTUSERLIMIT}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            : null}
                        {this.state.Alternates.length > 1 && val.ISA_EMPLOYEE_ID == this.state.OrderApprover ?
                            < div className="collapse multi-collapse w-100" id="multiCollapseExample1">
                                <div className="text-center">
                                    <h6 className="Font-14 font-medium text-black mb-3">Alternate Approver</h6>
                                </div>
                                <div className="card card-body border-0 pt-0 mb-4" style={{ 'padding-right': '40px' }}>
                                    <div className="row justify-content-center">
                                        {this.bindAlternates()}
                                    </div>
                                </div>
                            </div> : null
                        }
                        {val.NEXTAPPROVERLIMIT == null ?
                            val.ISA_IOL_APR_EMP_ID == this.state.OrderApprover ?
                                <div className="custom-approver-card-style card-after final-approver-style collapsed active attachment-remove-icon" id="OrderApprover" data-toggle="collapse" data-target="#multiCollapseExample1">
                                    <div className="d-flex align-items-center justify-content-start pl-4 pr-3">
                                        <div className="d-block mr-2">
                                            <img className="" src="images/user-icon.svg" alt="user-icon" />
                                        </div>
                                        <div className="d-block text-left w-100">
                                            <p className="font-medium font-12 mb-0 mt-3 text-black d-flex justify-content-between" data-toggle="tooltip" title={val.NEXTAPPROVER} data-label="NextApprover">
                                                {val.NEXTAPPROVER.length > 15 ? `${val.NEXTAPPROVER.substring(0, 15)}...` : val.NEXTAPPROVER}
                                                <span>
                                                    <a className="" onClick={() => this.RemainderPopup(val.ISA_IOL_APR_EMP_ID,val.ACTIVE_STATUS)}>
                                                        <img src="images/notification.svg" alt="notification" />
                                                    </a>
                                                </span>
                                            </p>
                                            <p className="mb-3">
                                                <span className="font-regular font-10 color-grey mr-1">
                                                    Budgetary Limit:
        </span>
                                                <span className="Font-14 font-bold text-black">-</span>
                                            </p>
                                        </div>
                                    </div>
                                </div> :
                                <div className="custom-approver-card-style card-after final-approver-style">
                                    <div className="d-flex align-items-center justify-content-start px-4">
                                        <div className="d-block mr-2">
                                            <img className="" src="images/user-icon.svg" alt="user-icon" />
                                        </div>
                                        <div className="d-block text-left">
                                            <p className="font-medium font-12 mb-0 mt-3 text-black" data-toggle="tooltip" title={val.NEXTAPPROVER} data-label="NextApprover">
                                                {val.NEXTAPPROVER.length > 15 ? `${val.NEXTAPPROVER.substring(0, 15)}...` : val.NEXTAPPROVER}</p>
                                            <p className="mb-3">
                                                <span className="font-regular font-10 color-grey mr-1">
                                                    Budgetary Limit:
        </span>
                                                <span className="font-14 font-bold text-black">-</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            : null}
                        {this.state.Alternates.length > 1 && val.ISA_IOL_APR_EMP_ID == this.state.OrderApprover && val.NEXTAPPROVERLIMIT == null ?
                            < div className="collapse multi-collapse w-100" id="multiCollapseExample1">
                                <div className="text-center">
                                    <h6 className="Font-14 font-medium text-black mb-3">Alternate Approver</h6>
                                </div>
                                <div className="card card-body border-0 pt-0 mb-4" style={{ 'padding-right': '40px' }}>
                                    <div className="row justify-content-center">
                                        {this.bindAlternates()}
                                    </div>
                                </div>
                            </div> : null
                        }

                    </>)
            });
        }

    }
    //PC_1044_160 WW-1044 Approval   [07/05/2024] Pavithra R - Notfiy alternate approver list bind -
    bindAlternates = () => {

        return this.state.Alternates.map((val, index) => {

            return (<>
                {
                    val.USERID != this.state.OLEmployee ?
                        <div className="col-md-4 col-lg-3 col-12 mb-3 custom-responsive attachment-remove-icon" onClick={() => this.RemainderPopup(val.USERID, val.ACTIVE_STATUS)}>
                            <div className="custom-alternate-approver-card-style">
                                <div className="d-flex align-items-center justify-content-start pl-3">
                                    <div className="d-block mr-2">
                                        <img className="" src="images/user-icon.svg" alt="user-icon" />
                                    </div>
                                    <div className="d-block text-left" style={{ 'width': '100%' }}>
                                        <p className="font-medium font-12 mb-0 mt-3 text-black" data-toggle="tooltip" title={val.USERNAME} data-label="AlternatesName">{val.USERNAME.length > 15 ? `${val.USERNAME.substring(0, 15)}...` : val.USERNAME}</p>
                                        <p className="mb-3" style={{ 'white-space': 'nowrap' }}>
                                            <span className="font-regular font-10 color-grey mr-1">
                                                Budgetary Limit:
                                                        </span>
                                            <span className="font-13 font-bold text-black">{val.USERLIMIT != null ? `$${val.USERLIMIT}` : "-"}</span>
                                        </p>
                                    </div>
                                    <div className="d-block pr-2 pt-1 custom-height">
                                        <a className="">
                                            <img src="images/notification.svg" alt="notification" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div> : null
                }</>
            )
        })
    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R- Notfiy approver confirmation popup display -
    RemainderPopup = (Approver, activeStatus) => {
        if (activeStatus && activeStatus != "A") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Approver is currently inactive"
            })
        }
        else {
            $('.approver-chain-details').modal('hide');
            $('.remaind-alternate-approver').modal('show');
            this.setState({ RemainderApprover: Approver });
        }
    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
    sendRemiander = () => {
        let RemainderBO = {
            Approver: this.state.RemainderApprover,
            OrderNo: this.state.RemainderOrder,
            OLEmployee: this.state.ApproverListUser,
            LineItems: this.state.RemainderLineItems,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_IOLServer: CookieService.getLocalStorageValues("Session_IOLServer"),
            Session_cplusServer: CookieService.getLocalStorageValues("Session_cplusServer"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            SESSION_SITE_CURRENCY: ""
        }
        if (!$('#OrderApprover').hasClass('collapsed') && $('#multiCollapseExample1').hasClass('show')) {
            $("#OrderApprover").addClass("collapsed");
            $('#multiCollapseExample1').removeClass('show');
        }
        $('.remaind-alternate-approver').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.RemainderOrderAction(RemainderBO);
    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R- Notfiy approver Remainder response -
    RemainderResponse = () => {
        let RemainderResponse = JSON.parse(OrderStatusStore.RemainderData);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (RemainderResponse.ErrorTable[0].error == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue try again"
            })
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Approver notified successfully"
            }).then(function () {
                $('.approver-chain-details').modal('show');
            });

        }

    }



    //Order Status Stored Procedure Integration Change - Deepthi
    GetHeaderDetailes = (IsApplyFilter, Srchtxt, ToggleCheck, IsToggle) => {
        debugger
        let FDate = "";
        let TDate = "";
        let SelectedReport;
        //WW-1233 Order Status Search issue Pavitha R [10/10/2024]
        if (Srchtxt == "") {
            SelectedReport = this.state.ReportDateField;
        } else {
            SelectedReport = "";
        }
        this.setState({ BuyAgainArray: [], OrderQuoteArray: [] });
        if (IsApplyFilter) {
            if (this.state.searchColumn == "LINE_STATUS") {
                if (this.state.OrderStatusSearch != "") {
                    Srchtxt = this.state.OrderStatusSearch;
                    IsApplyFilter = true;
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'Please Select Any Status'
                    });
                    // alert('Please Select Any Status');
                    return;
                }

            }
            else if (this.state.searchColumn == "ORDER_TYPE") {
                if (this.state.OrderStatusSearch != "") {
                    Srchtxt = this.state.OrderStatusSearch;
                    IsApplyFilter = true;
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'Please Select Any Type'
                    });
                    // alert('Please Select Any Type');
                    return;
                }

            }
            else if (this.state.searchColumn == "All") {
                let stxt = $(`#searchTxt`).val();
                if (stxt != "") {
                    Srchtxt = stxt;
                    IsApplyFilter = false;
                }

            }
        }

        if (IsToggle == "Yes") {
            let months;
            months = (new Date(this.state.SearchTrToDate).getDate() - new Date(this.state.SearchTrFromDate).getDate()) / 30 +
                new Date(this.state.SearchTrToDate).getMonth() - new Date(this.state.SearchTrFromDate).getMonth() +
                (12 * (new Date(this.state.SearchTrToDate).getFullYear() - new Date(this.state.SearchTrFromDate).getFullYear()));

            if (this.state.SearchTrFromDate && this.state.SearchTrToDate) {
                if (this.state.SearchTrFromDate > this.state.SearchTrToDate) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "start date should not be greater then end date"
                    });
                    //alert("start date should not be greater then end date");

                    return;
                }
                else if (months > 3) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item added to cart successfully"
                    });
                    //alert( "Item added to cart successfully");
                    return;

                }

                else {
                    FDate = this.state.SearchTrFromDate ? this.handledate(this.state.SearchTrFromDate) : "";
                    TDate = this.state.SearchTrToDate ? this.handledate(this.state.SearchTrToDate) : "";
                }
            }
            IsApplyFilter = false;
        };
        debugger;
        if (IsApplyFilter) {
            if (this.state.searchColumn == "LINE_STATUS" || this.state.searchColumn == "ORDER_TYPE") {
                let months;
                months = (new Date(this.state.SearchTrToDate).getDate() - new Date(this.state.SearchTrFromDate).getDate()) / 30 +
                    new Date(this.state.SearchTrToDate).getMonth() - new Date(this.state.SearchTrFromDate).getMonth() +
                    (12 * (new Date(this.state.SearchTrToDate).getFullYear() - new Date(this.state.SearchTrFromDate).getFullYear()));

                if (this.state.SearchTrFromDate && this.state.SearchTrToDate) {
                    if (this.state.SearchTrFromDate > this.state.SearchTrToDate) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "start date should not be greater then end date"
                        });
                        // alert("start date should not be greater then end date");

                        return;
                    }
                    else if (months > 3) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Date range should be within 3 months"
                        });
                        //  alert("Date range should be within 3 months");
                        return;

                    }

                    else {
                        FDate = this.state.SearchTrFromDate ? this.handledate(this.state.SearchTrFromDate) : "";
                        TDate = this.state.SearchTrToDate ? this.handledate(this.state.SearchTrToDate) : "";
                    }
                }
            }
            else {

                if (this.state.ReportDateField == "X") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Select any report(by order date)"
                    });
                    // alert("Select any report(by order date)");
                    return;
                }
                else if (this.state.ReportDateField == "99") {
                    if ((this.state.SearchTrFromDate == "" && this.state.SearchTrToDate == "") || (this.state.SearchTrFromDate == null && this.state.SearchTrToDate == null)) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Select A Date Range"
                        });
                        // alert("Select A Date Range");
                        return;
                    }
                    else if (this.state.SearchTrFromDate == "" || this.state.SearchTrFromDate == null) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Please Select From Date"
                        });
                        //alert("Please Select From Date");
                        return;
                    }
                    else if (this.state.SearchTrToDate == "" || this.state.SearchTrToDate == null) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Please Select To Date"
                        });
                        //  alert("Please Select To Date");
                        return;
                    }
                    else {

                        let months;
                        months = (new Date(this.state.SearchTrToDate).getDate() - new Date(this.state.SearchTrFromDate).getDate()) / 30 +
                            new Date(this.state.SearchTrToDate).getMonth() - new Date(this.state.SearchTrFromDate).getMonth() +
                            (12 * (new Date(this.state.SearchTrToDate).getFullYear() - new Date(this.state.SearchTrFromDate).getFullYear()));

                        if (this.state.SearchTrFromDate && this.state.SearchTrToDate) {
                            if (this.state.SearchTrFromDate > this.state.SearchTrToDate) {
                                swal({
                                    allowOutsideClick: false,
                                    closeOnClickOutside: false,
                                    text: "start date should not be greater then end date"
                                });
                                //  alert("start date should not be greater then end date");

                                return;
                            }
                            else if (months > 3) {
                                swal({
                                    allowOutsideClick: false,
                                    closeOnClickOutside: false,
                                    text: "Date range should be within 3 months"
                                });

                                // alert("Date range should be within 3 months");
                                return;

                            }

                            else {
                                FDate = this.state.SearchTrFromDate ? this.handledate(this.state.SearchTrFromDate) : "";
                                TDate = this.state.SearchTrToDate ? this.handledate(this.state.SearchTrToDate) : "";
                            }
                        }

                    }

                }
                //if (this.state.OrderTypeField == "Group") {
                //    if (this.state.EmpListPush.length == 0) {
                //        alert('Please Select Any Employee Name');
                //        return;
                //    }

                //}
            }
        }

        if (this.state.OrderTypeField == "Group") {
            if (this.state.EmpListPush.length == 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please Select Any Employee Name'
                });
                //  alert('Please Select Any Employee Name');
                return;
            }

        }
        let Emplist = []
        if (this.state.EmpListPush.length > 0) {
            this.state.EmpListPush.map((val, index) => {
                Emplist.push({ EmpId: val.value })
            });
        }
        this.setState({ LineDetailsGrid: [], HeaderGridArray: [], PageNo: 1 });
        if (this.state.searchColumn == "All") {
            Srchtxt = Srchtxt.toUpperCase();
        }
        let Div = this.state.Division;
        let Reg = this.state.Region;
        let SubReg = this.state.SubRegion;
        //WW-487 Order status and type search option is not immediately clear when looking at the 'check order status' page - Deepthi
        let OrdStat = this.state.MainOrderStatus;
        let OrdCat = this.state.OrderCategory;
        if (this.state.OrderTypeField != "All") {
            Div = "";
            Reg = "";
            SubReg = "";
        }

        let HeaderBO;
        HeaderBO = {
            FromDate: FDate,
            ToDate: TDate,
            SelectedReport: this.state.ReportDateField,
            OrderType: this.state.OrderTypeField,
            sGroupList: Emplist,
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            Division: Div == " " ? "" : Div,
            Region: Reg == " " ? "" : Reg,
            SubRegion: SubReg == " " ? "" : SubReg,
            OrdStatus: OrdStat == " " ? "" : OrdStat,
            OrdCat: OrdCat == " " ? "" : OrdCat,
            SearchType: this.state.searchColumn,
            SearchContent: Srchtxt.trim(),
            IsInventory: ToggleCheck ? 'True' : 'False',
            Bus_Unit: 'I0W01'
        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.HeaderData(HeaderBO);


    }
    PODetail = () => {
        //;
        let PageLoadResponse = JSON.parse(OrderStatusStore.PODetailData);
        this.setState({
            DetailTable: PageLoadResponse.DetailTable, VenderDetail: PageLoadResponse.VenderDetail, POData: PageLoadResponse.POData, packingSlip: PageLoadResponse.packingSlip,
            POTracking_no: PageLoadResponse.tracking_no //WW-819_PC_03 -Aparna
        });

        $('po-details').modal('show');
        $('.tryH').removeClass('accordion-arrow-change');
        $('.try').addClass('d-none');
        $('.tryH').addClass('accordion-arrow-change');
        $('.try').removeClass('d-none');
        //this.setState({ PODetailPopup: true });
        console.log("potable", PageLoadResponse.POData);
        console.log("vendortbl", PageLoadResponse.VenderDetail);
    }
    //****************Apply Filter button click*********************************
    validate = () => {
        let alertdate = "";

        if (this.state.SearchTrFromDate && this.state.SearchTrToDate) {
            if (this.state.SearchTrFromDate > this.state.SearchTrToDate) {
                alertdate = "start date should not be greater then end date";
                this.setState({ alert: alertdate });
                return false;
            }
            else {
                return true;
            }
        }
        return true;
    }
    date = () => {
        let sFD = new Date();
        let sTD = new Date();

        if (this.state.SearchTrFromDate == "" && this.state.SearchTrToDate == "") {
            let today = new Date();
            let before = new Date();
            console.log("today", today);
            //from = (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();
            sTD = ((today.getMonth() > 8) ? (today.getMonth() + 1) : ('0' + (today.getMonth() + 1))) + '/' + ((today.getDate() > 9) ? today.getDate() : ('0' + today.getDate())) + '/' + today.getFullYear()
            //before=this.handledate(from);
            before.setMonth(today.getMonth() - 6);
            sFD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            //;

        }
        else if (this.state.SearchTrFromDate == "" && this.state.SearchTrToDate != "") {
            let TrT = new Date(this.state.SearchTrToDate);
            let before = new Date();

            //;
            before.setMonth(TrT.getMonth() - 3);
            sFD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            sTD = ((TrT.getMonth() > 8) ? (TrT.getMonth() + 1) : ('0' + (TrT.getMonth() + 1))) + '/' + ((TrT.getDate() > 9) ? TrT.getDate() : ('0' + TrT.getDate())) + '/' + TrT.getFullYear()

            //;
        }
        else if (this.state.SearchTrFromDate && !this.state.SearchTrToDate) {

            let TrF = new Date(this.state.SearchTrFromDate);
            let before = new Date();
            //TrF = this.state.SearchTrFromDate;
            //;
            before.setMonth(TrF.getMonth() + 3);
            sTD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            //;
            sFD = ((TrF.getMonth() > 8) ? (TrF.getMonth() + 1) : ('0' + (TrF.getMonth() + 1))) + '/' + ((TrF.getDate() > 9) ? TrF.getDate() : ('0' + TrF.getDate())) + '/' + TrF.getFullYear()
        }
        else {
            let TrF = new Date(this.state.SearchTrFromDate);
            let TrT = new Date(this.state.SearchTrToDate);
            let before = new Date();
            let check = new Date();
            let checkT = new Date();
            //TrF = this.state.SearchTrFromDate;
            //;
            before.setMonth(TrF.getMonth() + 3);
            checkT = ((TrT.getMonth() > 8) ? (TrT.getMonth() + 1) : ('0' + (TrT.getMonth() + 1))) + '/' + ((TrT.getDate() > 9) ? TrT.getDate() : ('0' + TrT.getDate())) + '/' + TrT.getFullYear()

            check = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            //;
            if (checkT <= check) {
                sFD = this.state.SearchTrFromDate;
                sTD = this.state.SearchTrToDate;
            }
            //sFD = ((TrF.getMonth() > 8) ? (TrF.getMonth() + 1) : ('0' + (TrF.getMonth() + 1))) + '/' + ((TrF.getDate() > 9) ? TrF.getDate() : ('0' + TrF.getDate())) + '/' + TrF.getFullYear()
            else {
                this.setState({ SearchTrFromDate: "", SearchTrToDate: "", alert: "" });
            }
            //;
            //this.setState({ SearchTrFromDate: "", SearchTrToDate: "", alert: "" });
        }
        return [sFD, sTD];
    }
    abovemonth = () => {
        let sFD = new Date();
        let sTD = new Date();
        let alertsearchdate = "";
        let monthRag = 3;
        ////;
        /*if (this.state.SearchOption == "ExactValue") */
        if (radio == "ExactValue" || radio == "dateRange") {
            monthRag = 3;
        }
        else if (radio == "6month") {
            monthRag = 6
        }
        if (this.state.SearchTrFromDate == "" && this.state.SearchTrToDate != "") {
            let TrT = new Date(this.state.SearchTrToDate);
            let before = new Date();

            ////;
            before.setMonth(TrT.getMonth() - monthRag);
            sFD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            sTD = ((TrT.getMonth() > 8) ? (TrT.getMonth() + 1) : ('0' + (TrT.getMonth() + 1))) + '/' + ((TrT.getDate() > 9) ? TrT.getDate() : ('0' + TrT.getDate())) + '/' + TrT.getFullYear()

            //;
        }
        else if (this.state.SearchTrFromDate && !this.state.SearchTrToDate) {

            let TrF = new Date(this.state.SearchTrFromDate);
            let before = new Date();
            //TrF = this.state.SearchTrFromDate;
            //;
            before.setMonth(TrF.getMonth() + monthRag);
            sTD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            //;
            sFD = ((TrF.getMonth() > 8) ? (TrF.getMonth() + 1) : ('0' + (TrF.getMonth() + 1))) + '/' + ((TrF.getDate() > 9) ? TrF.getDate() : ('0' + TrF.getDate())) + '/' + TrF.getFullYear()
        }
        else if (!this.state.SearchTrFromDate && !this.state.SearchTrToDate) {
            let today = new Date();
            let before = new Date();
            console.log("today", today);
            //from = (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();
            sTD = ((today.getMonth() > 8) ? (today.getMonth() + 1) : ('0' + (today.getMonth() + 1))) + '/' + ((today.getDate() > 9) ? today.getDate() : ('0' + today.getDate())) + '/' + today.getFullYear()
            //before=this.handledate(from);
            before.setMonth(today.getMonth() - monthRag);
            sFD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            //;

        }

        else {
            if (!radiochange) {
                let TrF = new Date(this.state.SearchTrFromDate);
                let TrT = new Date(this.state.SearchTrToDate);
                //let TrF = this.handledate(this.state.SearchTrFromDate);
                //let TrT =  this.handledate(this.state.SearchTrToDate) ;
                let before = new Date();
                let check = new Date();
                let checkT = new Date();
                let checkF = new Date();
                let today = new Date();
                let to = new Date();
                //TrF = this.state.SearchTrFromDate;
                // //;
                console.log("TrF", TrF);
                console.log("TrT", TrT);
                before.setMonth(TrF.getMonth() + monthRag);
                to = ((today.getMonth() > 8) ? (today.getMonth() + 1) : ('0' + (today.getMonth() + 1))) + '/' + ((today.getDate() > 9) ? today.getDate() : ('0' + today.getDate())) + '/' + today.getFullYear()

                checkT = ((TrT.getMonth() > 8) ? (TrT.getMonth() + 1) : ('0' + (TrT.getMonth() + 1))) + '/' + ((TrT.getDate() > 9) ? TrT.getDate() : ('0' + TrT.getDate())) + '/' + TrT.getFullYear()
                checkF = ((TrF.getMonth() > 8) ? (TrF.getMonth() + 1) : ('0' + (TrF.getMonth() + 1))) + '/' + ((TrF.getDate() > 9) ? TrF.getDate() : ('0' + TrF.getDate())) + '/' + TrF.getFullYear()

                check = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
                ////;
                let months;
                months = (new Date(this.state.SearchTrToDate).getDate() - new Date(this.state.SearchTrFromDate).getDate()) / 30 +
                    new Date(this.state.SearchTrToDate).getMonth() - new Date(this.state.SearchTrFromDate).getMonth() +
                    (12 * (new Date(this.state.SearchTrToDate).getFullYear() - new Date(this.state.SearchTrFromDate).getFullYear()));

                //let diff = (TrT.getTime() - TrF.getTime()) / 1000;
                //    diff /= (60 * 60 * 24 * 7 * 4);
                //    //return Math.abs(Math.round(diff));
                //console.log("diff", Math.round(diff));
                if (months <= 3) {
                    sFD = this.handledate(this.state.SearchTrFromDate);
                    sTD = this.handledate(this.state.SearchTrToDate);
                }
                //if (checkT <= check) {
                //    if (checkT <= sTD) {
                //        sFD = this.handledate(this.state.SearchTrFromDate);
                //        sTD = this.handledate(this.state.SearchTrToDate);
                //    }
                //    else {
                //        sFD = this.handledate(this.state.SearchTrFromDate);
                //        sTD = to
                //    }
                //}

                else {
                    sFD = ""; sTD = ""; alertsearchdate = "date should be within 3 month";
                    this.setState({ SearchTrFromDate: "", SearchTrToDate: "", alert: "date should be within 3 month" });

                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Date range should be within 3 months"
                    });
                    // alert("Date range should be within 3 months");
                    //return false;
                }
            }
            else {
                let today = new Date();
                let before = new Date();
                console.log("today", today);
                //from = (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();
                sTD = ((today.getMonth() > 8) ? (today.getMonth() + 1) : ('0' + (today.getMonth() + 1))) + '/' + ((today.getDate() > 9) ? today.getDate() : ('0' + today.getDate())) + '/' + today.getFullYear()
                //before=this.handledate(from);
                before.setMonth(today.getMonth() - monthRag);
                sFD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
                //;
                this.setState({ SearchTrFromDate: sFD, SearchTrToDate: sTD, alert: "" });
            }
            //sFD = ((TrF.getMonth() > 8) ? (TrF.getMonth() + 1) : ('0' + (TrF.getMonth() + 1))) + '/' + ((TrF.getDate() > 9) ? TrF.getDate() : ('0' + TrF.getDate())) + '/' + TrF.getFullYear()

            //;
            //this.setState({ SearchTrFromDate: "", SearchTrToDate: "", alert: "" });
        }
        return [sFD, sTD, alertsearchdate];
    }
    exactvalue = () => {
        let sFD = new Date();
        let sTD = new Date();

        if (this.state.SearchTrFromDate == "" && this.state.SearchTrToDate == "") {
            let today = new Date();
            let before = new Date();
            console.log("today", today);
            //from = (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();
            sTD = ((today.getMonth() > 8) ? (today.getMonth() + 1) : ('0' + (today.getMonth() + 1))) + '/' + ((today.getDate() > 9) ? today.getDate() : ('0' + today.getDate())) + '/' + today.getFullYear()
            //before=this.handledate(from);
            before.setMonth(today.getMonth() - 6);
            sFD = ((before.getMonth() > 8) ? (before.getMonth() + 1) : ('0' + (before.getMonth() + 1))) + '/' + ((before.getDate() > 9) ? before.getDate() : ('0' + before.getDate())) + '/' + before.getFullYear()
            //;

        }
        return [sFD, sTD];
    }


    ApplyFilter = (pg, RecCount, searchColumn, searchTxt, sTrBy, sTrCriteria, sortColumn, sortType, FilterPopupBoolean, IsToggleChecked) => {
        let isvalid = this.validate();
        if (isvalid) {
            //debugger
            let BusUnits = "";
            let OFD = "";
            let OTD = "";
            let NFD = "";
            let NTD = "";
            let sFD = "";
            let sTD = "";
            let from = new Date();
            let to = new Date();
            let TotalBu = [];
            let ReportTypeField = "";
            let srTxt = searchTxt;
            let srCol = searchColumn;
            TotalBu = this.state.CompanyBU;
            let alertLocal = "";
            //;
            if (srTxt == "") {
                srCol = "";
            }
            //let lblTest = "";
            //let lblVersion = "";

            //lblTest = environmentDataResponse.lblTest;
            //lblVersion = environmentDataResponse.lblVersion;
            ////;

            console.log("srTxt", srTxt);
            if (TotalBu != "") {
                // //;
                if (this.state.ReportTypeField == "Site") {
                    if (this.state.BusUnitField == " ") {
                        BusUnits = CookieService.getLocalStorageValues("Session_BUSUNIT");
                        console.log("BusUnits", BusUnits);
                        ReportTypeField = "Site";
                    }
                    else {
                        BusUnits = this.state.BusUnitField;
                        ReportTypeField = this.state.ReportTypeField;
                    }

                }
                else if (this.state.ReportTypeField == "Company") {
                    BusUnits = this.state.CompanyBU;
                    ReportTypeField = this.state.ReportTypeField;
                }
                else {
                    ReportTypeField = "Site";
                    BusUnits = CookieService.getLocalStorageValues("Session_BUSUNIT");
                }

            }
            else {
                //if (this.state.ReportTypeField == "Site") {
                //    BusUnits = CookieService.getLocalStorageValues("Session_BUSUNIT");
                //}
                //if (this.state.ReportTypeField == "Company") {

                //    BusUnits = "'" + CookieService.getLocalStorageValues("Session_BUSUNIT") + "'";
                //}
                ReportTypeField = "Site";
                BusUnits = CookieService.getLocalStorageValues("Session_BUSUNIT");
                console.log("BusUnits", BusUnits);
            }
            console.log("BusUnits", BusUnits);
            ////;
            if (FilterPopupBoolean) {
                if (this.state.OrderDateBoolean) {
                    //OFD = this.state.OFromDate;
                    //OTD = this.state.OToDate;
                    OFD = this.state.OFromDate ? this.handledate(this.state.OFromDate) : "";
                    OTD = this.state.OToDate ? this.handledate(this.state.OToDate) : "";
                    //document.getElementById("searchTxt").innerText = "";
                    //$('#searchTxt').val('');
                    //srTxt = "";
                    //srCol = "";
                }
                if (this.state.NeedByDateBoolean) {
                    //NFD = this.state.NFromDate;
                    //NTD = this.state.NToDate;
                    NFD = this.state.NFromDate ? this.handledate(this.state.NFromDate) : "";
                    NTD = this.state.NToDate ? this.handledate(this.state.NToDate) : "";
                    //document.getElementById("searchTxt").innerText = "";
                    //$('#searchTxt').val('');
                    //srTxt = "";
                    //srCol = "";
                }
            }
            //;
            console.log("f", this.state.SearchTrFromDate);
            console.log("t", this.state.SearchTrToDate);
            console.log("SearchOption", this.state.SearchOption);
            ////;
            if (this.state.ReportDateField == "99") {
                if (this.state.SearchTrFromDate && this.state.SearchTrToDate) {
                    if (searchTrBy == "PriorityOrders" || searchTrBy == "OrderStatus" || this.state.DR) {
                        //let diff = (this.state.SearchTrToDate.getTime() - this.state.SearchTrFromDate.getTime()) / 1000;
                        //diff /= (60 * 60 * 24 * 7 * 4);
                        ////return Math.abs(Math.round(diff));
                        //console.log("diff", Math.abs(Math.round(diff)));
                        let months;
                        months = (new Date(this.state.SearchTrToDate).getDate() - new Date(this.state.SearchTrFromDate).getDate()) / 30 +
                            new Date(this.state.SearchTrToDate).getMonth() - new Date(this.state.SearchTrFromDate).getMonth() +
                            (12 * (new Date(this.state.SearchTrToDate).getFullYear() - new Date(this.state.SearchTrFromDate).getFullYear()));

                        if (months <= 3) {
                            sFD = this.state.SearchTrFromDate ? this.handledate(this.state.SearchTrFromDate) : "";
                            sTD = this.state.SearchTrToDate ? this.handledate(this.state.SearchTrToDate) : "";
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Date range should be within 3 months"
                            });
                            // alert("Date range should be within 3 months");
                            return;
                        }
                    }
                    else if (searchTrCriteria == "") {
                        let months;
                        months = (new Date(this.state.SearchTrToDate).getDate() - new Date(this.state.SearchTrFromDate).getDate()) / 30 +
                            new Date(this.state.SearchTrToDate).getMonth() - new Date(this.state.SearchTrFromDate).getMonth() +
                            (12 * (new Date(this.state.SearchTrToDate).getFullYear() - new Date(this.state.SearchTrFromDate).getFullYear()));


                        console.log("month", months);
                        if (months <= 3) {
                            sFD = this.state.SearchTrFromDate ? this.handledate(this.state.SearchTrFromDate) : "";
                            sTD = this.state.SearchTrToDate ? this.handledate(this.state.SearchTrToDate) : "";
                        }

                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Date range should be within 3 months"
                            });
                            // alert("Date range should be within 3 months");
                            return;
                        }
                    }
                    else if (searchTrCriteria != "") {
                        //if ((radio == "6month" || radio == "ExactValue"))
                        let EXV;
                        let MNT;
                        let DTR;
                        if ((this.state.MN || this.state.EV)) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Select date range or search by criteria"
                            });
                            //alert("Select date range or search by criteria");
                            searchTrCriteria = "";
                            if (searchTrBy == "OrderStatus") {
                                $("#status-dropdown").val('select');
                            }
                            else if (searchTrBy == "PriorityOrders") {
                                $("#SearchTrTxt").val('Priority');
                                searchTrCriteria = "Priority";
                            }
                            else {
                                $('#SearchTrTxt').val('');
                                radio = "ExactValue"

                                $('#SearchTrTxt').val('');
                                $("#status-dropdown").hide();
                                $("#SearchTrTxt").show();
                                searchTrCriteria = "";
                                radio = "ExactValue"
                                this.setState({});
                                EXV = true;
                                MNT = false;
                                DTR = false;
                                //document.getElementById("exval").checked = true;                        
                                $("#6month").attr('disabled', false);
                                $("#dateRag").attr('disabled', false);
                                $("#exval").attr('disabled', false);
                                //this.setState({ SearchTrFromDate: "", SearchTrToDate: "" });
                            }

                            this.setState({ SearchTrFromDate: "", SearchTrToDate: "", EV: EXV, MN: MNT, DR: DTR });
                            radiochange = false;

                            return;
                        }
                    }
                }
                else if (this.state.SearchTrFromDate || this.state.SearchTrToDate) {
                    let EXV;
                    let MNT;
                    let DTR;
                    if (searchTrCriteria != "" || (this.state.MN || this.state.EV)) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Select date range or search by criteria"
                        });

                        //  alert("Select date range or search by criteria");
                        searchTrCriteria = "";
                        if (searchTrBy == "OrderStatus") {
                            $("#status-dropdown").val('select');
                        }
                        else if (searchTrBy == "PriorityOrders") {
                            $("#SearchTrTxt").val('Priority');
                            searchTrCriteria = "Priority";
                        }
                        else {
                            $('#SearchTrTxt').val('');
                            radio = "ExactValue"

                            $('#SearchTrTxt').val('');
                            $("#status-dropdown").hide();
                            $("#SearchTrTxt").show();
                            searchTrCriteria = "";
                            radio = "ExactValue"
                            this.setState({});
                            EXV = true;
                            MNT = false;
                            DTR = false;
                            //document.getElementById("exval").checked = true;                        
                            $("#6month").attr('disabled', false);
                            $("#dateRag").attr('disabled', false);
                            $("#exval").attr('disabled', false);
                        }

                        this.setState({ SearchTrFromDate: "", SearchTrToDate: "", EV: EXV, MN: MNT, DR: DTR });
                        radiochange = false;

                        return;
                    }
                }
                else {
                    let val = this.abovemonth();

                    sFD = val[0];
                    sTD = val[1];
                    alertLocal = val[2];
                    console.log("sFD", sFD);
                    console.log("sTD", sTD);

                    if (alertLocal != "") {
                        return;
                    }
                }
                //if (searchTrBy != "" && searchTrCriteria != "") {
                //    if (this.state.SearchOption == "ExactValue" || this.state.SearchOption == "6month") {
                //        if (this.state.SearchTrFromDate == "" || this.state.SearchTrToDate == "") {
                //            let val = this.abovemonth();
                //            sFD = val[0];
                //            sTD = val[1];
                //            console.log("sFD", sFD);
                //            console.log("sTD", sTD);
                //        }

                //        let val = this.abovemonth();
                //        sFD = val[0];
                //        sTD = val[1];
                //    }
                //    else {
                //        let val = this.abovemonth();
                //        sFD = val[0];
                //        sTD = val[1];
                //    }

                //}
                //else {
                //    let val = this.abovemonth();
                //    sFD = val[0];
                //    sTD = val[1];
                //}
            }

            console.log("list", this.state.EmpListPush);
            let Emplist = []
            if (this.state.EmpListPush.length > 0) {
                this.state.EmpListPush.map((val, index) => {
                    Emplist.push({ EmpId: val.value })
                });
            }
            console.log("emplist", Emplist);
            let ordtyp = this.state.OrderTypeField

            //WW-308_PS_01 My Orders filter does not filter correctly(1/5/2021) -Aparna(this condition return ordtype to all even "My order" is selected )
            //if (reg != " " || subreg != " " || div != " ") {
            //    ordtyp = "All"
            //}
            //if (srTxt != "") {
            //    if (srTxt.length > 0) {
            //        ordtyp = "All"
            //    }
            //}

            //A1QA-153_PC_01 division,region and subregion will be checked in the query
            let reg = ""
            let subreg = ""
            let div = ""
            if (ordtyp == "All") {
                reg = this.state.Region;
                subreg = this.state.SubRegion;
                div = this.state.Division;
            }


            //;
            let OrderStatusDataBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),

                //eRptTimePeriod: "99", //report type set to site as 
                eRptSite: "Site", //ReportTypeField,
                sApprovalReport: "",
                eSearchOption: this.state.SearchOption,
                eSearchBy: srCol,
                strLocations: "",
                sApprovalsBU: "I0W01",//BusUnits,
                sBusUnits: "I0W01",// BusUnits,
                bShopCartSPC1: false,
                sSearchCriteria: srTxt,
                OrderStatus: this.state.OrderStatusSearch, /*[07/14/22, PC_WW-447_02-Sprint-23], Priyanka D */
                eRptTimePeriod: this.state.ReportDateField,
                sFromDate: sFD, searchTrBy: searchTrBy, searchTrCriteria: searchTrCriteria,
                sToDate: sTD,
                eOrdersToInclude: ordtyp, // this.state.OrderTypeField,
                sSortField: sortColumn,
                sortType: sortType,
                sApprovalReport: "",
                sGroupList: Emplist,
                CurrentPage: pg,
                NeededRecCount: 1000,
                FilterSearch: FilterPopupBoolean, FilterOrdDate: this.state.OrderDateBoolean,
                OFromDate: OFD, OToDate: OTD, FilterNeedDate: this.state.NeedByDateBoolean, NFromDate: NFD, NToDate: NTD,
                bUnlimitedSearch: false, sQueryUnlimitedResults: "",
                Division: this.state.Division,
                Region: this.state.Region,
                SubRegion: this.state.SubRegion,
                Manager: this.state.Manager,
                IsInvChecked: IsToggleChecked,
                IsWeb: true,//WW-380 -Aparna
            }

            console.log("searchTrCriteria", searchTrCriteria);
            //;
            if (pg > 0) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                $('.header-arrow').addClass('accordion-arrow-change');
                $('.content-row').removeClass('d-none');
                $('.header-arrow').removeClass('accordion-arrow-change');
                $('.content-row').addClass('d-none');
                OrderStatusAction.RetriveData(OrderStatusDataBO);
            }
            else {
                let srchtxt = $(`#searchTxt`).val();
                let OrderStatusDataBO = {
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
                    Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    eRptSite: "Site",
                    sApprovalReport: "",
                    eSearchOption: this.state.SearchOption,
                    eSearchBy: srCol,
                    strLocations: "",
                    sApprovalsBU: "I0W01",
                    sBusUnits: "I0W01",
                    bShopCartSPC1: false,
                    sSearchCriteria: srTxt,
                    OrderStatus: this.state.OrderStatusSearch,
                    eRptTimePeriod: this.state.ReportDateField,
                    sFromDate: sFD, searchTrBy: "All", searchTrCriteria: srchtxt,
                    sToDate: sTD,
                    eOrdersToInclude: ordtyp,
                    sSortField: sortColumn,
                    sortType: sortType,
                    sApprovalReport: "",
                    sGroupList: Emplist,
                    CurrentPage: pg,
                    NeededRecCount: 1000,
                    FilterSearch: FilterPopupBoolean, FilterOrdDate: this.state.OrderDateBoolean, OFromDate: OFD, OToDate: OTD,
                    FilterNeedDate: this.state.NeedByDateBoolean, NFromDate: NFD, NToDate: NTD,
                    bUnlimitedSearch: false, sQueryUnlimitedResults: "",
                    Division: this.state.Division,
                    Region: this.state.Region,
                    SubRegion: this.state.SubRegion,
                    Manager: this.state.Manager,
                    IsInvChecked: IsToggleChecked,
                    filterCategory: this.state.OrderCategory,
                    filterStatus: this.state.MainOrderStatus,
                    IsWeb: true
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                OrderStatusAction.ExportData(OrderStatusDataBO);
            }
        }
    }
    /***NEW******wal-158*****/
    notificationorderno = (orderno) => {
        //let OrderStatusDataBO = {
        //    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
        //    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        //    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
        //    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
        //    Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),


        //    //eRptTimePeriod: "99", 
        //    eRptSite: "Company",
        //    sApprovalReport: "",
        //    eSearchOption: "ExactValue",
        //    eSearchBy: "",
        //    strLocations: "",
        //    sApprovalsBU: "'I0W01'",
        //    sBusUnits: "'I0W01'",
        //    bShopCartSPC1: false,
        //    sSearchCriteria: "",
        //    eRptTimePeriod: "99",
        //    sFromDate: "", searchTrBy: "OrderNo", searchTrCriteria: orderno,
        //    sToDate: "",
        //    eOrdersToInclude: "All",
        //    sSortField: "ORD_DATE_FILTER",
        //    sortType: "DESC",
        //    sApprovalReport: "",
        //    sGroupList: "",
        //    CurrentPage: 1,
        //    NeededRecCount: 10,
        //    FilterSearch: false, FilterOrdDate: false, OFromDate: "", OToDate: "", FilterNeedDate: false, NFromDate: "", NToDate: "",
        //    bUnlimitedSearch: false, sQueryUnlimitedResults: ""
        //}
        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //$('.header-arrow').addClass('accordion-arrow-change');
        //$('.content-row').removeClass('d-none');
        //$('.header-arrow').removeClass('accordion-arrow-change');
        //$('.content-row').addClass('d-none');
        //OrderStatusAction.RetriveData(OrderStatusDataBO);
        this.GetHeaderDetailes(false, orderno, this.state.toggleChecked, "No")
    }
    /********END***********/
    ExportToExcel = () => {
        let sortColumn = "ORD_DATE_FILTER";
        let sortType = "ASC";
        let pageNo = 0;
        let srch = "";
        let NoSearchTxt = "";
        let NosearchTrTxt = "";
        let NosearchTrOption
        //NoSearchTxt=>searchTxt
        searchTxt = $(`#searchTxt`).val();
        srch = this.state.searchColumn;
        let searchCol = "";
        if (searchTxt == "" || searchTxt == null) {
            searchCol = this.state.searchColumn;
            console.log("searchCol", searchCol);
            //WW-366_PC_05
            // WW-399_PC_02 (5/9/ 2022) - Aparna
            if (searchCol != "LINE_PRIOR" && searchCol != "LINE_STATUS" && searchCol != "ORDER_TYPE") {
                searchTxt = $(`#searchTxt`).val();
            }
            else if (searchCol == "LINE_STATUS" || searchCol == "ORDER_TYPE") {
                searchTxt = this.state.OrderStatusSearch
            }
        }
        //if (searchTxt != "") {
        //    srch = "All"
        //}
        this.ApplyFilter(pageNo,
            this.state.RecCount,
            srch,
            searchTxt, NosearchTrTxt, NosearchTrOption,
            sortColumn,
            sortType, FilterPopupBoolean, this.state.toggleChecked
        );
        //;
    }
    searchTr = () => {
        if (this.state.ReportDateField == "99") {
            ////;
            if (searchTrCriteria == "select") {
                if (searchTrBy == "OrderStatus") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "select Order status"
                    });
                    //      alert("select Order status");
                    return false;
                }
            }

            if ((searchTrCriteria == "")) {

                if (searchTrBy == "OrderStatus") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "select Order status"
                    });
                    // alert("select Order status");
                    return false;
                }

                else if ((!this.state.SearchTrFromDate) && (!this.state.SearchTrToDate)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "select any criteria"
                    });
                    //   alert("select any criteria");
                    return false;
                }
                else if ((!this.state.SearchTrFromDate && this.state.SearchTrToDate)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "invalid from date"
                    });
                    // alert("invalid from date");
                    return false;
                }
                else if ((this.state.SearchTrFromDate && !this.state.SearchTrToDate)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "invalid to date"
                    });
                    //alert("invalid to date");
                    return false;
                }

                else {
                    if (radiochange) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "select any criteria"
                        });
                        //alert("select any criteria");
                        return false;
                    }
                    else {
                        return true;
                        //this.ApplyFilterbutton();
                    }

                }

            }

            else if ($('#dateRag').is(':checked')) {
                if (!this.state.SearchTrFromDate && !this.state.SearchTrToDate) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please select From and To Date"
                    });
                    //  alert("Please select From and To Date");
                    this.setState({ alert: "" });
                    return false;
                }
                else if ((!this.state.SearchTrFromDate) && (!this.state.SearchTrToDate)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "select any criteria"
                    });
                    //  alert("select any criteria");
                    return false;
                }
                else if ((!this.state.SearchTrFromDate && this.state.SearchTrToDate)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "invalid from date"
                    });
                    //alert("invalid from date");
                    return false;
                }
                else if ((this.state.SearchTrFromDate && !this.state.SearchTrToDate)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "invalid to date"
                    });
                    // alert("invalid to date");
                    return false;
                }
                else if (searchTrCriteria == "") {
                    //($('#SearchTrTxt').val() == "")
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please enter search criteria"
                    });
                    //alert("Please enter search criteria");
                    return false;
                }
                else {
                    return true;
                    //this.ApplyFilterbutton();
                }

            }
            //else if (searchTrBy == "OrderStatus") {
            //    if (searchTrCriteria == "0") {
            //        alert("please select Order Status");
            //    }
            //}

            else {
                return true;
                // this.ApplyFilterbutton();
            }
        }

        else {
            return true;
            //this.ApplyFilterbutton();
        }
    }
    //WW-399_PC_04 (5/12/2022)-Aparna
    ApplyfilterSearchCheck = () => {
        let searchCol = this.state.searchColumn;
        if (searchCol == "LINE_STATUS" || searchCol == "ORDER_TYPE") {
            if (this.state.OrderStatusSearch == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Select any value"
                });
                //alert("Select any value");
                return false;
            }
            else {
                this.ApplyFilerCheckforgroup()
            }
        }
        else {
            this.ApplyFilerCheckforgroup()
        }
    }
    ApplyFilerCheckforgroup = () => {
        //let criteria = $(`#SearchTrTxt`).val().trim();
        //*****NEW*****wal-158*****

        const queryParams = new URLSearchParams(window.location.search)
        let orderno_noti = queryParams.get('ordno');
        if (this.props.location.hasOwnProperty('state') && this.props.location.state != undefined && this.props.location.state.hasOwnProperty('origin')) {
            if (this.props.location.state.hasOwnProperty('ordno')) {
                orderno_noti = this.props.location.state.ordno;
            }
        }
        console.log("orderno_noti", orderno_noti)
        if (orderno_noti != "" && orderno_noti != null && orderno_noti != undefined) {
            this.props.history.push({
                pathname: `/OrderStatus2`,

            });
        }
        //************END**********
        console.log("criteria", searchTrCriteria);
        console.log("ApplyFilerCheckforgroup from", this.state.SearchTrFromDate);
        console.log("ApplyFilerCheckforgroup to", this.state.SearchTrToDate);
        console.log("eordertype", this.state.OrderTypeField);
        if (this.state.ReportDateField != "X") {
            if (this.state.OrderTypeField == "Group") {
                if (this.state.EmpListPush.length > 0) {
                    if (this.searchTr()) {
                        this.ApplyFilterbutton();
                    }

                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please select the employee ID"
                    });
                    //alert("Please select the employee ID");
                }
            }


            else if (this.state.ReportDateField == "99") {
                if (this.searchTr()) {
                    this.ApplyFilterbutton();
                }
            }
            else if (this.state.ReportDateField != "99") {

                this.ApplyFilterbutton();

            }

            // if (this.state.ReportDateField == "99") {
            //   //;
            //    if ((searchTrCriteria == "")) {

            //        if (searchTrBy == "OrderStatus") {
            //            alert("select Order status");
            //        }

            //        else if ((this.state.SearchTrFromDate == "") && (this.state.SearchTrToDate == "")) {
            //            alert("select any criteria");
            //        }
            //        else if ((this.state.SearchTrFromDate == "" && this.state.SearchTrToDate != "")) {
            //            alert("invalid from date");
            //        }
            //        else if ((this.state.SearchTrFromDate != "" && this.state.SearchTrToDate == "")) {
            //            alert("invalid to date");
            //        }

            //        else {
            //            if (radiochange) {
            //                alert("select any criteria");
            //            }
            //            else {
            //                this.ApplyFilterbutton();
            //            }

            //        }

            //    }

            //    else if ($('#dateRag').is(':checked')) {
            //        if (this.state.SearchTrFromDate == "" && this.state.SearchTrToDate == "") {
            //            alert("Please select From and To Date");
            //            this.setState({ alert: "" });
            //            return;
            //        }
            //        else if ((this.state.SearchTrFromDate == "") && (this.state.SearchTrToDate == "")) {
            //            alert("select any criteria");
            //            return;
            //        }
            //        else if ((this.state.SearchTrFromDate == "" && this.state.SearchTrToDate != "")) {
            //            alert("invalid from date");
            //            return;
            //        }
            //        else if ((this.state.SearchTrFromDate != "" && this.state.SearchTrToDate == "")) {
            //            alert("invalid to date");
            //            return;
            //        }
            //        else if (searchTrCriteria == "") {
            //            //($('#SearchTrTxt').val() == "")
            //            alert("Please enter search criteria");
            //        }
            //        else {
            //            this.ApplyFilterbutton();
            //        }

            //    }
            //    //else if (searchTrBy == "OrderStatus") {
            //    //    if (searchTrCriteria == "0") {
            //    //        alert("please select Order Status");
            //    //    }
            //    //}

            //    else {
            //        this.ApplyFilterbutton();
            //    }
            //}

            //else {
            //    this.ApplyFilterbutton();
            //}
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select any Report (by order date)"
            });
            // alert("Select any Report (by order date)");
        }
    }


    ApplyFilterbutton = () => {
        let sortColumn = "ORD_DATE_FILTER";//"ORDER_NO";
        let sortType = "ASC";//"ASC";
        let pageNo = 1;
        searchTxt = "";
        if (this.state.ReportDateField == "99") {
            //this.dateCheck();
        }

        //searchTxt = $(`#searchTxt`).val().trim();
        let searchCol = "";
        if (searchTxt != "") {
            searchCol = this.state.searchColumn;
        }
        FilterPopupBoolean = false;
        //this.setState({ searchColumn: "" });
        this.ApplyFilter(pageNo,
            this.state.RecCount,
            searchCol,
            searchTxt, searchTrBy, searchTrCriteria,
            sortColumn,
            sortType, FilterPopupBoolean, this.state.toggleChecked
        );
        this.setState({ sortColumn: sortColumn, sortType: sortType, searchAval: false, PageNo: pageNo, OrderDateBoolean: false, NeedByDateBoolean: false, OFromDate: "", OToDate: "", NFromDate: "", NToDate: "" });
    }

    handlePriority = (value) => {
        //;
        this.setState({ priorityFlag: value });
        let priorityFlag = ``;
        if (value == 1) {
            priorityFlag = `R`;
        } else {
            priorityFlag = ` `;
        }
        this.handleSearch(true, value);
    }



    //_____________________________________________________________________________
    filterClick = (event, displayName, columnName) => {
        event.preventDefault();
        GlobalSearchCol = columnName;
        this.setState({ filterDisplayName: displayName, searchColumn: columnName, OrderStatusSearch: "" });
        console.log("searchColumn", columnName)
        if (columnName != "LINE_PRIOR") {
            this.setState({ priorityFlag: 0 });
        }

        this.handleSearchTxt()
        //if (displayName == "Priority") {
        //    $("#searchTxt").hide();
        //    $("#searchIcon").hide();
        //    $("#priorityDiv").show();
        //    //this.setState({ priorityFlag: 0 });
        //} else {
        //    $("#searchTxt").show();
        //    $("#searchIcon").show();
        //    $("#priorityDiv").hide();
        //}
    };

    handleSearch = (isPriority, priorityFlag) => {
        //;
        let pageNo = 1;
        if (isPriority) {
            isPrioritySearch = true;
            if (priorityFlag == 1) {
                searchTxt = "R";
            }
            else {
                searchTxt = " ";
            }

        } else {
            isPrioritySearch = false;
            searchTxt = $(`#searchTxt`).val();
        }
        let sortColumn = "ORD_DATE_FILTER";
        let sortType = "DESC";
        //searchTxt = $(`#searchTxt`).val();
        //;
        let searchCol = "";
        if (searchTxt != "") {
            searchCol = this.state.searchColumn;
            console.log("searchCol", searchCol);
            //WW-366_PC_05
            // WW-399_PC_02 (5/9/ 2022) - Aparna
            if (searchCol != "LINE_PRIOR" && searchCol != "LINE_STATUS" && searchCol != "ORDER_TYPE") {
                searchTxt = $(`#searchTxt`).val();
            }
            else if (searchCol == "LINE_STATUS" || searchCol == "ORDER_TYPE") {
                searchTxt = this.state.OrderStatusSearch
            }
        }
        /*[07/25/22, PC_WW-455-05]Priyanka D*/
        this.ApplyFilter(pageNo,
            this.state.RecCount,
            searchCol,
            searchTxt, searchTrBy, searchTrCriteria,
            "",
            "", FilterPopupBoolean, this.state.toggleChecked
        );
        //;
        console.log("search", searchCol);
        this.setState({ PageNo: pageNo, searchAval: true });
        console.log("search", this.state.searchAval);
    }
    ClearSearch = () => {
        document.getElementById("searchTxt").value = "";
        $(`#RegId`).prop('disabled', false);
        $(`#ClearID`).prop('disabled', false);
        $('#applyfilterid').prop('disabled', false);
        $(`#SubRegId`).prop('disabled', false);
        $(`#ordertype`).prop('disabled', false);
        $(`#Date`).prop('disabled', false);
        $(`#Division`).prop('disabled', false);
        //WW - 487 Order status and type search option is not immediately clear when looking at the 'check order status' page
        $(`#mainorderstatusid`).prop('disabled', false);
        $(`#OrdCatId`).prop('disabled', false);
        this.setState({ SearchedTxt: "", isSearch: true });

    }
    //Order Status Stored Procedure Integration Change - Deepthi
    handleHeaderSearch = (isPriority, priorityFlag) => {
        //;
        let pageNo = 1;
        if (isPriority) {
            isPrioritySearch = true;
            if (priorityFlag == 1) {
                searchTxt = "R";
            }
            else {
                searchTxt = " ";
            }

        } else {
            isPrioritySearch = false;
            searchTxt = $(`#searchTxt`).val();
        }
        if (searchTxt.trim() !== "") {

            let sortColumn = "ORD_DATE_FILTER";
            let sortType = "DESC";
            //searchTxt = $(`#searchTxt`).val();
            //;
            let searchCol = "";
            if (searchTxt != "") {
                searchCol = this.state.searchColumn;
                console.log("searchCol", searchCol);
                //WW-366_PC_05
                // WW-399_PC_02 (5/9/ 2022) - Aparna
                if (searchCol != "LINE_PRIOR" && searchCol != "LINE_STATUS" && searchCol != "ORDER_TYPE") {
                    searchTxt = $(`#searchTxt`).val();
                }
                else if (searchCol == "LINE_STATUS" || searchCol == "ORDER_TYPE") {
                    searchTxt = this.state.OrderStatusSearch
                }
            }
            this.GetHeaderDetailes(false, searchTxt, this.state.toggleChecked, "No")
            this.setState({ PageNo: pageNo, searchAval: true });
            console.log("search", this.state.searchAval);
        }
    }

    saveprefresponse = () => {
        let PageLoadResponse = JSON.parse(OrderStatusStore.PageLoadData);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');


        //this.setState({ FlagData: PageLoadResponse.TotalCount });
        let flagdata = "False";
        let flagResponse = "";
        flagdata = PageLoadResponse[0].ErrorOccur;
        flagResponse = PageLoadResponse[0].lblNoData;
        //;
        console.log("saveprrferece", flagResponse);
        if (flagdata == "True") {
            if (flagResponse == "Employee List is too long.") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Employee List is too long"
                });
                //  alert("Employee List is too long");
            }
            if (flagResponse == "Error updating record from SDIX_RPT_PRESETS") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Error updating record from SDIX_RPT_PRESETS"
                });
                // alert("Error updating record from SDIX_RPT_PRESETS");
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                //bug 4054 - Yuvarani K
                text: "Your selection criteria preferences were saved successfully!"
            });
            //alert("Your Selection Criteria Preferences were saved successfully!")
        }
        console.log("falg", flagdata);
        console.log("falg", flagResponse);
    }

    BusUnitDropdownmap = () => {
        //;
        return this.state.BusUnitDropDown.map((value, ID) => {
            return (
                <option key={value.BUSINESS_UNIT} value={value.BUSINESS_UNIT}>{value.DESCRIPTION}</option>
            )

        });
    }
    /******NEW******wal-336************/
    DivisionDDmap = () => {


        let divsrt = this.state.DivisionDD.sort((a, b) => (a.DIVISION > b.DIVISION) ? 1 : -1);
        return divsrt.map((value, ID) => {
            //[10/27/22, WW_514_PS_OS_02, WW-514, Dhevanesm R]
            if (value.DIVISION != "" && value.DIVISION != " " && value.DIVISION != null && value.DIVISION != undefined) {
                return (
                    <option key={value.DIVISION} value={value.DIVISION}>{value.DIVISION}</option>
                )
            }


        });
    }
    RegionDDmap = () => {

        if (this.state.RegionDD && this.state.RegionDD != null && this.state.RegionDD != []) {
            let RegDD = this.state.RegionDD.filter((v, i, a) => a.findIndex(t => (t.REGION.trim().toUpperCase() === v.REGION.trim().toUpperCase())) === i);
            let regsrt = RegDD.sort((a, b) => {
                let a1 = a.REGION;
                let b1 = b.REGION;
                if (!this.containsAnyLetter(a.REGION)) {
                    a1 = parseInt(a.REGION);
                }
                if (!this.containsAnyLetter(b.REGION)) {
                    b1 = parseInt(b.REGION);
                }
                let tA = typeof a1;
                let tB = typeof b1;
                if (tA === tB && tA === "string") {
                    return a.REGION.localeCompare(b.REGION);
                } else if (tA === tB && tA === "number") {
                    return a.REGION - b.REGION;
                } else {
                    return tA === "string" ? 1 : -1;
                }
            });
            //let regsrt = RegDD.sort((a, b) => (a.REGION.toString() > b.REGION.toString()) ? 1 : -1);
            return regsrt.map((value, ID) => {
                //[10/27/22, WW_514_PS_OS_02, WW-514, Dhevanesm R]
                if (value.REGION != "" && value.REGION != " " && value.REGION != null && value.REGION != undefined) {
                    return (
                        <option key={value.REGION} value={value.REGION}>{value.REGION}</option>
                    )
                }
            });
        }
    }
    containsAnyLetter = (str) => {
        return /[a-zA-Z]/.test(str);
    }

    SubRegionDDmap = () => {

        if (this.state.SubRegionDD != undefined && this.state.SubRegionDD != null && this.state.SubRegionDD != []) {
            let SunRegDD = this.state.SubRegionDD.filter((v, i, a) => a.findIndex(t => (t.SUB_REGION.trim().toUpperCase() === v.SUB_REGION.trim().toUpperCase())) === i);
            let subregsrt = SunRegDD.sort((a, b) => {
                let a1 = a.SUB_REGION;
                let b1 = b.SUB_REGION;
                if (!this.containsAnyLetter(a.SUB_REGION)) {
                    a1 = parseInt(a.SUB_REGION);
                }
                if (!this.containsAnyLetter(b.SUB_REGION)) {
                    b1 = parseInt(b.SUB_REGION);
                }
                let tA = typeof a1;
                let tB = typeof b1;
                if (tA === tB && tA === "string") {
                    return a.SUB_REGION.localeCompare(b.SUB_REGION);
                } else if (tA === tB && tA === "number") {
                    return a.SUB_REGION - b.SUB_REGION;
                } else {
                    return tA === "string" ? 1 : -1;
                }
            });
            //let subregsrt = SunRegDD.sort((a, b) => (a.SUB_REGION.toString() > b.SUB_REGION.toString()) ? 1 : -1);
            return subregsrt.map((value, ID) => {
                //[10/27/22, WW_514_PS_OS_02, WW-514, Dhevanesm R]
                if (value.SUB_REGION != "" && value.SUB_REGION != " " && value.SUB_REGION != null && value.SUB_REGION != undefined) {
                    return (
                        <option key={value.SUB_REGION} value={value.SUB_REGION}>{value.SUB_REGION}</option>
                    )
                }

            });
        }
    }

    /*****END*******/
    OrderStatusDropdown = () => {
        return this.state.OrderStatus.map((value, ID) => {
            return (
                /*[07/14/22, PC_WW-447_03-Sprint-23], Priyanka D */
                <option value={value.MAIN_STATUS}>{value.MAIN_STATUS}</option>
            )

        });
    }

    EmpIdDropdownmap = () => {

        //return this.state.EmpIdDropDown.map((value, ID) => {
        //    return (
        //        <option value={value.ISA_EMPLOYEE_NAME}>{value.ISA_EMPLOYEE_NAME}</option>
        //    )

        //});
        console.log("error", this.state.EmpIdDropDown);


    }


    SavePrefCheckForGroup = () => {
        //****NEW(1/27/2021)***ADDED******
        if (this.state.ReportDateField == "X") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select Report Date Field"
            });
            // alert("Select Report Date Field");
            return;
        }
        else if (this.state.ReportDateField == "99") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "You cannot save preferred dates"
            });
            // alert("You cannot save preferred dates");
            return;
        }
        //*END**********
        if (this.state.OrderTypeField == "Group") {
            if (this.state.EmpListPush.length > 0) {
                this.SavePreferenceClick();
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Select Employee"
                });
                // alert("Select Employee");
            }
        }
        else if (this.state.ReportDateField == "99" || this.state.ReportDateField == "X") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select Report Date Field"
            });
            //  alert("Select Report Date Field");
        }
        else {
            this.SavePreferenceClick();
        }
    }


    //***********************SavePreference Click************************
    SavePreferenceClick = () => {
        let MultiSitelist = []
        if (this.state.OrderTypeField == "Group") {
            if (this.state.EmpListPush.length > 0) {
                this.state.EmpListPush.map((val, index) => {
                    MultiSitelist.push({ EmpId: val.value })
                });
            }
        }
        console.log("empist", MultiSitelist);
        //;
        if (this.state.OrderTypeField == "All") {
        }
        let SavePrefereceBO = {

            Report: this.state.ReportDateField,
            Order_Type: this.state.OrderTypeField,
            Report_Type: this.state.ReportTypeField,
            Selected_Site_Bu: this.state.BusUnitField,
            Emplist: MultiSitelist,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
            Division: this.state.Division,
            Region: this.state.Region,
            SubRegion: this.state.SubRegion,
            OrderStatus: this.state.MainOrderStatus,
            OrderCategory: this.state.OrderCategory
        }
        //;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.SavePreference(SavePrefereceBO);
        console.log("savepref", this.state.EmpListPush);





    }

    BackNavigation = (e) => {

        e.preventDefault();
        let a = "";
    }
    //*****************************SavePreferenceEnd**************************************
    //********NEW*****wal-366**************
    divclear = () => {
        let subreg = []
        subreg = this.state.DivTbl.filter((ele, ind) => ind === this.state.DivTbl.findIndex(elem => elem.SUB_REGION === ele.SUB_REGION && elem.SUB_REGION != ' ' && elem.SUB_REGION != null))
        //WW - 487 Order status and type search option is not immediately clear when looking at the 'check order status' page
        this.setState({ Division: " ", Region: " ", SubRegion: " ", ReportDateField: "X", OrderTypeField: "My", SubRegionDD: subreg, SearchTrFromDate: "", SearchTrToDate: "", MainOrderStatus: " ", OrderCategory: " " });
        $(`#ordertype`).prop('disabled', false);
        $("#sFT").hide();

    }

    /**********END****************/

    handleChange = (event) => {
        //;
        //$("#SearchTrTxt").show();
        //$("#status-dropdown").hide();
        //$('#SearchTrTxt').val('');
        //*****NEW*****wal-158*****

        const queryParams = new URLSearchParams(window.location.search)

        let orderno_noti = queryParams.get('ordno');
        console.log("orderno_noti", orderno_noti)
        if (this.props.location.hasOwnProperty('state') && this.props.location.state != undefined && this.props.location.state.hasOwnProperty('origin')) {
            if (this.props.location.state.hasOwnProperty('ordno')) {
                orderno_noti = this.props.location.state.ordno;
            }
        }
        if (orderno_noti != "" && orderno_noti != null && orderno_noti != undefined) {
            this.props.history.push({
                pathname: `/OrderStatus2`,

            });
        }
        //************END**********
        //********NEW*************wal-366****

        //[12/15/21, PC_OS_02, WW-300, Dhevanesam R - To avoid filtering when divion is selected]

        //let reg= [];
        //let region= [];
        //let subreg=[]
        //if ((event.target.name == "Division" && event.target.value != "")) {
        //    //$(`#ordertype`).prop('disabled', true);
        //    reg = this.state.DivTbl.filter((ele, ind) => ele.DIVISION == event.target.value && ele.REGION != ' ' && ele.REGION != null)
        //    region = reg.filter((v, i, a) => a.findIndex(t => (t.REGION.trim().toUpperCase() === v.REGION.trim().toUpperCase())) === i)
        //    //   reg = this.state.DivTbl.filter((ele, ind) => ind === this.state.DivTbl.findIndex(elem => elem.DIVISION === event.target.value && elem.REGION != ' ' && elem.REGION!=null))
        //    /*[10/12/21, PC_OS_01], Priyanka D//Binding default value for Region and subregion*/
        //    this.setState({ Region: "" });  
        //    this.setState({ SubRegion: "" });
        //}
        //else if ((event.target.name == "Region" && event.target.value != "")) {
        //    //$(`#ordertype`).prop('disabled', true);

        //    subreg = this.state.DivTbl.filter((ele, ind) => ele.DIVISION == this.state.Division && ele.REGION == event.target.value)
        //    //subreg = this.state.DivTbl.filter((ele, ind) => ind === this.state.DivTbl.findIndex(elem =>  elem.REGION == event.target.value ))
        //    /*[10/12/21, PC_OS_01], Priyanka D//Binding default value for subregion*/
        //    this.setState({ SubRegion: "" });
        //}

        //if ((event.target.name == "Division" && event.target.value != "")) {
        //    //$(`#ordertype`).prop('disabled', true);
        //    this.setState({ Region: "" });
        //    this.setState({ SubRegion: "" });

        //}
        //else if ((event.target.name == "Region" && event.target.value != "")) {
        //    //$(`#ordertype`).prop('disabled', true);
        //    this.setState({ SubRegion: "" });
        //}
        //else if (event.target.name == "SubRegion" && event.target.value != "") {
        //    //$(`#ordertype`).prop('disabled', true);
        //}
        //else if (this.state.Division == " " && this.state.Region == " " && this.state.SubRegion == " ") {
        //    $(`#ordertype`).prop('disabled', false);
        //}

        //********END******
        // WW-300_PS_01 sub region dependent on region (12/17/2021)-Aparna
        let Reg = [];
        if (event.target.name == "Division") {
            if (event.target.value != " ") {
                Reg = this.state.DivTbl.filter((ele, ind) => ele.DIVISION == event.target.value && ele.REGION != null)
                this.setState({ RegionDD: Reg });
            }
            else {

                Reg = this.state.DivTbl.filter((ele, ind) => ind === this.state.DivTbl.findIndex(elem => elem.REGION === ele.REGION && elem.REGION != ' ' && elem.REGION != null))
                this.setState({ RegionDD: Reg });
            }
        }
        let subreg = []
        if (event.target.name == "Region") {
            if (event.target.value != " ") {
                subreg = this.state.DivTbl.filter((ele, ind) => ele.REGION == event.target.value && ele.SUB_REGION != null)
                this.setState({ SubRegionDD: subreg });
            }
            else {
                subreg = this.state.DivTbl.filter((ele, ind) => ind === this.state.DivTbl.findIndex(elem => elem.SUB_REGION === ele.SUB_REGION && elem.SUB_REGION != ' ' && elem.SUB_REGION != null))
                this.setState({ SubRegionDD: subreg });
            }
        }
        else {
            this.setState({ SubRegion: "" });
        }

        this.setState({ [event.target.name]: event.target.value });
        //console.log("subreg", subreg)
        //console.log("reg", reg)
        //if (event.target.name == "Division" && event.target.value != "") {
        //    this.setState({ [event.target.name]: event.target.value, RegionDD: region });
        //}
        //else if (event.target.name == "Region" && event.target.value != "") {
        //    this.setState({ [event.target.name]: event.target.value, SubRegionDD: subreg });
        //}
        //else {
        //    this.setState({ [event.target.name]: event.target.value});
        //}

        if (event.target.value == "Group") {
            this.setState({
                EmpListPush: [], OrderTypeField: "Group", Division: " ",
                Region: " ",
                SubRegion: " "
            });
        }
        else {
            this.setState({ isSearch: true })
        }
        $("#sFT").hide();
        $("#sdrp").hide();
        $("#OR").hide();
        if (event.target.value != "99") {
            //this.setState({ SearchTrFromDate: "", SearchTrToDate: "" });
            searchTrCriteria = "";
            $('#SearchTrTxt').val('');
            $("#status-dropdown").hide();
            $("#SearchTrTxt").show();
            searchTrBy = "OrderNo";
            radiochange = false;

            searchTrCriteria = "";
            radio = "ExactValue"


            $('#ex').removeClass('disable-radio-label');
            $('#6m').removeClass('disable-radio-label');
            $('#dr').removeClass('disable-radio-label');

            // document.getElementById("exval").checked = true;

            //document.getElementById("exval").disabled = false;
            $("#6month").attr('disabled', false);
            $("#dateRag").attr('disabled', false);
            $("#exval").attr('disabled', false);
            this.setState({ EV: true, MN: false, DR: false });
        }
        if (event.target.value == "99" || this.state.ReportDateField == "99") {
            $("#status-dropdown").hide();
            $("#SearchTrTxt").show();
            $("#sFT").show();
            $("#sdrp").show();
            $("#OR").show();
            $('#SearchTrTxt').val('');

            //document.getElementById("exval").checked = true;

            this.setState({ STrDisplayName: "Order Number", EV: true, MN: false, DR: false });
        }
        if (event.target.name == "ReportDateField" && event.target.value != "99") {
            $("#sFT").hide();
            $("#sdrp").hide();
            $("#OR").hide();
        }
        //let div = this.state.Division;
        //let reg = this.state.Region;
        //let sub = this.state.SubRegion;
        //let boo = false;
        //if (div != "" && reg != "" && sub != "") {
        //    boo =true
        //}
        //if ((event.target.name == "Division" && event.target.value != "") )
        //if (event.target.value != "99") {
        //    this.setState({ SearchTrFromDate: "", SearchTrToDate: "" });
        //    searchTrCriteria = "";
        //    $('#SearchTrTxt').val('');
        //    $("#status-dropdown").hide();

        //    $("#sFT").hide();
        //    $("#sdrp").hide();
        //    $("#OR").hide();
        //    //$("#SearchTrTxt").show();
        //    searchTrBy = "OrderNo";
        //    radiochange = false;
        //}
        //if (this.state.ReportDateField == "99") {
        //    $("#sFT").show();
        //    $("#sdrp").show();
        //    $("#OR").show();
        //}
        //if (event.target.value == "99") {
        //    $("#status-dropdown").hide();
        //    $("#SearchTrTxt").show(); 

        //    $("#sFT").show();
        //    $("#sdrp").show();
        //    $("#OR").show();
        //    $('#SearchTrTxt').val('');
        //}
        if (event.target.name == "OrderTypeField" && event.target.value != "All") {
            this.setState({ Division: " ", Region: " ", SubRegion: " " })
        }


    };
    //Order Status Stored Procedure Integration Change - Deepthi
    addFavItemsToCart = (CoreCharge, Proceed) => {
        debugger
        //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            let hasEquipmentItem = [];
            let hasQuoteItem = [];
            hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));

            if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                $('#MixedOrderConfirmPopup').modal('show');
                this.setState({ CoreCharge: CoreCharge, Proceed: Proceed, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
            else {
                if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) {
                    let locOrderArr = [];
                    let locItemArr = [];
                    if (this.state.OrderQuoteArray != undefined && this.state.OrderQuoteArray != null && this.state.OrderQuoteArray.length > 0) {
                        this.state.OrderQuoteArray.map((val, index) => {
                            locOrderArr = cartItems.filter(line => {
                                return line.ISA_QUOTE_REF == val.ORDER_NO;
                            });
                            locItemArr = cartItems.filter(line => {
                                return line.Itemid == val.INV_ITEM_ID;
                            });
                        });
                    }
                    if (locOrderArr != undefined && locOrderArr != null && locOrderArr.length > 0) {
                        if (locItemArr != undefined && locItemArr != null && locItemArr.length > 0) {
                            this.setState({ CoreCharge: CoreCharge, Proceed: Proceed });
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "This item is already added in the cart"
                            });
                            return;
                        }
                    }
                    else if (this.state.BuyAgainArray != undefined && this.state.BuyAgainArray != null && this.state.BuyAgainArray.length > 0) {
                        this.setState({ CoreCharge: CoreCharge, Proceed: Proceed, cartConfirmationPopupTxt: "Adding item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                        $('#MixedOrderConfirmPopup').modal('show');
                        return;
                    }
                    else if (this.state.OrderQuoteArray != undefined && this.state.OrderQuoteArray != null && this.state.OrderQuoteArray.length > 0) {
                        this.setState({ CoreCharge: CoreCharge, Proceed: Proceed, cartConfirmationPopupTxt: "Adding item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                        $('#MixedOrderConfirmPopup').modal('show');
                        return;
                    }
                }
                else if (!cartDelete && this.state.OrderQuoteArray != undefined && this.state.OrderQuoteArray != null && this.state.OrderQuoteArray.length > 0) {
                    this.setState({ CoreCharge: CoreCharge, Proceed: Proceed, cartConfirmationPopupTxt: "Adding item will remove your current items in your shopping cart. Do you want to proceed with this change?" });
                    $('#MixedOrderConfirmPopup').modal('show');
                    return;
                }
            }
        }
        //1898 - Unable to add Items from different pages through buy again - Deepthi
        let buyagainItems = this.state.BuyAgainArray;
        let itemsSelected = [];
        if (this.state.BuyAgainArray != undefined && this.state.BuyAgainArray != null && this.state.BuyAgainArray.length > 0) {
            itemsSelected = this.state.BuyAgainArray.filter((selected) => selected.checked == true);
        }
        else if (this.state.OrderQuoteArray != undefined && this.state.OrderQuoteArray != null && this.state.OrderQuoteArray.length > 0) {
            itemsSelected = this.state.OrderQuoteArray.filter((selected) => selected.checked == true);
        }
        let itemsToAdd = [];
        //A1QA-248_PC_06 (11/16/2022)-Aparna
        let LochasCoreCharge = false;
        console.log("itemsSelected-core charge", itemsSelected)
        if (itemsSelected.length > 0) {
            itemsSelected.forEach((value) => {
                if (CoreCharge == false || Proceed == true) {
                    itemsToAdd.push({
                        Order_Number: value.ORDER_NO, Business_unit_om: value.BUSINESS_UNIT_OM, INV_ITEM_ID: value.INV_ITEM_ID, Quantity: value.QTY_REQ,
                        ISA_INTFC_LN: value.LINE_NBR,
                        ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM, MFG_ITM_ID: value.MFG_ITM_ID, Descr: value.DESCR254, price: value.ISA_SELL_PRICE, ITEM_CAT: value.ITEM_CAT,
                        PaintColor: value.PaintColor
                    });
                    if (value.HASCORECHARGE == true) {
                        LochasCoreCharge = true
                    }
                }
                else {
                    if (value.HASCORECHARGE == false) {
                        itemsToAdd.push({
                            Order_Number: value.ORDER_NO, Business_unit_om: value.BUSINESS_UNIT_OM, INV_ITEM_ID: value.INV_ITEM_ID, Quantity: value.QTY_REQ,
                            ISA_INTFC_LN: value.LINE_NBR,
                            ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM, MFG_ITM_ID: value.MFG_ITM_ID, Descr: value.DESCR254, price: value.ISA_SELL_PRICE, ITEM_CAT: value.ITEM_CAT,
                            PaintColor: value.PaintColor
                        });
                    }
                }


            });
            if (CoreCharge == false && LochasCoreCharge == true) {
                $('#CoreChargePopUp').modal('show')
                return;
            }
            if (itemsToAdd.length > 0) {
                let addFavOrderItemsBO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                    LineItems: itemsToAdd,
                    Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
                    Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
                    EquipmentDelete: cartDelete,
                    Interactive: false
                }; //;
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                OrderStatusAction.addFavOrderItemsTocart(addFavOrderItemsBO);
            }
        }
        else {
            //alert("Please select any item to buy again");
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select any item to buy again"
            });
        }
    };




    //*****************ApprovalHistory*****************************
    Approvalhistory = (value) => {
        debugger;
        //;
        $('#order-approval-history').modal('show');
        let bu = [];
        let sitebu;
        bu = this.state.BusUnitDropDown;
        console.log("bud", this.state.BusUnitDropDown);
        //;
        if (bu.length > 0) {
            bu.forEach((val) => {
                if (val.BUSINESS_UNIT == CookieService.getLocalStorageValues("Session_BUSUNIT"))
                    sitebu = val.DESCRIPTION;
            })
        }
        let lblTest = "";
        let lblVersion = "";
        let environmentDataResponse;
        //;
        environmentDataResponse = JSON.parse(localStorage.getItem("SDIEnvironmentData"));
        environmentDataResponse = environmentDataResponse[0];
        console.log("buhist", environmentDataResponse);
        lblTest = environmentDataResponse.lblTest;
        let websiteid = CookieService.getLocalStorageValues("Session_WEBSITEID");
        lblVersion = environmentDataResponse.lblVersion;
        let ver = [];
        ver = lblVersion.split(' _Z_  :: SUAT :: ');
        console.log("BU", lblTest);
        console.log("BU", lblVersion);
        console.log("BUV", ver[0] + ver[1]);
        this.setState({
            ApprovalPopup: true,

            ApprovalHistoryL: {

                Version: ver[0] + ver[1],
                BU: lblTest,
                CURRENCY: value.CURRENCY,
                REV_DUE_DATE: !value.REV_DUE_DT1 ? "-" : value.REV_DUE_DT1,
                SHIPDOC: this.shiptobind(value),
                //pc-1138-02 changing the employee id to user name S.Sanjay 8/1/2024
                APPROVALBY: value.APPROVEDBYNAME,
                ASSET_TAG: value.ISA_MACHINE_NO,
                ASSET_TYPE: value.ISA_ASSET_TYPE,
                BUSINESS_UNIT_OM: value.BUSINESS_UNIT_OM,
                PRICE: value.PURCH_PRICE1,
                SUPPLIER: value.SUPPLIER,
                MFG: (value.LINEFIELD == "REPLN" && value.MFG_ID != "" ? value.MFG_ID : value.ISA_MFG_FREEFORM),    //[06/22/2022 ,WW-378 mgf id binded for repln order],Pavithra R

                UNIT: value.UNIT_OF_MEASURE
            }
        });
        let ApprovalHistoryBO = {
            sOrderNo: value.ORDER_NO,
            LoadId: value.ORDER_NO,
            sBu: this.state.ReportTypeField,
            ENTERED_BY_USERID: value.ENTEREDEMPNAME


        }
        //;
        OrderStatusAction.ApprovalHistory(ApprovalHistoryBO);
    }
    //*************************************************************

    //************************Approvalhistory popupdetail******************
    bindApproveHistoryPopupDetail() {
        let HistoryResponse = JSON.parse(OrderStatusStore.PageLoadData);
        this.setState({ ApprovalhistoryArr: HistoryResponse.ApprvHist });

        //this.setState({
        //    ApprovalPopup: true,

        //})
    }
    //**********************POPOPUp****************************************
    PODetailPopup = (value, IsCancelled) => {

        let PODetailBO = {
            sPOID: value,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP")
        }
        //;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.PODetail(PODetailBO);

    }
    //********************************End**********************************
    ShipmentBOlPopup = (OrderItem, OrderDetail) => {
        let pop = false;
        if (this.state.FlagTable.length > 0) {
            let pop = this.state.FlagTable.filter((item, index) => item.sOrderNo == OrderDetail.ORDER_NO && item.popup == "True");
            if (pop.lenght > 0) {
                pop = true;
            }
        }


        let ShipmentBOLBO = {
            signpopup: pop,
            OrderNo: OrderItem.ORDER_NO,
            LoadId: OrderItem.LOAD_ID,
            ENTERED_BY_USERID: OrderDetail.OPRID_ENTERED_BY,

            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),

        }
        //;
        OrderStatusAction.shipmentBOL(ShipmentBOLBO);
    }

    //pushEmpId = (e) => {
    //    selectedEmpId
    //}
    //handleBusUnitChange = (e) => {

    //    this.setState({ BusUnitField: e.target.value });
    //}
    //*****************sorting icon click***************************
    Sorting = (sortType, sortColumn) => {
        let searchCol
        if (this.state.isSearch) {
            searchCol = this.state.searchColumn;
            if (searchCol == "LINE_PRIOR") {
                if (this.state.priorityFlag == 1) {
                    searchTxt = `R`;
                }
                else if (this.state.priorityFlag == 2) {
                    searchTxt = ` `;
                }
                else {
                    searchCol = "";
                    searchTxt = ` `;
                }

            }
            else {
                searchTxt = $(`#searchTxt`).val().trim()
            }


        }
        if (this.state.searchTrTxt !== "") {

        }
        //this.setState({ sSearchCriteria: sc });
        let pageNo = 1;
        this.ApplyFilter(this.state.PageNo,
            this.state.RecCount,
            this.state.searchColumn,
            searchTxt, searchTrBy, searchTrCriteria,
            sortColumn,
            sortType, FilterPopupBoolean, this.state.toggleChecked
        );
        this.setState({ pageNo: pageNo, sortColumn: sortColumn, sortType: sortType });
    }
    handleSTrTxt = (event) => {
        //this.setState({ searchC: [event.traget.value] });
        searchTrCriteria = $('#SearchTrTxt').val();
        //;
    }
    /*[07/25/22, PC_WW-455-04]Priyanka D*/
    handleSearchTxt = (event) => {
        debugger
        if (event != undefined) {
            if (event.target.value != "") {
                this.setState({ SearchedTxt: event.target.value, isSearch: false, ReportDateField: "X", OrderTypeField: "All", Division: " ", Region: " ", SubRegion: " ", OrderStatusSearch: "", SearchTrFromDate: "", SearchTrToDate: "", OrderCategory: " ", MainOrderStatus: " " })
                $(`#RegId`).prop('disabled', true);
                $(`#SubRegId`).prop('disabled', true);
                $(`#ordertype`).prop('disabled', true);
                $(`#Date`).prop('disabled', true);
                $('#applyfilterid').prop('disabled', true);
                $(`#Division`).prop('disabled', true);
                $(`#ClearID`).prop('disabled', true);
                //WW - 487 Order status and type search option is not immediately clear when looking at the 'check order status' page
                $(`#OrdCatId`).prop('disabled', true);
                $(`#mainorderstatusid`).prop('disabled', true);
            } else {

                // this.setState({ Manager: this.state.managerdata})
                $(`#RegId`).prop('disabled', false);
                $(`#ClearID`).prop('disabled', false);
                $(`#SubRegId`).prop('disabled', false);
                $(`#ordertype`).prop('disabled', false);
                $(`#Date`).prop('disabled', false);
                $('#applyfilterid').prop('disabled', false);
                $(`#Division`).prop('disabled', false);
                $(`#OrdCatId`).prop('disabled', false);
                $(`#mainorderstatusid`).prop('disabled', false);
                this.setState({ isSearch: true });
            }
        } else {
            //this.setState({ Manager: this.state.managerdata })
            if (GlobalSearchCol == "All" || GlobalSearchCol == " ") {

                let srchtxt = $('#SearchTrTxt').val();
                if (srchtxt === undefined) {
                    srchtxt = "";
                }
                if (srchtxt != "") {
                    $(`#RegId`).prop('disabled', true);
                    $(`#SubRegId`).prop('disabled', true);
                    $(`#ordertype`).prop('disabled', true);
                    $(`#Date`).prop('disabled', true);
                    $('#applyfilterid').prop('disabled', false);
                    $(`#Division`).prop('disabled', true);
                    $(`#ClearID`).prop('disabled', true);
                    //WW - 487 Order status and type search option is not immediately clear when looking at the 'check order status' page
                    $(`#OrdCatId`).prop('disabled', true);
                    $(`#mainorderstatusid`).prop('disabled', true);
                    this.setState({ isSearch: false });
                }


            }
            else {
                $(`#RegId`).prop('disabled', false);
                $(`#SubRegId`).prop('disabled', false);
                $(`#ordertype`).prop('disabled', false);
                $(`#Date`).prop('disabled', false);
                $(`#Division`).prop('disabled', false);
                $(`#ClearID`).prop('disabled', false);
                $(`#OrdCatId`).prop('disabled', false);
                $(`#mainorderstatusid`).prop('disabled', false);
                this.setState({ isSearch: true });
            }

        }


        //WW-366_PC_08 (5/16/2022) -Aparna
        // this.divclear();
    }
    handlePageClick = (data) => {
        //;
        let pageNo = data.selected + 1;
        //$('.accordion-arrow').removeClass('accordion-arrow-change');
        //$('.hiddenRow').hide();
        //$('tr').removeClass('tr-border');
        window.scrollTo(0, 0);
        this.setState({ PageNo: pageNo, isExpand: false });
        //WW-380 handle pagingation in front end -Aparna
        //if (this.state.isSearch) {
        //    if (isPrioritySearch) {
        //        let radioVal = $("input[name='priorityOption']:checked").val();
        //        if (radioVal == `1`) {
        //            searchTxt = `R`;
        //        }
        //        else {
        //            searchTxt = ` `;
        //        }

        //    }
        //    else {
        //        searchTxt = $(`#searchTxt`).val().trim();
        //    }
        //    //searchTxt = $(`#searchTxt`).val().trim();
        //}
        //this.ApplyFilter(pageNo,
        //    this.state.RecCount,
        //    this.state.searchColumn,
        //    searchTxt, searchTrBy, searchTrCriteria,
        //    this.state.sortColumn,
        //    this.state.sortType, FilterPopupBoolean, this.state.toggleChecked
        //);
        console.log("totArr", pageNo);
        //;

    };

    shiptobind = (OrderDetail) => {
        let ShiptoValue = this.state.GridArr2.filter((item, index) => item.ORDER_NO == OrderDetail.ORDER_NO && item.ORDER_INT_LINE_NO == OrderDetail.LINE_NBR);
        //;

        return ShiptoValue.map((Item, index) => {
            //;
            return (
                <a href="#" data-toggle="modal" className="float-none" data-target="#shipmentBOL" onClick={(e) => this.ShipmentBOlPopup(Item, OrderDetail)} >{Item.SHIP_DATE}</a>
            );
        })
    }
    //Order Status Stored Procedure Integration Change - Deepthi
    selectbuyagainOrder = (value) => {
        debugger
        let locGridArr = this.state.HeaderGridArray;
        let locbuyagain = this.state.BuyAgainArray;
        let filterArr;

        if (locbuyagain.length > 0) {
            filterArr = locbuyagain.findIndex(t => (t.ORDER_NO === value.ORDER_NO && t.LINE_NBR == value.LINE_NBR));
        };

        let I = locGridArr.findIndex(t => (t.ORDER_NO === value.ORDER_NO && t.ISA_INTFC_LN == value.LINE_NBR));
        locGridArr[I].checked = locGridArr[I].checked == true ? false : locGridArr[I].checked == false ? true : true;
        //A1QA-248_PC_05 (11/16/2022)-Aparna
        let NextIndex = I + 1;
        let LochasCoreCharge = false
        if (locGridArr[NextIndex] != null && locGridArr[NextIndex] != undefined) {
            if (locGridArr[NextIndex].hasCoreCharge == true) {
                LochasCoreCharge = true
            }
        }
        if (locGridArr[I].checked == true) {
            if (filterArr == -1 || filterArr == undefined) {
                let buyagaiobj = {
                    ORDER_NO: value.ORDER_NO,
                    BUSINESS_UNIT_OM: 'I0W01',
                    INV_ITEM_ID: value.ITEM_ID,
                    QTY_REQ: value.QTY_REQ,
                    LINE_NBR: value.LINE_NBR,
                    ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM,
                    MFG_ITM_ID: value.MFG_ITM_ID,
                    DESCR254: locGridArr[I].DESCR254,
                    ISA_SELL_PRICE: value.ISA_SELL_PRICE,
                    ITEM_CAT: value.ITEM_CAT,
                    checked: locGridArr[I].checked,
                    HASCORECHARGE: LochasCoreCharge,
                    PaintColor: value.LINE_FIELD_C6
                }
                locbuyagain.push(buyagaiobj);
            }

        }
        else {
            let Index = this.state.BuyAgainArray.findIndex(t => (t.ORDER_NO === value.ORDER_NO && t.ISA_INTFC_LN == value.LINE_NBR));
            this.state.BuyAgainArray.splice(Index, 1);
            locbuyagain = this.state.BuyAgainArray;
        }

        // To Update the LineDetailsGrid checked property
        let locLineDetailsGrid = this.state.LineDetailsGrid;
        locGridArr.forEach(gridItem => {
            let lineDetailIndex = locLineDetailsGrid.findIndex(lineItem =>
                (lineItem.ORDER_NO === gridItem.ORDER_NO && lineItem.LINE_NBR === gridItem.ISA_INTFC_LN)
            );
            if (lineDetailIndex !== -1) {
                locLineDetailsGrid[lineDetailIndex].checked = gridItem.checked;
            }
        });


        this.setState({ BuyAgainArray: locbuyagain, HeaderGridArray: locGridArr, LineDetailsGrid: locLineDetailsGrid });

    }

    selectOrder = (ind) => {
        let { GridArr } = this.state;
        //1898 - Unable to add Items from different pages through buy again - Deepthi
        let locBuyAgain = this.state.BuyAgainArray;
        let filtarray;
        if (locBuyAgain.length > 0) {
            filtarray = locBuyAgain.findIndex(t => (t.ORDER_NO === ind.ORDER_NO && t.LINE_NBR == ind.LINE_NBR));
        }
        let I = GridArr.findIndex(t => (t.ORDER_NO === ind.ORDER_NO && t.LINE_NBR == ind.LINE_NBR))
        GridArr[I].checked = GridArr[I].checked == true ? false : GridArr[I].checked == false ? true : true;
        //1898 - Unable to add Items from different pages through buy again - Deepthi
        if (GridArr[I].checked == true) {
            if (filtarray == -1 || filtarray == undefined) {
                locBuyAgain.push(GridArr[I]);
            }

        }
        this.setState({ BuyAgainArray: locBuyAgain });
        this.setState(GridArr);
    }
    OrderStatusPopup = (value) => {
        //$('.orderstatus-popup').modal('show');
        let OrderStatusBO = {
            sOrderNo: value.ORDER_NO,

            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),

            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")

        }
        //;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.OrderStatusDetail(OrderStatusBO);
    }
    //Order Status Stored Procedure Integration Change - Deepthi
    GetOrderLineDetails = (event, index, OrderNo, classname) => {
        debugger
        let OrderList = [];
        OrderList.push({ OrderId: OrderNo });
        if (!OrderLevelQuoteClick) { //[12/06/2024, To fetch line details without oppening accordion - WW-1221 Preventive work order -Vishwa S]
            $(event.currentTarget).children().toggleClass('accordion-arrow-change');
            $(`#contentrow-${index}`).toggleClass('d-none');
            $('tr').removeClass('tr-border');
            $(event.currentTarget).parent('tr').addClass('tr-border');


            if (classname.includes("d-none")) {
                let LineDataBO = {
                    Order_No: OrderList,
                    Bus_Unit: 'I0W01'
                }
                OrderStatusAction.LineData(LineDataBO);
            }
        }
        else { //[12/06/2024, To fetch line details without oppening accordion - WW-1221 Preventive work order -Vishwa S]
            let LineDataBO = {
                Order_No: OrderList,
                Bus_Unit: 'I0W01'
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            OrderStatusAction.LineData(LineDataBO);
        }

    }
    //Order Status Stored Procedure Integration Change - Deepthi
    onAccordianClick = (event, index, OrderNo) => {
        debugger
        let classname = document.getElementById(`contentrow-${index}`).className;
        if (!OrderLevelQuoteClick) {
            if (classname.includes("d-none")) {
                $('.header-arrow').addClass('accordion-arrow-change');
                $('.content-row').removeClass('d-none');
                $('.header-arrow').removeClass('accordion-arrow-change');
                $('.content-row').addClass('d-none');
                this.setState({ LineDetailsGrid: [] });
            }
        }
        else {
            this.setState({ LineDetailsGrid: [] });
        }


        this.GetOrderLineDetails(event, index, OrderNo, classname);

    };
    onAccordianPOClick = (event, index) => {
        debugger
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentPOrow-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');

    };
    //******Line Level Grid Binding*****

    imageclicked = (imgarray) => {
        this.setState({ imagearray: imgarray });
        $('#image_modal').modal('show');
    }
    //[2/2/2022, PC_OS_03, WW-350, Dhevanesam R]
    CancelItemConfirmed = (ItemLevel) => {
        let OrderNoList = this.state.OrderNoList
        let LineNoList = this.state.LineNoList
        let FilArrGrid = []
        if (ItemLevel == "LineItem") {
            // PC_WAL_1045_04-Include new status for CNC-Priyanka 
            FilArrGrid = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == OrderNoList[0] && x.ISA_INTFC_LN == LineNoList[0].LineNo && (!this.state.showReasonPopup.includes(x.ISA_LINE_STATUS)) && x.ISA_LINE_STATUS != "IPR")
        }
        else {
            // PC_WAL_1045_04-Include new status for CNC-Priyanka 
            FilArrGrid = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == OrderNoList[0] && (!this.state.showReasonPopup.includes(x.ISA_LINE_STATUS)) && x.ISA_LINE_STATUS != "IPR")
        }
        $('#CanceledItemReason').modal('show');
        this.setState({ ItemLevel: ItemLevel, reasonModal: FilArrGrid.length > 0 ? true : false });
    }
    //Order Status Stored Procedure Integration Change - Deepthi
    CancelLineLevelItem = (value, Levels) => {
        debugger
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (Levels == "Line") {
            let lineDet = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO && x.ISA_INTFC_LN == value.LINE_NBR)
            let linestatus = lineDet[0].ISA_LINE_STATUS;
            let OrderApprover = lineDet[0].NEXTAPPROVER;
            if (linestatus == "IPR") {
                let IprAlertMsg = "This item is in processing and cannot be cancelled currently. Please try again after sometime."
                this.setState({ IsConfirm: false, IprAlertMsge: IprAlertMsg });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                $('#CancelItem-confirmation').modal('show')
            }
            else {
                let FilArrGridLN = []
                let FilArrGridCC = []
                let lnVal = value.LINE_NBR + 1;
                console.log("lnVal", lnVal)
                let GridArrResponse = [];
                GridArrResponse = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO)
                GridArrResponse.forEach((valueGrid, index) => {
                    if (FilArrGridLN.length == 0) {
                        FilArrGridLN = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO && x.ISA_INTFC_LN == value.LINE_NBR)
                        if (FilArrGridLN.length > 0) {
                            if (FilArrGridCC.length == 0) {
                                FilArrGridCC = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO && x.ISA_INTFC_LN == lnVal)
                                if (FilArrGridCC.length > 0) {
                                    FilArrGridCC.forEach((valueFilArr, index) => {
                                        if (valueFilArr.DESCR254.includes("Core Charges")) {
                                            FilArrGridLN.push(FilArrGridCC[0]);
                                        }
                                    })

                                }
                            }
                        }
                    }

                });
                let OrderNo = []
                let LineNumber = []
                if (value != null && value != "") {
                    OrderNo.push(value.ORDER_NO);
                }
                //[10/12/2022, PC_OS_03, WW - 401 Item Id is not displayed in email, if cancel one item from order, Dhevanesam R]
                if (FilArrGridLN.length > 0) {
                    FilArrGridLN.forEach((valueFil, index) => {
                        if (valueFil != null && valueFil != "") {
                            let Item_Id = "";
                            if (valueFil.LINEFIELD != "NSTK" && valueFil.LINEFIELD != "PCH") {
                                if (valueFil.INV_ITEM_ID != "" && valueFil.INV_ITEM_ID != null && valueFil.INV_ITEM_ID != " " && valueFil.INV_ITEM_ID != undefined) {
                                    Item_Id = valueFil.INV_ITEM_ID;
                                }
                                else if (valueFil.ITEM_ID_VEND != "" && valueFil.ITEM_ID_VEND != null && valueFil.ITEM_ID_VEND != " " && valueFil.ITEM_ID_VEND != undefined) {
                                    Item_Id = valueFil.ITEM_ID_VEND;
                                }
                                else {
                                    Item_Id = valueFil.ITEM_ID;
                                }
                            }
                            else {
                                Item_Id = valueFil.ITEM_ID;
                            }
                            // PC_WAL_1045_01-Add supplier id, supplier name and Poid for sending cancellation email-Priyanka D
                            LineNumber.push({
                                LineNo: valueFil.ISA_INTFC_LN.toString(),
                                ItemId: Item_Id,
                                LineStatus: valueFil.ISA_LINE_STATUS.toString(),
                                Supplier: valueFil.SUPPLIER,
                                SupplierID: valueFil.SUPPLIER_ID,
                                //WAL-1045-Details required for grid in mail-Priyanka D
                                SupplierPartNumber: valueFil.ITEM_ID,
                                Descr: valueFil.DESCR254,
                                Qty: valueFil.QTY_REQ,
                                PO_ID: valueFil.PO_ID,
                                PO_Line: valueFil.PO_LINE_NO,
                                WorkOrder: valueFil.ISA_WORK_ORDER_NO,
                                EnteredBy: valueFil.ISA_EMPLOYEE_ID.toString()
                            });
                        }
                    });
                }
                this.setState({ OrderNoList: OrderNo, LineNoList: LineNumber, OrderApprover: OrderApprover, IsLineLevel: true, IsConfirm: true, IprAlertMsge: "Do you want to cancel this item ?" });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                $('#CancelItem-confirmation').modal('show')
            }

        }
        else {

            let FilArrGrid = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO && x.ISA_LINE_STATUS != "CNC")
            let IprItems = [];
            IprItems = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO && x.ISA_LINE_STATUS == "IPR")
            let IprAlertMsg = ""
            if (IprItems.length > 0) {
                let OrdCount = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO).length;
                if (IprItems.length == OrdCount) {
                    IprAlertMsg = "All items of this order are in processing and cannot be cancelled currently. Please try again after sometime.";
                    this.setState({ IsLineLevel: false, IsConfirm: false, IprAlertMsge: IprAlertMsg });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    $('#CancelOrder-confirmation').modal('show');
                }
                else {
                    let OrderNo = []
                    let LineNumber = []
                    if (value != null && value != "") {
                        OrderNo.push(value.ORDER_NO);
                    }
                    if (FilArrGrid.length > 0) {
                        FilArrGrid.forEach((valueFil, index) => {
                            if (valueFil != null && valueFil != "") {
                                if (valueFil.ISA_LINE_STATUS != "IPR") {
                                    let Item_Id = "";
                                    if (valueFil.LINEFIELD != "NSTK" && valueFil.LINEFIELD != "PCH") {
                                        if (valueFil.INV_ITEM_ID != "" && valueFil.INV_ITEM_ID != null && valueFil.INV_ITEM_ID != " " && valueFil.INV_ITEM_ID != undefined) {
                                            Item_Id = valueFil.INV_ITEM_ID;
                                        }
                                        else if (valueFil.ITEM_ID_VEND != "" && valueFil.ITEM_ID_VEND != null && valueFil.ITEM_ID_VEND != " " && valueFil.ITEM_ID_VEND != undefined) {
                                            Item_Id = valueFil.ITEM_ID_VEND;
                                        }
                                        else {
                                            Item_Id = valueFil.ITEM_ID;
                                        }
                                    }
                                    else {
                                        Item_Id = valueFil.ITEM_ID;
                                    }
                                    LineNumber.push({
                                        // PC_WAL_1045_01-Add supplier id, supplier name and Poid for sending cancellation email-Priyanka D
                                        LineNo: valueFil.ISA_INTFC_LN.toString(),
                                        ItemId: Item_Id,
                                        LineStatus: valueFil.ISA_LINE_STATUS.toString(),
                                        Supplier: valueFil.SUPPLIER,
                                        SupplierID: valueFil.SUPPLIER_ID,
                                        //WAL-1045-Details required for grid in mail-Priyanka D
                                        SupplierPartNumber: valueFil.ITEM_ID,
                                        Descr: valueFil.DESCR254,
                                        Qty: valueFil.QTY_REQ,
                                        PO_ID: valueFil.PO_ID,
                                        PO_Line: valueFil.PO_LINE_NO,
                                        WorkOrder: valueFil.ISA_WORK_ORDER_NO,
                                        EnteredBy: valueFil.ISA_EMPLOYEE_ID.toString()
                                    });
                                }
                            }
                        });
                    }
                    if (IprItems.length == 1) {
                        let ItemId = IprItems[0].ITEM_ID != "" && IprItems[0].ITEM_ID != null ? IprItems[0].ITEM_ID : null;
                        IprAlertMsg = "The item " + ItemId + " is in processing and cannot be cancelled currently. Do you want to cancel other items of this order?";
                        this.setState({ OrderNoList: OrderNo, LineNoList: LineNumber, IsLineLevel: false, IsConfirm: true, IprAlertMsge: IprAlertMsg });
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        $('#CancelOrder-confirmation').modal('show');
                    }
                    else {
                        let ItemIds = "";
                        IprItems.forEach((valIpr, Iprindex) => {
                            if (valIpr.ISA_LINE_STATUS == "IPR") {
                                if (Iprindex == 0) {
                                    ItemIds = valIpr.ITEM_ID != "" && valIpr.ITEM_ID != null && valIpr.ITEM_ID != " " ? valIpr.ITEM_ID : null;
                                }
                                else {
                                    let ItemId = valIpr.ITEM_ID != "" && valIpr.ITEM_ID != null && valIpr.ITEM_ID != " " ? valIpr.ITEM_ID : null;
                                    ItemIds = ItemIds + ", " + ItemId
                                }
                            }
                        });

                        IprAlertMsg = "The items " + ItemIds + " are in processing and cannot be cancelled currently. Do you want to cancel other items of this order?";
                        this.setState({ OrderNoList: OrderNo, LineNoList: LineNumber, IsLineLevel: false, IsConfirm: true, IprAlertMsge: IprAlertMsg });
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        $('#CancelOrder-confirmation').modal('show');
                    }
                }
            }
            else {
                let OrderNo = []
                let LineNumber = []
                if (value != null && value != "") {
                    OrderNo.push(value.ORDER_NO);
                }
                if (FilArrGrid.length > 0) {
                    FilArrGrid.forEach((valueFil, index) => {
                        if (valueFil != null && valueFil != "") {
                            let Item_Id = "";
                            if (valueFil.LINEFIELD != "NSTK" && valueFil.LINEFIELD != "PCH") {
                                if (valueFil.INV_ITEM_ID != "" && valueFil.INV_ITEM_ID != null && valueFil.INV_ITEM_ID != " " && valueFil.INV_ITEM_ID != undefined) {
                                    Item_Id = valueFil.INV_ITEM_ID;
                                }
                                else if (valueFil.ITEM_ID_VEND != "" && valueFil.ITEM_ID_VEND != null && valueFil.ITEM_ID_VEND != " " && valueFil.ITEM_ID_VEND != undefined) {
                                    Item_Id = valueFil.ITEM_ID_VEND;
                                }
                                else {
                                    Item_Id = valueFil.ITEM_ID;
                                }
                            }
                            else {
                                Item_Id = valueFil.ITEM_ID;
                            }
                            LineNumber.push({
                                // PC_WAL_1045_01-Add supplier id, supplier name and Poid for sending cancellation email-Priyanka D
                                LineNo: valueFil.ISA_INTFC_LN.toString(),
                                ItemId: Item_Id,
                                LineStatus: valueFil.ISA_LINE_STATUS.toString(),
                                Supplier: valueFil.SUPPLIER,
                                SupplierID: valueFil.SUPPLIER_ID,
                                //WAL-1045-Details required for grid in mail-Priyanka D
                                SupplierPartNumber: valueFil.ITEM_ID,
                                Descr: valueFil.DESCR254,
                                Qty: valueFil.QTY_REQ,
                                PO_ID: valueFil.PO_ID,
                                PO_Line: valueFil.PO_LINE_NO,
                                WorkOrder: valueFil.ISA_WORK_ORDER_NO,
                                EnteredBy: valueFil.ISA_EMPLOYEE_ID.toString()
                            });
                        }
                    });
                }
                this.setState({ OrderNoList: OrderNo, LineNoList: LineNumber, IsLineLevel: false, IsConfirm: true, IprAlertMsge: "Do you want to cancel this order ?" });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                $('#CancelOrder-confirmation').modal('show')
            }

        }
    }
    //[2/2/2022, PC_OS_02, WW-350, Dhevanesam R]
    CancelItemPopUpOpen = (value, Levels) => {
        debugger
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (Levels == "Line") {
            let FilArrGridLN = []
            let FilArrGridCC = []
            let lnVal = value.LINE_NBR + 1
            console.log("lnVal", lnVal)
            let GridArrResponse = []
            GridArrResponse = this.state.GridArr.filter((x) => x.ORDER_NO == value.ORDER_NO)
            GridArrResponse.forEach((valueGrid, index) => {
                //debugger
                if (FilArrGridLN.length == 0) {
                    FilArrGridLN = this.state.GridArr.filter((x) => x.ORDER_NO == value.ORDER_NO && x.LINE_NBR == value.LINE_NBR)
                    if (FilArrGridLN.length > 0) {
                        //debugger
                        if (FilArrGridCC.length == 0) {
                            FilArrGridCC = this.state.GridArr.filter((x) => x.ORDER_NO == value.ORDER_NO && x.LINE_NBR == lnVal)
                            if (FilArrGridCC.length > 0) {
                                //debugger
                                FilArrGridCC.forEach((valueFilArr, index) => {
                                    if (valueFilArr.DESCR254.includes("Core Charges")) {
                                        FilArrGridLN.push(FilArrGridCC[0])
                                    }
                                })

                            }
                        }
                    }
                }

            });
            console.log("FilArrGridLN", FilArrGridLN)
            //debugger
            let OrderNo = []
            let LineNumber = []
            //debugger
            if (value != null && value != "") {
                OrderNo.push(value.ORDER_NO);
            }
            if (FilArrGridLN.length > 0) {
                FilArrGridLN.forEach((valueFil, index) => {
                    if (valueFil != null && valueFil != "") {
                        LineNumber.push({
                            LineNo: valueFil.LINE_NBR.toString(),
                            ItemId: valueFil.INV_ITEM_ID.toString(),
                            LineStatus: valueFil.ISA_LINE_STATUS.toString(),
                            WorkOrder: valueFil.ISA_WORK_ORDER_NO.toString(),
                            EnteredBy: valueFil.ISA_EMPLOYEE_ID.toString()
                        });
                    }
                });
            }
            console.log("OrderNo", OrderNo)
            console.log("LineNumber", LineNumber)
            this.setState({ OrderNoList: OrderNo, LineNoList: LineNumber, IsLineLevel: true });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#CancelItem-confirmation').modal('show')
        }
        else {
            //debugger
            let FilArrGrid = this.state.GridArr.filter((x) => x.ORDER_NO == value.ORDER_NO && x.ISA_LINE_STATUS != "CNC")
            let OrderNo = []
            let LineNumber = []
            //debugger
            if (value != null && value != "") {
                OrderNo.push(value.ORDER_NO);
            }
            if (FilArrGrid.length > 0) {
                FilArrGrid.forEach((valueFil, index) => {
                    //debugger
                    if (valueFil != null && valueFil != "") {
                        LineNumber.push({
                            LineNo: valueFil.LINE_NBR.toString(),
                            ItemId: valueFil.INV_ITEM_ID.toString(),
                            LineStatus: valueFil.ISA_LINE_STATUS.toString(),
                            WorkOrder: valueFil.ISA_WORK_ORDER_NO,
                            EnteredBy: valueFil.ISA_EMPLOYEE_ID.toString()
                        });
                    }
                });
            }
            console.log("OrderNo", OrderNo)
            console.log("LineNumber", LineNumber)
            this.setState({ OrderNoList: OrderNo, LineNoList: LineNumber, IsLineLevel: false });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#CancelOrder-confirmation').modal('show')
        }
    }
    //[2/2/2022, PC_OS_09, WW-350, Dhevanesam R]
    CancelItemClosePopUp = (Levels) => {
        //debugger
        if (Levels == "LineItem") {
            $('#CancelItem-confirmation').modal('hide');
        }
        else {
            $('#CancelOrder-confirmation').modal('hide');
        }
    }
    // Order Status Stored Procedure Integration Change - Deepthi
    HeaderDataResponse = () => {
        debugger
        let HeaderDataRespnse = JSON.parse(OrderStatusStore.HeaderData);
        let checkqty = false;

        let locHeaderDet = HeaderDataRespnse.v_result_set;
        //WW-1221 - To remove reordered and cancelled quote items -Vishwa S
        locHeaderDet = locHeaderDet.filter(val => val.ISA_LINE_STATUS !== 'RFC' && !(val.ISA_LINE_STATUS === 'RFR' || val.ISA_LINE_STATUS === 'RFX'));
        locHeaderDet.sort((a, b) => a.ISA_INTFC_LN - b.ISA_INTFC_LN);
        //WW-629 INC0015911 Need to prevent cancel order for sales orders that have already been picke-Deepthi
        let cancelBtnList = HeaderDataRespnse.CancelBtnFlags;
        let showReasonPopup = HeaderDataRespnse.CancelStatusFlags;
        let coreReturnList = HeaderDataRespnse.coreReturnFlags;
        let locshowReasonPopup = "";
        let locCancelBtnStatuses = "";
        let coreReturns = [];
        if (cancelBtnList != undefined && cancelBtnList != null) {
            locCancelBtnStatuses = cancelBtnList[0].CancelBtnRow;
        }
        if (showReasonPopup != undefined && showReasonPopup != null) {
            locshowReasonPopup = showReasonPopup[0].CancelStatusRow;
        }
        if (coreReturnList != undefined && coreReturnList != null) {
            coreReturns = coreReturnList[0].coreReturnStatus;
        }
        if (locHeaderDet.length > 0) {
            let count = locHeaderDet.length;

            let linecount = locHeaderDet.length;
            let uniqueorder = locHeaderDet.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === v.ORDER_NO.trim().toUpperCase())) === i);
            let ordercount = uniqueorder.length;
            let pg = Math.ceil((ordercount > 0 ? ordercount : 0) / this.state.RecCount);
            let total = count > 0 ? count : 0;
            locHeaderDet.forEach((value, index) => {

                value.checked = false;
                value.hasCoreCharge = false;
                value.hasBenItemVal = "";
                value.InvItemQtyCheck = false;
                if (value.DESCR254.includes("Core Charges")) {
                    value.hasCoreCharge = true;
                }
            });
            //1898 - Unable to add Items from different pages through buy again - Deepthi 
            let Buyagaindata = this.state.BuyAgainArray
            if (Buyagaindata.length > 0) {
                Buyagaindata.forEach((Buyvalue, index) => {
                    locHeaderDet.forEach((value, index) => {
                        if (value.ORDER_NO === Buyvalue.ORDER_NO && value.LINE_NBR == Buyvalue.LINE_NBR) {
                            value.checked = true;
                        }
                    });
                });
            }

            // if (localStorage.getItem("StoreValue") != undefined || localStorage.getItem("StoreValue") != null) {
            //BenStoreVal = JSON.parse(localStorage.getItem("StoreValue"));
            let warehouse_item = locHeaderDet.filter((x) => x.SUPPLIER_ID == "W999999999")
            let loacalloc = JSON.parse(localStorage.getItem("StoreValue"))

            if (warehouse_item.length > 0) {
                checkqty = true;
            }
            if (checkqty) {
                let itemids = []
                warehouse_item.map((val, index) => {
                    //debugger
                    itemids.push(val.INV_ITEM_ID)
                });
                if (itemids.length > 0) {
                    //debugger
                    let BO = {
                        shipto_id: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//loacalloc, WAL-767-Aparna
                        supplier_part_number: itemids,
                        User_Id: CookieService.getLocalStorageValues("Session_UserID")
                    }
                    //debugger
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ShoppingCartAction.WarehouseQTYCheck(BO)
                }

            }
            //}
            this.setState({ OrdertotalCount: ordercount, totalCount: ordercount, pageCount: pg, HeaderGridArray: locHeaderDet, HeaderUniqueGridArray: uniqueorder, isExpand: false, ApplyFilterClick: true, LineDetailsGrid: [], cancelBtnStatuses: locCancelBtnStatuses, showReasonPopup: locshowReasonPopup, coreReturns: coreReturns });

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Data Not Found"
            });
            // alert("Data Not Found");
            this.setState({ OrdertotalCount: 0, totalCount: 0, pageCount: 0, HeaderGridArray: [], HeaderUniqueGridArray: [], isExpand: false, ApplyFilterClick: true, LineDetailsGrid: [] });
        }


    }

    //[2/2/2022, PC_OS_08, WW-350, Dhevanesam R]
    CancelRequestResponse = () => {
        let Orderlist = this.state.OrderNoList;
        let OrderNo = Orderlist[0];
        let HeaderGridArr = this.state.HeaderGridArray;
        //[10/7/22], WW-526, PC_OS_01, Dhevanesam R
        let LineGridArr = this.state.LineDetailsGrid;
        console.log("OrderStatusStore.PassThroughAuthe", OrderStatusStore.CancelRequest)
        /*[03/17/23, OS_PC_10-3178], Priyanka D-Returning order status */
        let cancelResponse = JSON.parse(OrderStatusStore.CancelRequest);
        let CancelRequest = cancelResponse[0].result
        let OrderStatus = cancelResponse[0].ORD_STATUS
        if (CancelRequest == "Success") {
            $('#CanceledItemReason').modal('hide');
            $('#CanceledItemSuccess').modal('show');
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            //[10/11/22], Bug - 2724, PC_OS_01, Dhevanesam R
            if (this.state.IsLineLevel == false) {
                HeaderGridArr.forEach((val) => {

                    if (val.ORDER_NO == OrderNo) {
                        val.ORDER_STATUS = OrderStatus;
                        if (val.ISA_LINE_STATUS != "IPR") {
                            if (val.ISA_LINE_STATUS != "CRE" && val.ISA_LINE_STATUS != "QTS" && val.ISA_LINE_STATUS != "QTW" && val.ISA_LINE_STATUS != "CNC") {
                                val.ISA_LINE_STATUS = "PNC";
                            }
                            else {
                                val.ISA_LINE_STATUS = "CNC";
                                val.LINE_STATUS = "CNC";
                            }
                            val.HEADER_NOTES = true;
                        }
                    }
                });
                this.setState({ HeaderGridArray: HeaderGridArr });
            }
            else {
                let LineList = this.state.LineNoList;
                let lineitems = HeaderGridArr.filter((x) => x.ORDER_NO == OrderNo);
                //[10/11/22], Bug - 2724, PC_OS_01, Dhevanesam R
                if (lineitems.length == 1) {
                    HeaderGridArr.forEach((val) => {
                        if (val.ORDER_NO == OrderNo) {
                            val.ORDER_STATUS = OrderStatus;
                            if (val.ISA_LINE_STATUS != "CRE" && val.ISA_LINE_STATUS != "QTS" && val.ISA_LINE_STATUS != "QTW" && val.ISA_LINE_STATUS != "CNC") {
                                val.ISA_LINE_STATUS = "PNC";
                            }
                            else {
                                val.ISA_LINE_STATUS = "CNC";
                                val.LINE_STATUS = "CNC";
                            }
                        }
                    });
                }
                else {
                    let FilArrGrid = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == this.state.OrderNoList[0] && x.ISA_INTFC_LN == this.state.LineNoList[0].LineNo);
                    let HeaderArraySplice = [];
                    let OrderfilteredItem = [];
                    let HeaderStatusArr = [];
                    if (FilArrGrid.length > 0) {
                        HeaderGridArr.forEach((itemarray, indexarray) => {
                            if (FilArrGrid[0].ISA_INTFC_LN == itemarray.ISA_INTFC_LN) {
                                HeaderArraySplice.push(itemarray);
                            }
                        });
                    }
                    HeaderArraySplice.forEach((val) => {
                        if (val.ORDER_NO == OrderNo) {
                            val.ORDER_STATUS = OrderStatus;
                            if (val.ISA_LINE_STATUS != "CRE" && val.ISA_LINE_STATUS != "QTS" && val.ISA_LINE_STATUS != "QTW" && val.ISA_LINE_STATUS != "CNC") {
                                val.ISA_LINE_STATUS = "PNC";
                            }
                            else {
                                val.ISA_LINE_STATUS = "CNC";
                                val.LINE_STATUS = "CNC";
                            }
                        }
                    });

                    HeaderGridArr.forEach((val) => {
                        if (val.ORDER_NO == OrderNo) {
                            val.ORDER_STATUS = OrderStatus;
                        }
                    });

                }
                this.setState({ HeaderGridArray: HeaderGridArr });
            }
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue. Please contact SDI Customer care"
            });
            //alert("Technical issue in sending the mail")
            $('#CanceledItemSuccess').modal('hide');
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    }
    //[2/2/2022, PC_OS_10, WW-350, Dhevanesam R]
    CancelItemSuccessClosePopUp = () => {
        //debugger
        $('#CanceledItemSuccess').modal('hide');
    }
    //[2/2/2022, PC_OS_16, WW-350, Dhevanesam R]
    CancelItemReasonClosePopUp = () => {
        this.setState({ CancelItemReasonText: "", CancelItemReasonDrop: "Select", inValidComments: false });
        $('#CanceledItemReason').modal('hide');

    }
    //[2/2/2022, PC_OS_11, WW-350, Dhevanesam R]
    CancelItemReasonConfirmPopUp = () => {
        let CancelDrop = this.state.CancelItemReasonDrop
        let CancelText = this.state.CancelItemReasonText
        if (CancelText && CancelText.length < 5) {
            this.setState({ inValidComments: true })
        }
        else {
            let displayName = "";
            if (CookieService.getLocalStorageValues("Session_USERNAME")) {
                displayName = CookieService.getLocalStorageValues("Session_USERNAME").indexOf(",") >= 0 ? CookieService.getLocalStorageValues("Session_USERNAME").split(",")[1] + " " + CookieService.getLocalStorageValues("Session_USERNAME").split(",")[0] : CookieService.getLocalStorageValues("Session_USERNAME");
                if (CookieService.getLocalStorageValues("Session_AGENTUSERID") != "" && CookieService.getLocalStorageValues("Session_AGENTUSERID")) {
                    if (CookieService.getLocalStorageValues("Session_USERTYPE") == "ADMINX") {
                        displayName = displayName + CookieService.getLocalStorageValues("Session_CONAME");
                    } else {
                        displayName = displayName + CookieService.getLocalStorageValues("Session_AGENTUSERNAME");
                    }
                }
            };
            if (CancelDrop == "Other, please describe") {
                CancelDrop = CancelText
                CancelText = "";
            }
            let CancelRequestBO = {
                OrderNoList: this.state.OrderNoList,
                ItemLevel: this.state.IsLineLevel,
                ItemList: this.state.LineNoList,
                Reason: CancelDrop == "Select" ? "": CancelDrop,
                Name: displayName,
                OrderApprover: this.state.OrderApprover,
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                UserId: CookieService.getLocalStorageValues("Session_UserID"),
                BU: CookieService.getLocalStorageValues("Session_BUSUNIT") != undefined && CookieService.getLocalStorageValues("Session_BUSUNIT") != null && CookieService.getLocalStorageValues("Session_BUSUNIT") != "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
                comments: CancelText
            };
            this.setState({ CancelItemReasonText: "", CancelItemReasonDrop: "Select", inValidComments: false });
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            OrderStatusAction.CancelRequest(CancelRequestBO);
        }
    }
    //[2/2/2022, PC_OS_16, WW-350, Dhevanesam R]
    getReasonText = (e) => {
        //debugger
        let ReasonVal = e.target.value;
        this.setState({ CancelItemReasonText: ReasonVal });
    }
    //[2/2/2022, PC_OS_16, WW-350, Dhevanesam R]
    handleReasonChange = (e) => {
        //debugger
        this.setState({ CancelItemReasonDrop: e.target.value });

    }
    // Order Status Stored Procedure Integration Change - Deepthi
    LineDataResponse = () => {
        debugger
        let LineResponse = JSON.parse(OrderStatusStore.LineData)
        let locgrid = LineResponse.v_result_set;
        let locASNdet = LineResponse.v_asn_result;
        let imgArr = LineResponse.v_fragile_data;
        let linegrid = [];

        if (locgrid.length > 0) {
            locgrid.forEach((x) => {
                let linedetails = this.state.HeaderGridArray.filter(line => {
                    return line.ORDER_NO == x.ORDER_NO && line.ISA_INTFC_LN == x.LINE_NBR;
                });
                if (linedetails.length > 0) {
                    let matchedLine = linedetails[0];
                    // Create a new object including the checked property
                    let lineWithChecked = {
                        ...x, // Spread properties from x
                        checked: matchedLine.checked // Add the checked property from the matched line
                    };
                    linegrid.push(lineWithChecked);
                }
            });
        }
        if (OrderLevelQuoteClick) {
            this.reorderQuote(linegrid);
        }

        this.setState({ LineDetailsGrid: linegrid, ASNdetails: locASNdet, fragileImgDetail: imgArr });
    }

    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    selectQuoteOrder = (value) => {
        debugger
        let locGridArr = this.state.HeaderGridArray;
        let locOrderQuote = this.state.OrderQuoteArray;
        let filterArr;
        //let locOrderQuoteCheckedArray;

        if (locOrderQuote.length > 0) {
            filterArr = locOrderQuote.findIndex(t => (t.ORDER_NO === value.ORDER_NO && t.LINE_NBR == value.LINE_NBR));
            //locOrderQuoteCheckedArray = locOrderQuote.filter(t => (t.ORDER_NO === value.ORDER_NO && t.LINE_NBR == value.LINE_NBR));
        };

        let I = locGridArr.findIndex(t => (t.ORDER_NO === value.ORDER_NO && t.ISA_INTFC_LN == value.LINE_NBR));
        locGridArr[I].checked = locGridArr[I].checked == true ? false : locGridArr[I].checked == false ? true : true;
        //A1QA-248_PC_05 (11/16/2022)-Aparna
        let NextIndex = I + 1;
        let LochasCoreCharge = false
        if (locGridArr[NextIndex] != null && locGridArr[NextIndex] != undefined) {
            if (locGridArr[NextIndex].hasCoreCharge == true) {
                LochasCoreCharge = true
            }
        }
        if (locGridArr[I].checked == true) {
            if (filterArr == -1 || filterArr == undefined) {
                let orderQuoteObj = {
                    ORDER_NO: value.ORDER_NO,
                    BUSINESS_UNIT_OM: 'I0W01',
                    INV_ITEM_ID: value.ITEM_ID,
                    QTY_REQ: value.QTY_REQ,
                    LINE_NBR: value.LINE_NBR,
                    ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM,
                    MFG_ITM_ID: value.MFG_ITM_ID,
                    DESCR254: locGridArr[I].DESCR254,
                    ISA_SELL_PRICE: value.ISA_SELL_PRICE,
                    ITEM_CAT: value.ITEM_CAT,
                    checked: locGridArr[I].checked,
                    HASCORECHARGE: LochasCoreCharge,
                    PaintColor: value.LINE_FIELD_C6
                }
                locOrderQuote.push(orderQuoteObj);
            }

        }
        else {
            let Index = this.state.OrderQuoteArray.findIndex(t => (t.ORDER_NO === value.ORDER_NO && t.ISA_INTFC_LN == value.LINE_NBR));
            this.state.OrderQuoteArray.splice(Index, 1);
            locOrderQuote = this.state.OrderQuoteArray;
        }

        // To Update the LineDetailsGrid checked property
        let locLineDetailsGrid = this.state.LineDetailsGrid;
        locGridArr.forEach(gridItem => {
            let lineDetailIndex = locLineDetailsGrid.findIndex(lineItem =>
                (lineItem.ORDER_NO === gridItem.ORDER_NO && lineItem.LINE_NBR === gridItem.ISA_INTFC_LN)
            );
            if (lineDetailIndex !== -1) {
                locLineDetailsGrid[lineDetailIndex].checked = gridItem.checked;
            }
        });

        this.setState({ OrderQuoteArray: locOrderQuote, HeaderGridArray: locGridArr, LineDetailsGrid: locLineDetailsGrid });

    }

    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    handleEquipmentYes = () => {
        $('#MixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        this.addFavItemsToCart(this.state.CoreCharge, this.state.Proceed);
    };
    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    handleEquipmentNo = () => {
        $('#MixedOrderConfirmPopup').modal('hide');
        cartDelete = false;
    };
    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    reorderQuote = (linegrid) => {
        let locOrderQuote = [];
        let locGridArr = this.state.HeaderGridArray;
        //let orderdetails = this.state.HeaderGridArray.filter(line => {
        //    return line.ORDER_NO === val.ORDER_NO;
        //});

        linegrid.forEach(value => {
            // To update the checked property of looped items to HeaderGridArray
            let I = locGridArr.findIndex(t => (t.ORDER_NO === value.ORDER_NO && t.ISA_INTFC_LN == value.LINE_NBR));
            locGridArr[I].checked = true;

            let NextIndex = I + 1;
            let LochasCoreCharge = false
            if (locGridArr[NextIndex] != null && locGridArr[NextIndex] != undefined) {
                if (locGridArr[NextIndex].hasCoreCharge == true) {
                    LochasCoreCharge = true
                }
            }

            let orderQuoteObj = {
                ORDER_NO: value.ORDER_NO,
                BUSINESS_UNIT_OM: 'I0W01',
                INV_ITEM_ID: value.ITEM_ID,
                QTY_REQ: value.QTY_REQ,
                LINE_NBR: value.LINE_NBR,
                ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM,
                MFG_ITM_ID: value.MFG_ITM_ID,
                DESCR254: value.DESCR254,
                ISA_SELL_PRICE: value.ISA_SELL_PRICE,
                ITEM_CAT: value.ITEM_CAT,
                checked: true,
                HASCORECHARGE: LochasCoreCharge,
                PaintColor: value.LINE_FIELD_C6
            };
            locOrderQuote.push(orderQuoteObj);
        });
        let nonCoreItems = locOrderQuote.filter(item => !item.INV_ITEM_ID.startsWith('Core -'));
        locOrderQuote = nonCoreItems;

        // To Update the LineDetailsGrid checked property
        let locLineDetailsGrid = linegrid;
        this.state.HeaderGridArray.forEach(gridItem => {
            let lineDetailIndex = locLineDetailsGrid.findIndex(lineItem =>
                (lineItem.ORDER_NO === gridItem.ORDER_NO && lineItem.LINE_NBR === gridItem.ISA_INTFC_LN)
            );
            if (lineDetailIndex !== -1) {
                locLineDetailsGrid[lineDetailIndex].checked = true;
            }
        });

        this.setState({ OrderQuoteArray: locOrderQuote, HeaderGridArray: locGridArr, LineDetailsGrid: locLineDetailsGrid, BuyAgainArray: [] }, () => {
            this.addFavItemsToCart(false, false);
        });
        OrderLevelQuoteClick = false;
    };

    onClickTrackDet = (asnArray) => {
        this.setState({ ASNlineData: asnArray });
        $('#tracking-details').modal('show');
    }
    Reprint = (linedetails, headerdetails) => {
        let ReprintBO = {
            ORDER_NO: linedetails.ORDER_NO,
            LINE_NBR: linedetails.LINE_NBR,
            PO_ID: linedetails.PO_ID1,
            Track_No: linedetails.CORE_TRACK_NO,
            TrackingURL: linedetails.CORE_TRACKINGURL,
            Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.reprintAction(ReprintBO)
    }
    getReturnData = (linedetails, headerdetails) => {
        if (CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" && CookieService.getLocalStorageValues("HOME_STORE") != " ") {
            this.setState({ Return_Order_No: linedetails.ORDER_NO, Return_Line_ln: linedetails.LINE_NBR, Return_UOM: linedetails.UOM, Return_QTY_REQ: linedetails.QTY_REQ, Return_Desc: linedetails.DESCR254, Return_SupplierID: linedetails.SUPPLIERID, Return_PO_ID: headerdetails.PO_ID, Return_PO_Line: headerdetails.PO_LINE_NO, Return_Sch_No: headerdetails.SCHED_NBR });
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            OrderStatusAction.getReturnDataAction()
        } else {
            if (CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" || CookieService.getLocalStorageValues("Session_USERTYPE") == "CORPADMIN") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select home store from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Orderstatus' }
                });
                return;
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please contact your manager for setting up the home store"
                });
                return;
            }
        }
    }
    ReprintResponse = () => {
        let reprintSuccess = OrderStatusStore.ReprintResponse;

        if (reprintSuccess != "Success") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in reprinting the details"
            });
        } else {
            this.setState({ reprintSuccessmsg: "The tracking details and shipping label has been sent to your mail" })
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#ReprintSucess').modal('show');

        }
    }
    SubmitReturnRespone = () => {
        let LineDetailsGrid = this.state.LineDetailsGrid
        let ASNdetails = this.state.ASNdetails
        let SubmitReturnResponse = JSON.parse(OrderStatusStore.SubmitReturn);
        if (SubmitReturnResponse.ErrorMsg) {
            if (SubmitReturnResponse.ErrorMsg.toUpperCase() == "SUCCESS") {
                $('#coreDetails').modal('hide');
                if (SubmitReturnResponse.trackingNumber != null && SubmitReturnResponse.trackingNumber != undefined && SubmitReturnResponse.trackingNumber != "" && SubmitReturnResponse.trackingNumber != " ") {
                    LineDetailsGrid.map((value, index) => {
                        if (value.ORDER_NO == this.state.Return_Order_No && value.LINE_NBR == this.state.Return_Line_ln) {
                            value.CORE_TRACK_NO = SubmitReturnResponse.trackingNumber;
                            value.CORE_TRACKINGURL = SubmitReturnResponse.trackingURL
                            value.SHIP_DATE = SubmitReturnResponse.ship_date
                        }
                    })
                    ASNdetails.map((value, index) => {
                        if (value.ORDER_NUMBER == this.state.Return_Order_No && value.LINE_NO == this.state.Return_Line_ln) {
                            value.TRACKING_NUMBER = SubmitReturnResponse.trackingNumber;
                            value.SHIP_QTY = this.state.Return_QTY_REQ;
                            value.SHIP_DATE = "-";
                            value.SHIP_STATUS = "-";
                        }
                    })
                    this.setState({ returnTrackingNumber: SubmitReturnResponse.trackingNumber, LineDetailsGrid, ASNdetails: ASNdetails, coreResponseErr: "" })
                    $('#submitreturnresponse').modal('show');
                } else {
                    $('#coreDetails').modal('show');
                    this.setState({ coreResponseErr: "Error in generating tracking number" })
                }
            } else {
                $('#coreDetails').modal('show');
                this.setState({ coreResponseErr: SubmitReturnResponse.ErrorMsg })
            }
        } else {
            $('#coreDetails').modal('show');
            this.setState({ coreResponseErr: "Error occured in generating label" })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    coreDetailsResponse = () => {
        let coreDetails = JSON.parse(OrderStatusStore.coreDetailsResponse);
        let ServiceTypeDt = coreDetails.ServiceType
        let PackageTypeDt = coreDetails.PackageType
        let ErrorDt = coreDetails.ErrorTable
        let pckType = [];
        if (ErrorDt != null && ErrorDt != undefined) {
            if (ErrorDt[0] != undefined && ErrorDt[0] != null) {
                if (ErrorDt[0].lblerror != null && ErrorDt[0].lblerror != "" && ErrorDt[0].lblerror != " ") {
                    this.setState({ coreError: "ErrorDt[0].lblerror" })
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: ErrorDt[0].lblerror
                    });
                } else {
                    PackageTypeDt.map((value, index) => {
                        let UOM = value.DESCR1.split("/")
                        if (UOM[0] != undefined && UOM[0] != null) {
                            UOM[0] = UOM[0].replace("lbs", "").trim()
                        }
                        let locArray = {
                            label: value.DESCR,
                            value: value.PACKAGEID,
                            lbs: parseInt(UOM[0])
                        }
                        pckType.push(locArray)
                    })
                    this.setState({ packageTypes: pckType, serviceTypes: ServiceTypeDt })
                    this.clearCoreDetails()
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    $('#coreDetails').modal('show');
                }
            } else {
                PackageTypeDt.map((value, index) => {
                    let UOM = value.DESCR1.split("/")
                    if (UOM[0] != undefined && UOM[0] != null) {
                        UOM[0] = UOM[0].replace("lbs", "").trim()
                    }
                    let locArray = {
                        label: value.DESCR,
                        value: value.PACKAGEID,
                        lbs: parseInt(UOM[0])
                    }
                    pckType.push(locArray)
                })
                this.setState({ packageTypes: pckType, serviceTypes: ServiceTypeDt })
                this.clearCoreDetails()
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                $('#coreDetails').modal('show');
            }
        } else {
            PackageTypeDt.map((value, index) => {
                let UOM = value.DESCR1.split("/")
                if (UOM[0] != undefined && UOM[0] != null) {
                    UOM[0] = UOM[0].replace("lbs", "").trim()
                }
                let locArray = {
                    label: value.DESCR,
                    value: value.PACKAGEID,
                    lbs: parseInt(UOM[0])
                }
                pckType.push(locArray)
            })
            this.setState({ packageTypes: pckType, serviceTypes: ServiceTypeDt })
            this.clearCoreDetails()
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#coreDetails').modal('show');
        }
    }
    handlePickupType = (isDropOff) => {
        this.setState({ isDropOff: isDropOff })
    }
    clearCoreDetails = () => {
        this.setState({ isDropOff: true, selectedService: "PRIORITY_OVERNIGHT", selectedPackage: [], filteredPackage: [], weightText: "", selectedShipdate: "", coreResponseErr: "" })
    }
    bindServiceType = () => {
        debugger
        return this.state.serviceTypes.map((value, index) => {
            return (
                <label className="custom-radiobtn pb-3 mb-0" for={`serviceType-${value.ISA_CONTAINER_ID}`}>{value.DESCR}
                    <input type="radio" name="serviceTypes" checked={this.state.selectedService == value.ISA_CONTAINER_ID} id={`serviceType-${value.ISA_CONTAINER_ID}`} onClick={(e) => this.handleServiceType(value.DESCR, value.ISA_CONTAINER_ID)} />
                    <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                </label>
            );
        })
    }
    handlePackage = (packageType) => {
        this.setState({ selectedPackage: packageType })
    }
    weightChange = (e) => {
        let re = SDIConstants.numberRegEX;
        let weightText = this.state.weightText
        let greaterWeight = false
        if (re.test(e.target.value) || e.target.value == "") {
            let maxLength = parseFloat(e.target.value);
            if (maxLength || e.target.value == "" || maxLength == 0) {
                if (maxLength > 150) {
                    greaterWeight = true
                    weightText = e.target.value;
                } else {
                    weightText = e.target.value;
                }
                let filteredPackage = this.state.packageTypes.filter((x) => parseFloat(x.lbs) >= parseFloat(e.target.value))
                this.setState({ weightText: weightText, greaterWeight, filteredPackage: filteredPackage, selectedPackage: [] })
            }
        }

        //let isNumber=/^\d+$/.test(e.target.value)
        //if (isNumber) {
        //    if (parseInt(e.target.value) <= 150) {
        //        let filteredPackage = this.state.packageTypes.filter((x) => parseInt(x.lbs) >= parseInt(e.target.value))
        //        this.setState({ weightText: parseInt(e.target.value), filteredPackage: filteredPackage, selectedPackage: [] })
        //    } else{
        //        this.setState({greaterWeight:true})
        //    }
        //} else {
        //    this.setState({ filteredPackage: [], selectedPackage: [], greaterWeight: false})
        //}
    }
    bindPackageType = () => {
        if (this.state.filteredPackage.length > 0 && !parseFloat(this.state.weightText) <= 0) {
            let filteredPackage = this.state.filteredPackage
            return (
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                    <div class="row">
                        <label id="package-type" class="col-md-3 font-14 font-medium text-black px-0 mandatory-after">Package Type</label>
                        <div class="col-md-8 px-0">
                            <Select
                                className="DropDown-Font-Size"
                                options={filteredPackage}
                                value={this.state.selectedPackage}
                                onChange={e => this.handlePackage(e)}
                            />
                        </div>
                    </div>
                </div>
            );
        } else if (this.state.greaterWeight || parseFloat(this.state.weightText) <= 0) {
            return (
                <span className="float-left err-msg text-danger mb-5">Weight should be between 0 lbs and 150 lbs</span>
            );
        }
    }
    handleShipDate = (e) => {
        this.setState({ selectedShipdate: e })
    }
    handleServiceType = (desc, containerId) => {
        this.setState({ selectedService: containerId })
    }
    SubmitReturn = () => {
        $('#coreDetails').modal('hide');
        debugger
        let street = CookieService.getLocalStorageValues("Address2");
        if (CookieService.getLocalStorageValues("Address3") != "") {
            street = CookieService.getLocalStorageValues("Address2") + " " + CookieService.getLocalStorageValues("Address3");
        }
        let street1 = "", street2 = "", street3 = "";
        let ShipperStreetLines = [], RecStreetLines = [];
        if (street.length > 30) {
            let SpaceSplit = street.split(" ");
            if (SpaceSplit.length > 0) {
                let concatstreet1 = "", concatstreet2 = "";
                SpaceSplit.forEach((x, ind) => {
                    if (ind == 0) {
                        concatstreet1 = x;
                        street1 = x;
                    }
                    else {
                        concatstreet1 = street1 + " " + x;
                        if (street2 == "") {
                            concatstreet2 = x;
                        } else {
                            concatstreet2 = street2 + " " + x;
                        }
                        if (concatstreet1.length <= 30) {
                            street1 += " " + x;
                        }
                        else if (concatstreet2.length <= 30) {
                            if (street2 == "") {
                                street2 = x;
                            } else {
                                street2 = street2 + " " + x;
                            }
                        }
                        else {
                            if (street3 == "") {
                                street3 = x;
                            }
                            else {
                                street3 += " " + x;
                            }

                        }
                        concatstreet1 = "";
                        concatstreet2 = "";
                    }

                })
            }
            ShipperStreetLines.push(street1);
            if (street2.length > 0) {
                ShipperStreetLines.push(street2);
            }
            if (street3.length > 0) {
                ShipperStreetLines.push(street3);
            }
        }
        else {
            street1 = street;
            ShipperStreetLines.push(street1);
        }

        let address = {
            streetLines: ShipperStreetLines,
            city: CookieService.getLocalStorageValues("City"),
            stateOrProvinceCode: CookieService.getLocalStorageValues("Session_STATE"),
            postalCode: CookieService.getLocalStorageValues("Postal_Code"),
            countryCode: "US"
        }
        let contact = {
            personName: CookieService.getLocalStorageValues("Session_USERNAME"),
            phoneNumber: CookieService.getLocalStorageValues("Session_PHONE")
        }
        let shipper = {
            contact: contact,
            address: address
        }
        let PackageLineItems = []
        let weight = {
            value: parseFloat(this.state.weightText),
            units: "LB"
        }
        let lineItems = {
            weight: weight,
            packagingType: this.state.selectedPackage
        }
        const dateString = this.state.selectedShipdate;
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');
        const day = String(dateObject.getDate()).padStart(2, '0');
        const dateOnly = `${year}-${month}-${day}`;
        PackageLineItems.push(lineItems);
        let RequestedShipment = {
            shipper: shipper,
            shipDatestamp: dateOnly,
            serviceType: this.state.selectedService,
            packagingType: this.state.selectedPackage.value,
            pickupType: (this.state.isDropOff ? "DROPOFF_AT_FEDEX_LOCATION" : "USE_SCHEDULED_PICKUP"),
            requestedPackageLineItems: PackageLineItems
        }

        let SubmitReturnBO = {
            RequestedShipment: RequestedShipment,
            BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            User_ID: CookieService.getLocalStorageValues("Session_UserID"),
            User_Email: CookieService.getLocalStorageValues("Session_EMAIL"),
            Order_No: this.state.Return_Order_No,
            Line_No: this.state.Return_Line_ln,
            UOM: this.state.Return_UOM,
            QTY_REQ: this.state.Return_QTY_REQ,
            DESCR254: this.state.Return_Desc,
            PO_ID: this.state.Return_PO_ID,
            PO_LINE_NO: this.state.Return_PO_Line,
            SCHED_NBR: this.state.Return_Sch_No,
            Supplier_ID: this.state.Return_SupplierID,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.SubmitReturnAction(SubmitReturnBO)
    }
    CopyMessage = () => {
        Copy(this.state.returnTrackingNumber);
        MenuAction.CopyMessage();
    }
    bindAttachments = () => {
        const { t } = this.props;
        return (
            <>
            {this.state.pdfarray.map((val, index) => (
                    <div className="col-md-6 mb-3" key={index}>
                        <div className="doc-parent">
                             <img src="images/pdf-file-icon.svg" alt="close-icon" />
                             <div className="doc-content">
                                 <p className="font-12 font-regular mb-0">
                                     {t('Document') + ' - ' + (index + 1)}
                                  </p>
                            <a
                                href={val}
                                     className="font-10"
                                     name={t('Document') + ' - ' + (index + 1)}
                                     download
                                target="_blank"
                                  >
                                  <Trans>Download</Trans>
                                   </a>
                              </div>
                        </div>
                     </div>
              ))
             }
                      
            </>
        );
    };

    displayAttachments = (e,Doc) => {
        e.preventDefault();
        this.setState({ pdfarray: Doc })
        $('#Attachments').modal('show');
    }
    // Order Status Stored Procedure Integration Change - Deepthi
    bindLineGriddata = (OrderNo, ind) => {
        debugger
        //WW-1352 To find the login user is third party - Nandhini L
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;

        if (this.state.LineDetailsGrid.length > 0) {
            return this.state.LineDetailsGrid.map((value, index) => {
                let showCoreReturns = false;
                let checkboxL = false;
                let lable = "Ship To";
                let imagePath = "";
                let status = "";
                let st = "";
                let color = "";
                let apoinfo = "";
                let tracking_num = "-";
                let tracking_link = "-";
                let carrier = "-";
                let IMG_URL = "";
                let tracklist = "";
                let FreightProv = "";
                let trackshipvia = "";
                let SignedBy = "-";
                let currentItem = value.MFG_ITM_ID;
                let currentImgArr = [];
                if (this.state.fragileImgDetail != undefined) {
                    if (this.state.fragileImgDetail.length > 0) {
                        currentImgArr = this.state.fragileImgDetail.filter(item => item.MFG_ITM_ID == currentItem);
                    }
                }
                //WW-629 INC0015911 Need to prevent cancel order for sales orders that have already been picke-Deepthi
                let locASNdet = [];
                let hasCancelStatus = false;

                let cancelBtnStatuses = this.state.cancelBtnStatuses;
                if (cancelBtnStatuses.includes(value.ISA_LINE_STATUS)) {
                    hasCancelStatus = true;
                }
                let linedetails = this.state.HeaderGridArray.filter(line => {
                    return line.ORDER_NO == value.ORDER_NO && line.ISA_INTFC_LN == value.LINE_NBR;
                });
                if (this.state.ASNdetails.length > 0) {
                    locASNdet = this.state.ASNdetails.filter(asn => {
                        return asn.ORDER_NUMBER == value.ORDER_NO && asn.LINE_NO == value.LINE_NBR;
                    });
                }
                let hasTrackingNumber = false;
                if (locASNdet.length > 0) {
                    hasTrackingNumber = locASNdet[0].TRACKING_NUMBER != null && locASNdet[0].TRACKING_NUMBER != "" && locASNdet[0].TRACKING_NUMBER != " " && locASNdet[0].TRACKING_NUMBER != undefined ? true : false;
                }

                let disp = linedetails[0].SHIPTO_ID;
                //let linedetails = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO && x.ISA_INTFC_LN == value.LINE_NBR);
                let NextAppr = this.state.EmpIdDropDown.filter((x) => x.value == value.NEXT_APPR)
                let NA = ""
                let nxt
                if (NextAppr.length > 0) {
                    if (NextAppr[0].value != undefined) {
                        nxt = NextAppr[0].label.split("-")
                        NA = nxt[0]
                    }

                }
                else {
                    if (value.NEXT_APPR == CookieService.getLocalStorageValues("Session_UserID")) {
                        NA = CookieService.getLocalStorageValues("Session_USERNAME")
                    }
                }
                if (linedetails[0].APOINFO != null && linedetails[0].APOINFO != undefined) {
                    apoinfo = linedetails[0].APOINFO.split(',');
                    tracklist = linedetails[0].APOINFO.split(',');
                    //WW-550 - Scott made changes in Get_Ord_Stat_Tracking_Det function, so reverted back - Deepthi N H
                    if (apoinfo[9] != "" && apoinfo[9] != undefined && apoinfo[9] != null) {
                        if (apoinfo[9].trim().length > 0) { tracking_num = apoinfo[9]; }
                    }
                    if (apoinfo[10] != "" && apoinfo[10] != undefined && apoinfo[10] != null) {
                        if (apoinfo[10].trim().length > 0) { carrier = apoinfo[10]; }
                    }
                    if (apoinfo[11] != "" && apoinfo[11] != undefined && apoinfo[11] != null) {
                        if (apoinfo[11].trim().length > 0) {
                            tracking_link = apoinfo[11];
                            console.log("tracking_link ", tracking_link);
                        }
                    }
                    if (apoinfo[12] != "" && apoinfo[12] != undefined && apoinfo[12] != null) {
                        if (apoinfo[12].trim().length > 0) {
                            SignedBy = apoinfo[12];
                        }
                    }

                }
                if (tracklist[10] != null || tracklist[10] != " " || tracklist[10] != "") {
                    FreightProv = tracklist[10];
                }
                trackshipvia = carrier;
                // //;
                tracking_num = tracking_num.replace("||", "")

                if (Session_BUSUNIT == 'I0W01') {
                    // if (value.LINE_FIELD_C6 == "ZEUS") {
                    if (linedetails[0].HAL_LOCATION != "  , ,  " && linedetails[0].HAL_LOCATION != undefined && linedetails[0].HAL_LOCATION != " ") {

                        lable = "Hold At Location "
                        disp = linedetails[0].HAL_LOCATION;
                    }
                    // }
                }
                if (Session_BUSUNIT == 'I0W01') {
                    //Bug 2737 removing checkbox for Stock issues order (10/12/2022)-Aparna
                    if ((value.LINE_FIELD_C6 == "ZEUS") || (value.LINE_FIELD_C6 == "RFQ") || (value.LINE_FIELD_C6 == "NSTK") || ((value.LINE_FIELD_C6 == "PCH") && value.SUPPLIERID != "W000000091")) { //bug 2288 	Lowes pro punchout shouldn't contains buy again option in order status  - Pavithra R

                        checkboxL = true;
                    }
                    if ((value.LINE_FIELD_C6 == 'NSTK' || value.LINE_FIELD_C6 == 'PCH' || value.ISA_WBS_ELMNT == "Equipment")) {

                        checkboxL = false;
                    }

                    if (this.state.Pickup_VendorList.length > 0) {

                        this.state.Pickup_VendorList.map((i) => {


                            if (value.SUPPLIER != "" && value.SUPPLIER != " " && value.SUPPLIER != undefined && value.SUPPLIER != null) {


                                if ((value.LOCATION2 != "" && value.LOCATION2 != " " && value.LOCATION2 != undefined && value.LOCATION2 != null) || value.SUPPLIER.toUpperCase().includes("LOWE'S")) {

                                    lable = "Pickup"
                                    if (this.state.Pickup_store_tbl.length > 0) {
                                        this.state.Pickup_store_tbl.forEach((val, index) => {
                                            if ((val.VNDR_LOC == value.LOCATION2 && val.NAME1.toUpperCase() == value.SUPPLIER.toUpperCase())) {
                                                disp = val.ADDRESS1 + "," + val.CITY + "," + val.STATE;
                                            }
                                            if (disp == linedetails[0].SHIPTO_ID) {
                                                disp = "Pick-Up"
                                            }
                                        })
                                    }
                                    else {
                                        disp = "Pick-Up"
                                    }
                                }



                            }

                        })

                    }
                    /*************END***************/


                }

                let imgarr = [];
                let pdfarr = [];

                if (linedetails[0].IMAGE_URL != null && linedetails[0].IMAGE_URL != "" && linedetails[0].IMAGE_URL != undefined) {
                    //debugger
                    if (linedetails[0].IMAGE_URL.indexOf('|') !== -1) {
                        //debugger
                        let img = linedetails[0].IMAGE_URL.split('|');
                        //WW-1352 eml format file will display as document - Nandhini L
                        img.forEach((x) => {
                            let attach = x?.toLowerCase().trim();
                            if (attach.indexOf('.pdf') != -1 || attach.indexOf('.eml') != -1) {
                                pdfarr.push(attach);
                            } else {
                                let obj = { original: attach, thumbnail: attach };
                                imgarr.push(obj);
                            }
                        })
                    } else {
                        //debugger
                        let obj = { original: linedetails[0].IMAGE_URL.trim(), thumbnail: linedetails[0].IMAGE_URL.trim() };
                        imgarr.push(obj);
                    }
                }
                console.log('imgarr', imgarr);
                let valitemdesc = value.DESCR254;
                if (linedetails[0].DESCR254 != null || linedetails[0].DESCR254 != undefined) {
                    linedetails[0].DESCR254 = linedetails[0].DESCR254.includes("&apos;") ? linedetails[0].DESCR254.replaceAll("&apos;", "'") : linedetails[0].DESCR254
                    if (linedetails[0].DESCR254.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                        let ind = linedetails[0].DESCR254.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                        let removedreco = linedetails[0].DESCR254.slice(0, ind);
                        valitemdesc = removedreco;
                    }
                    else if (linedetails[0].DESCR254.toUpperCase().includes("SUPPLIER:")) {
                        let ind = linedetails[0].DESCR254.toUpperCase().indexOf("SUPPLIER");
                        let removedreco = linedetails[0].DESCR254.slice(0, ind);
                        valitemdesc = removedreco;

                    } else if (linedetails[0].DESCR254.toUpperCase().includes("-INVITEMICON-")) {
                        valitemdesc = linedetails[0].DESCR254.toUpperCase().split("-INVITEMICON-")
                        valitemdesc = valitemdesc[0];
                    }
                    else {
                        valitemdesc = linedetails[0].DESCR254;
                    }
                }
                let inventory = true
                if (value.SUPPLIERID == "W999999999") {
                    inventory = false
                }
                let pickup = false
                if (value.ISA_LINE_STATUS == "PUR" || value.ISA_LINE_STATUS == "RPU") {
                    pickup = true
                }
                else if (value.ISA_LINE_STATUS == "DSP" || value.ISA_LINE_STATUS == "ASN") {
                    if (value.USER_CHAR2 == "PU" || value.USER1 == "P" || value.SUPPLIERID == "W000000091") {
                        pickup = true
                    }
                }
                let core = false
                if (value.ITEM_ID != undefined && value.ITEM_ID != null) {
                    if (value.ITEM_ID != "") {
                        if (value.ITEM_ID.toUpperCase().includes("CORE")) {
                            core = true
                        }
                    }

                }
                console.log("this.state.LineDetailsGrid", index + 1)
                let isCoreitem = false
                try {
                    console.log("this.state.LineDetailsGrid", this.state.LineDetailsGrid[index + 1].ITEM_ID == undefined ? "yes" : "NO")
                    if (this.state.LineDetailsGrid[index + 1].ITEM_ID != undefined) {
                        if (this.state.LineDetailsGrid[index + 1].ITEM_ID != "") {
                            if (this.state.LineDetailsGrid[index + 1].ITEM_ID.toUpperCase().includes("CORE")) {
                                isCoreitem = true
                            }
                        }
                    }
                }
                catch (ex) {
                    console.log("no")

                }
                if (this.state.coreReturns.includes(value.ISA_LINE_STATUS) && linedetails[0].hasCoreCharge == true) {
                    showCoreReturns = true
                }
                let supplierpartNo = "";
                if (value.SUPPLIERID == "W999999999") {
                    if (value.INV_ITEM_ID.trim() != "" && value.INV_ITEM_ID != null && value.INV_ITEM_ID != undefined) {
                        supplierpartNo = value.INV_ITEM_ID;
                    }
                    else {
                        supplierpartNo = value.ITEM_ID;
                    }
                }
                else {
                    if (value.ITM_ID_VNDR.trim() != "" && value.ITM_ID_VNDR != null && value.ITM_ID_VNDR != undefined) {
                        supplierpartNo = value.ITM_ID_VNDR;
                    }
                    else {
                        supplierpartNo = value.ITEM_ID;
                    }
                }
                //22/11/2024, WW-1046 to find whether the item has delivered status -Vishwa S
                let isRetunStatusValid = false;
                if (value.ISA_LINE_STATUS == "DLF" || value.ISA_LINE_STATUS == "RCF") {
                    isRetunStatusValid = true
                }

                //[12/06/2024, WW-1221 to display quote order -Vishwa S]
                let isQuoteOrderValid = false;
                let IsQuoteValidStatus = false;
                if (value.LINE_FIELD_C6 == "RFQ") {
                    isQuoteOrderValid = true
                    if (value.ISA_LINE_STATUS == "QRO") {

                        IsQuoteValidStatus = true
                    }
                }
                let sameQuoteOrderClickCheck = true;
                if (this.state.OrderQuoteArray != undefined && this.state.OrderQuoteArray != null && this.state.OrderQuoteArray.length > 0) {
                    if (this.state.OrderQuoteArray[0].ORDER_NO == value.ORDER_NO) {
                        sameQuoteOrderClickCheck = false;
                    }
                }
                let isQuoteItemCancled = false;
                if ((value.ISA_LINE_STATUS == "RFR" || value.ISA_LINE_STATUS == "RFX") && value.LINE_FIELD_C6 == "RFQ") {
                    isQuoteItemCancled = true
                }

                console.log("refrigerant", value.USER1 == "P" ? lable == "Pickup" ? "pick" : "ref" : "ship")

                return (
                    <tr className="p">
                        <td colSpan={12} className="hiddenRow">
                            <div className="accordian-body" id="order-row-1">

                                <div className="row align-items-center">

                                    <div className="ord_img col-md-2 text-center">
                                        {/**WW-366 (image crash issue*/}
                                        {/**WW-1352 For thirdpaty bind no image - Nandhini L */ }
                                        {(value.LINE_FIELD_C6 == "WNST" && IsThirdParty == true) ? <img src="/Images/noimage_new.png" onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": '120px', "height": '130px' }} /> :
                                            imgarr.length > 1 ? <img className="ord_img_img" onError={(e) => { e.target.src = "/Images/noimage_new.png" }} id={`LineImg-${value.LINE_NBR}-${index}`} src={imgarr[0].original} onClick={() => this.imageclicked(imgarr)} style={{ "width": '120px', "height": '130px' }} /> : imgarr.length == 0 ? <img src="/Images/noimage_new.png" onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": '120px', "height": '130px' }} /> : <img src={imgarr[0].original} onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": '120px', "height": '130px' }} />}
                                        <div className="ord_img_icon"><img src="/Images/info-icon.png" id={`LineImg-${value.LINE_NBR}-${index}`} onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": "25px", "height": "25px" }} /></div>
                                    </div>

                                    <div className="col-md-10">

                                        <div className="row">
                                            {/*WW-1347 OrderStatus field removal -Vishwa S*/}
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`Line#L-${value.LINE_NBR}-${index}`}><Trans>Line</Trans> <span> # :</span></label>
                                                <label className="item-details-value" id={`Line#-${value.LINE_NBR}-${index}`}>{value.LINE_NBR}</label>
                                            </div>

                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`ItemKeyL-${value.Item_NBR}-${index}`}><Trans>ItemKey</Trans><span> </span><Trans>ID</Trans><span> :</span></label>
                                                <label className="item-details-value" id={`ItemKey-${value.Item_NBR}-${index}`}>{value.DESCR254.includes("Core Charges") ? "Core- " : ""}{value.MFG_ITM_ID}</label>

                                                {linedetails[0].hasBenItemVal == "C" ? <span class="i-circlegridBlue">C</span> : linedetails[0].hasBenItemVal == "T" ? <span class="i-circlegridYellow">T</span> : linedetails[0].SUPPLIER_ID == "W999999999" ? <span class="i-circlegrid">w</span> : null}
                                            </div>




                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`QTYL${value.LINE_NBR}-${index}`}>Quantity :</label>
                                                <label className="item-details-value" id={`QTY${value.LINE_NBR}-${index}`}>{value.QTY_REQ}</label>
                                            </div>
                                            {/*WW-1347 OrderStatus field removal -Vishwa S*/}
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`QTYRecvL-${value.LINE_NBR}-${index}`}>Quantity  Received :</label>
                                                <label className="item-details-value" id={`QTYRecv-${value.LINE_NBR}-${index}`}>{value.QTY_RECEIVED}</label>
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`OrderForL-${value.LINE_NBR}-${index}`}><Trans>orderedfor_key</Trans><span> :</span></label>
                                                <label className="item-details-value " id={`OrderFor-${value.LINE_NBR}-${index}`}>{value.EMPNAME}</label>
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`StatusL-${value.LINE_NBR}-${index}`}><Trans>Status</Trans><span> :</span></label>
                                                <label className="item-details-value" id={`Status-${value.LINE_NBR}-${index}`}>{value.LINE_STATUS == null || value.LINE_STATUS.trim() == "" ? 'Unknown' : value.LINE_STATUS}</label>
                                            </div>
                                            {/*WW-1347 OrderStatus field removal -Vishwa S*/}
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`PriorityL-${value.LINE_NBR}-${index}`}><Trans>Priority</Trans> <span> :</span></label>
                                                <label className="item-details-value priority-alert" id={`Priority-${value.LINE_NBR}-${index}`}>{value.LINE_PRIOR == null || value.LINE_PRIOR.trim() == "" ? '-' : value.LINE_PRIOR}</label>
                                            </div>

                                            {/*{checkboxL && linedetails[0].hasCoreCharge == false && linedetails[0].InvItemQtyCheck == false && (linedetails[0].IMAGE_URL == null ? true : !(linedetails[0].IMAGE_URL.indexOf('.pdf') != -1)) ?
                                                <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" htmlFor={`OrderStatus-${value.LINE_NBR}-${index + 1}`} id={`OrderStatus-${value.LINE_NBR}-${index + 1}`} ><Trans>Buy again </Trans><span>:</span></label>
                                                    <input type="checkbox" className="item-details-value my-1" checked={value.checked} id={`OrderStatus-${value.LINE_NBR}-${index + 1}`} name="example1" onChange={() => this.selectbuyagainOrder(value)} />

                                                </div> : null}*/}

                                            {((checkboxL && linedetails[0].hasCoreCharge == false && linedetails[0].InvItemQtyCheck == false && (linedetails[0].IMAGE_URL == null ? true : !(linedetails[0].IMAGE_URL.indexOf('.pdf') != -1)) || (value.ORDER_NO.startsWith('WQ') && isQuoteOrderValid)) && !isQuoteItemCancled && linedetails[0].hasCoreCharge == false) ?
                                                (!isQuoteOrderValid && !IsQuoteValidStatus ? (<div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" htmlFor={`OrderStatus-${value.LINE_NBR}-${index + 1}`} id={`OrderStatus-${value.LINE_NBR}-${index + 1}`} ><Trans>Buy again </Trans><span>:</span></label>
                                                    <input type="checkbox" className="item-details-value my-1" checked={value.checked} id={`OrderStatus-${value.LINE_NBR}-${index + 1}`} name="example1" onChange={() => this.selectbuyagainOrder(value)}
                                                        disabled={this.state.OrderQuoteArray != undefined && this.state.OrderQuoteArray != null && this.state.OrderQuoteArray.length > 0 ? true : false} />

                                                </div>) : (isQuoteOrderValid && IsQuoteValidStatus ? (<div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" htmlFor={`OrderQuote-${value.LINE_NBR}-${index + 1}`} id={`OrderQuote-${value.LINE_NBR}-${index + 1}`} ><Trans>Order Quote </Trans><span>: </span></label>
                                                    <input type="checkbox" className="item-details-value my-1" checked={value.checked} id={`OrderQuote-${value.LINE_NBR}-${index + 1}`} name="example1" onChange={() => this.selectQuoteOrder(value)}
                                                        disabled={((this.state.BuyAgainArray != undefined && this.state.BuyAgainArray != null && this.state.BuyAgainArray.length > 0) || (this.state.OrderQuoteArray != undefined && this.state.OrderQuoteArray != null && this.state.OrderQuoteArray.length > 0)) && (sameQuoteOrderClickCheck) ? true : false} />
                                                </div>) : null))
                                                : null}



                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`SignedByL${value.LINE_NBR}-${index}`}><Trans>Signed By</Trans><span> :</span></label>
                                                <label className="item-details-value" id={`SignedBy${value.LINE_NBR}-${index}`}>{SignedBy}</label>
                                            </div>




                                            {"MANAGER".startsWith(this.state.Manager) || "REGMANAGER".startsWith(this.state.Manager) || "DIRECTOR".startsWith(this.state.Manager) || "SR_DIRECTOR".startsWith(this.state.Manager) ? <>
                                                <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`DivisionL-${value.LINE_NBR}-${index}`}><Trans>Division</Trans> <span> :</span></label>
                                                    <label className="item-details-value" id={`Division-${value.LINE_NBR}-${index}`}>{value.DIVISION == null || value.DIVISION.trim() == "" ? '-' : value.DIVISION}</label>
                                                </div>
                                                <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`RegionL-${value.LINE_NBR}-${index}`}><Trans>Region</Trans> <span> :</span></label>
                                                    <label className="item-details-value" id={`Region-${value.LINE_NBR}-${index}`}> {value.REGION == null || value.REGION.trim() == "" ? '-' : value.REGION} </label>
                                                </div>
                                                <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`SubRegionL-${value.LINE_NBR}-${index}`}><Trans>Sub Region</Trans> <span> :</span></label>
                                                    <label className="item-details-value" id={`SubRegion-${value.LINE_NBR}-${index}`}>{value.SUB_REGION == null || value.SUB_REGION.trim() == "" ? '-' : value.SUB_REGION}</label>
                                                </div>
                                            </> : null}

                                            {value.USER1 == "P" ? lable == "Pickup" ? <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`Pick-UpL-${value.LINE_NBR}-${index}`}><Trans>{lable}</Trans><span> :</span></label>
                                                <label className="item-details-value" id={`Pick-Up-${value.LINE_NBR}-${index}`}>{disp}</label>
                                            </div> : <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`Pick-UpL-${value.LINE_NBR}-${index}`}><Trans>Pick-Up</Trans><span> :</span></label>
                                                    <label className="item-details-value Refrigerent-styles" id={`Pick-Up-${value.LINE_NBR}-${index}`}>(Refrigerant)</label>
                                                </div> : <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`Pick-UpL-${value.LINE_NBR}-${index}`}><Trans>{lable}</Trans><span> :</span></label>
                                                    <label className="item-details-value" id={`Pick-Up-${value.LINE_NBR}-${index}`}>{disp}</label>
                                                </div>}
                                            {!value.ORDER_NO.startsWith('WQ') ? <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`FreightProviderL-${value.LINE_NBR}-${index}`}><Trans>Freight Provider :</Trans></label>
                                                <label className="item-details-value" id={`FreightProvider-${value.LINE_NBR}-${index}`}>{trackshipvia}</label>
                                            </div> : null}
                                            {!value.ORDER_NO.startsWith('WQ') ? <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`Tracking#-${value.LINE_NBR}-${index}`}><Trans>Tracking</Trans><span> Details :</span></label>
                                                {hasTrackingNumber == true ?
                                                    <a className="sdi-tracking-color" data-toggle="modal" data-target="#exampleModalCenter" onClick={(e) => this.onClickTrackDet(locASNdet)}>
                                                        <img src="images/Truck-icon.svg" alt="tracking-icon" className="mr-1 mb-1" />Track
                                                    </a> : "-"
                                                }
                                            </div> : null}
                                            {inventory == true && pickup == true && core == false ? <>
                                                <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`Tracking#-${value.LINE_NBR}-${index}`}><Trans>Item Pickup</Trans><span> :</span></label>

                                                    <a className="sdi-tracking-color" style={{ "cursor": "pointer" }} data-toggle="modal" onClick={(e) => this.onPickupClick(value.ORDER_NO, value.LINE_NBR, ind, isCoreitem)}>
                                                        <img src="images/pickup-blu.svg" alt="tracking-icon" className="mr-1 mb-1" /><span>Picked up </span>?
                                                    </a>

                                                </div></>
                                                : null}
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`HistoryL-${value.LINE_NBR}-${index}`}><Trans>More Details</Trans> <span> :</span></label>
                                                <a href="#" id={`History-${value.LINE_NBR}-${index}`} data-toggle="modal" data-target="#order-approval-history" data-backdrop="static" data-keyboard="false" className="history-icon ml-1" onClick={(e) => this.Approvalhistory(value)} />
                                            </div>

                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`supplierL-${value.LINE_NBR}-${index}`}><Trans>{value.SUPPLIER == " " || value.SUPPLIER == null ? "Suggested Supplier :" : "Supplier :"}</Trans></label>
                                                <label className="item-details-value" id={`supplier-${value.LINE_NBR}-${index}`}>{value.SUPPLIER == " " || value.SUPPLIER == null ? value.SUGGESTED_VNDR : value.SUPPLIER}</label>
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`SupplierPart-${value.LINE_NBR}${index}`}><Trans>Supplier</Trans><span> </span><Trans>Part#</Trans><span> </span><span> :</span></label>
                                                <label className="item-details-value " id={`SupplierPartNum-${value.LINE_NBR}${index}`}>{supplierpartNo}</label>
                                            </div>


                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`POIDL-${value.LINE_NBR}-${index}`}><Trans>PO ID:</Trans></label>
                                                {/*WW-1230 - WO searvice channel navigation -Nandhini L*/}
                                                <a href="#" id={`POID-${value.LINE_NBR}-${index}`} data-toggle="modal" data-target="#po-details" onClick={(e) => this.PODetailPopup(value.PO_ID1)}>{value.PO_ID1}</a>
                                                <div>
                                                    {value.CANCELLED_PO != "" && value.CANCELLED_PO != null && value.CANCELLED_PO != undefined ? <span id={`POID-${value.LINE_NBR}-${index}1`} style={{ "color": "red" }} data-toggle="modal" data-target="#po-details" onClick={(e) => this.PODetailPopup(value.CANCELLED_PO)}><del style={{ "cursor": "pointer" }}>{value.CANCELLED_PO}</del></span> : null}
                                                </div>
                                            </div>
                                            {/*bug 4080 - Yuvarani K*/}
                                            {value.EXPECTED_DATE != null ? <>
                                                <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`ExpectedDeliveryL-${value.LINE_NBR}${index}`}><Trans>Expected</Trans><span> </span><Trans>Delivery</Trans><span> </span><Trans>Date</Trans><span> :</span></label>
                                                    <label className="item-details-value " id={`ExpectedDelivery-${value.LINE_NBR}${index}`}>{value.EXPECTED_DATE}</label>
                                                </div></>
                                                : null}

                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`DescriptionL-${value.LINE_NBR}-${index}`}><Trans>Description</Trans><span> :</span></label>
                                                <label className="item-details-value w-100 textbreakwrap" id={`Description-${value.LINE_NBR}-${index}`}>{valitemdesc} </label>

                                            </div>

                                            {!value.ORDER_NO.startsWith('WQ') ? <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`NextApproverL-${value.LINE_NBR}-${index}`}><Trans>Next Approver</Trans><span> :</span></label>
                                                <label className="item-details-value" id={`NextApprover-${value.LINE_NBR}-${index}`}>
                                                    {/* //pc-1138-01 changing the employee id to user name S.Sanjay 8/1/2024*/}
                                                    {(value.NEXT_APPR === null || value.NEXT_APPR === undefined) ? "-" : value.NEXT_APPR.trim() === "" ? "-" : value.NEXTAPPROVERNAME}
                                                </label>
                                            </div> : null}
                                            {value.LINE_NOTES ?
                                                <div className="col-md-3 mb-2">
                                                    <label className="catalog-label mr-2" id={`Notes-${value.LINE_NBR}-${index}`}><Trans>Notes</Trans><span> :</span></label>
                                                    <a href="" className="custom-list-group back-icon" id={`Notes-${value.LINE_NBR}-${index}`} onClick={(e) => this.getNotes(e, value.ORDER_NO, value.LINE_NBR, value.MFG_ITM_ID)}>Read Notes</a>
                                                </div> : null}
                                            {!value.ORDER_NO.startsWith('WQ') ? <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`FedExImg-${value.LINE_NBR}-${index}`}>
                                                    <Trans>FedEx Attachment</Trans><span> :</span>
                                                </label>
                                                {currentImgArr.map((value1, index1) => (
                                                    <span className="mr-2" style={{
                                                        "backgroundColor": "rgb(240, 240, 240)", "borderRadius": '10px', "padding": "10px"
                                                    }}>
                                                        <a
                                                            className="item-details-value"
                                                            id={`FedExAttch-${value.LINE_NBR}-${index}-${index1}`}
                                                            key={index1}
                                                            style={{ color: 'blue', textDecoration: 'underline' }}
                                                            href={value1.ISA_SIG_URL}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {(value1.ISA_SIG_URL === null || value1.ISA_SIG_URL === undefined)
                                                                ? "-"
                                                                : value1.ISA_SIG_URL.length > 28
                                                                    ? value1.ISA_SIG_URL.slice(0, 25) + "..."
                                                                    : value1.ISA_SIG_URL}
                                                        </a>
                                                    </span>
                                                ))}
                                            </div> : null}
                                            {/**WW-1352 For thirdpaty bind no image - Nandhini L */}
                                            {linedetails[0].IMAGE_URL == null || (value.LINE_FIELD_C6 == "WNST" && IsThirdParty == true) ? null : (linedetails[0].IMAGE_URL.toLowerCase().indexOf('.pdf') != -1 || linedetails[0].IMAGE_URL.toLowerCase().indexOf('.eml') != -1) ? pdfarr.length > 0 ? <div className="col-md-3 pr-0 mb-2">

                                                <label className="catalog-label mr-2" id={`pdfarrL-${value.LINE_NBR}-${index}`}><Trans>Attachment</Trans><span> :</span></label>
                                                <a href="#" id={`Attachments-${value.LINE_NBR}-${index}`} onClick={(e) => this.displayAttachments(e, pdfarr)}>
                                                    <img src="/images/Attachments.svg" className="attachments-icon" alt="AttachmentIcon"></img>
                                                </a>
                                            </div> : <div className="col-md-6 mb-2">
                                                    <label className="catalog-label mr-2" id={`AttachmentL-${value.LINE_NBR}-${index}`}><Trans>Attachments</Trans><span> :</span></label>
                                                    <a style={{ "textDecoration": "underLine" }} href={linedetails[0].IMAGE_URL} id={`Attachment-${value.LINE_NBR}-${index}`} download target="_blank">File</a>
                                                </div> : null}





                                        </div>

                                    </div>

                                    <div className="col-md-12 text-right mb-3">
                                        {showCoreReturns == true ?
                                            (value.CORE_TRACK_NO != null && value.CORE_TRACK_NO != undefined && value.CORE_TRACK_NO != "" && value.CORE_TRACK_NO != " " ?
                                                <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn mr-2  returncore" id={`Reprint-${value.LINE_NBR}-${index}`} onClick={() => this.Reprint(value, linedetails[0])}>Reprint Shipping Label</button>
                                                :
                                                <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn mr-2  returncore" id={`Return-${value.LINE_NBR}-${index}`} onClick={() => this.getReturnData(value, linedetails[0])}>Return Core Item</button>
                                            ) : null}

                                        <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn mr-2" id={`Pass-${value.LINE_NBR}-${index}`} id="PassAuthe" onClick={() => this.PassAutheLine(value, linedetails[0])}>Incident</button>
                                        {isRetunStatusValid ?
                                            <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn mr-2" id={`StartAReturn-${value.LINE_NBR}-${index}`} id="StartAReturn" onClick={() => this.startAReturnClick(value, "LINE")}>Start a Return</button>
                                            : null}
                                        {linedetails[0].hasCoreCharge == false ?
                                            <div class="d-inline-block">
                                                {hasCancelStatus == false ? <div>
                                                    <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn " id={`cancel-${value.LINE_NBR}-${index}`} id="CancelOrderBtn" onClick={() => this.CancelLineLevelItem(value, "Line")}>Cancel</button>
                                                </div> : null
                                                } </div> : null}


                                    </div>

                                </div>
                            </div>

                        </td>
                    </tr>

                )
            });

        }

    }

    linedatagrid = (ORDER_NO, PO_ID) => {
        //let lineOrderArray = [];
        //if (this.state.toggleChecked) {
        //    lineOrderArray = this.state.InvGridArr;
        //}
        //else {
        //    lineOrderArray = this.state.GridArr;
        //}
        return this.state.GridArr.filter((x) => x.ORDER_NO == ORDER_NO).map((value, index) => {
            let checkboxL = false;
            let lable = "Ship To";
            let disp = value.SHIPTO_ID;
            console.log("disp", disp);
            let imagePath = "";
            let status = "";
            let st = "";
            let color = "";
            let apoinfo = "";
            let tracking_num = "-";
            let tracking_link = "-";
            let carrier = "-";
            let IMG_URL = "";
            let tracklist = "";
            let FreightProv = "";
            let trackshipvia = "";
            let SignedBy = "-";
            // WW-305_PS_01 adding next approvar name in item detail (12/20/2021)
            let NextAppr = this.state.EmpIdDropDown.filter((x) => x.value == value.NEXT_APPR)
            let NA = ""
            let nxt
            if (NextAppr.length > 0) {
                if (NextAppr[0].value != undefined) {
                    nxt = NextAppr[0].label.split("-")
                    NA = nxt[0]
                }

            }
            else {
                if (value.NEXT_APPR == CookieService.getLocalStorageValues("Session_UserID")) {
                    NA = CookieService.getLocalStorageValues("Session_USERNAME")
                }
            }
            if (value.APOINFO != null) {
                apoinfo = value.APOINFO.split(',');
                tracklist = value.APOINFO.split(',');
                if (apoinfo[9] != "" && apoinfo[9] != undefined && apoinfo[9] != null) {
                    if (apoinfo[9].trim().length > 0) { tracking_num = apoinfo[9]; }
                }
                if (apoinfo[10] != "" && apoinfo[10] != undefined && apoinfo[10] != null) {
                    if (apoinfo[10].trim().length > 0) { carrier = apoinfo[10]; }
                }
                if (apoinfo[11] != "" && apoinfo[11] != undefined && apoinfo[11] != null) {
                    if (apoinfo[11].trim().length > 0) {
                        tracking_link = apoinfo[11];
                        console.log("tracking_link ", tracking_link);
                    }
                }
                if (apoinfo[12] != "" && apoinfo[12] != undefined && apoinfo[12] != null) {
                    if (apoinfo[12].trim().length > 0) {
                        SignedBy = apoinfo[12];
                    }
                }

            }
            if (tracklist[10] != null || tracklist[10] != " " || tracklist[10] != "") {
                FreightProv = tracklist[10];
            }
            trackshipvia = carrier;
            tracking_num = tracking_num.replace("||", "")
            // //;
            if (Session_BUSUNIT == value.BUSINESS_UNIT_OM) {

                {/*'/*[06/13/22,WW-401, User can buy again Punchout items and also they can add PCH item to Fav order], Priyanka D */ }
                //Bug 2737 removing checkbox for Stock issues order (10/12/2022)-Aparna
                if ((value.LINEFIELD == "ZEUS") || (value.LINEFIELD == "RFQ") || (value.LINEFIELD == "NSTK") || (value.LINEFIELD == "PCH" && value.SUPPLIERID != "W000000091")) { //bug 2288 	Lowes pro punchout shouldn't contains buy again option in order status  - Pavithra R

                    checkboxL = true;
                }

                //[12/15/21, PC_OS_03, WW-300, Dhevanesam R - To check null condition for the order status value] 
                if (value.ORDER_STATUS != "" && value.ORDER_STATUS != null) {
                    status = value.ORDER_STATUS;
                    st = status.split('^')[1];
                    color = status.split('^')[4];

                    if (color.toUpperCase() == "RED") {
                        color = "btn-red"
                    }
                    else if (color.toUpperCase() == "YELLOW") {
                        color = "btn-yellow"
                    }
                    else if (color.toUpperCase() == "GREEN") {
                        color = "btn-green"
                    }
                    else {
                        st = "Unknown";
                    }
                    imagePath = ((status.split('^')[3]) == 1 ? "images/chain0.png" :
                        (status.split('^')[3]) == 2 ? "images/chain1.png" :
                            (status.split('^')[3]) == 3 ? "images/chain2.png" :
                                (status.split('^')[3]) == 4 ? "images/chain3.png" :
                                    (status.split('^')[3]) == 5 ? "images/chain4.png" : "images/chain6.png")
                    console.log("value.ORDER_STATUS", value.ORDER_STATUS);
                }
                else {
                    st = "Unknown";
                }
                /*********NEW**wal-158************/


                if (this.state.Pickup_VendorList.length > 0) {

                    this.state.Pickup_VendorList.map((i) => {


                        if (value.SUPPLIER != "" && value.SUPPLIER != " " && value.SUPPLIER != undefined && value.SUPPLIER != null) {


                            if ((value.LOCATION2 != "" && value.LOCATION2 != " " && value.LOCATION2 != undefined && value.LOCATION2 != null) || value.SUPPLIER.toUpperCase().includes("LOWE'S")) {

                                lable = "Pickup"
                                if (this.state.Pickup_store_tbl.length > 0) {
                                    this.state.Pickup_store_tbl.forEach((val, index) => {
                                        if (val.ADDRESS3 == value.LOCATION2 && val.NAME1.toUpperCase() == value.SUPPLIER.toUpperCase()) {
                                            disp = val.ADDRESS1 + "," + val.CITY + "," + val.STATE;
                                        }
                                        if (disp == value.SHIPTO_ID) {
                                            disp = "Pick-Up"
                                        }
                                    })
                                }
                                else {
                                    disp = "Pick-Up"
                                }
                            }



                        }

                    })

                }
                /*************END***************/


            }
            let imgarr = [];
            let pdfarr = [];

            if (value.IMAGE_URL != null && value.IMAGE_URL != "" && value.IMAGE_URL != undefined) {
                //debugger
                if (value.IMAGE_URL.indexOf('|') !== -1) {
                    //debugger
                    let img = value.IMAGE_URL.split('|');
                    //WW-1352 eml format file will display as document - Nandhini L
                    img.forEach((x) => {
                        if (x.indexOf('.pdf') != -1 || x.indexOf('.eml') != -1) {
                            pdfarr.push(x);
                        } else {
                            let obj = { original: x, thumbnail: x };
                            imgarr.push(obj);
                        }
                    })
                } else {
                    //debugger
                    let obj = { original: value.IMAGE_URL, thumbnail: value.IMAGE_URL };
                    imgarr.push(obj);
                }
            }
            console.log('imgarr', imgarr);
            let valitemdesc = value.DESCR254;
            if (value.DESCR254 != null || value.DESCR254 != undefined) {
                if (value.DESCR254.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                    let ind = value.DESCR254.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                    let removedreco = value.DESCR254.slice(0, ind);
                    valitemdesc = removedreco;
                }
                else if (value.DESCR254.toUpperCase().includes("SUPPLIER:")) {
                    let ind = value.DESCR254.toUpperCase().indexOf("SUPPLIER");
                    let removedreco = value.DESCR254.slice(0, ind);
                    valitemdesc = removedreco;

                } else if (value.DESCR254.toUpperCase().includes("-INVITEMICON-")) {
                    valitemdesc = valitemdesc.split("-INVITEMICON-")
                    valitemdesc = valitemdesc[0];
                }
                else {
                    valitemdesc = value.DESCR254;
                }
            }


            return (
                <tr className="p">
                    <td colSpan={12} className="hiddenRow">
                        <div className="accordian-body" id="order-row-1">

                            <div className="row align-items-center">

                                <div className="ord_img col-md-2 text-center">
                                    {/**WW-366 (image crash issue*/}
                                    {imgarr.length > 1 ? <img className="ord_img_img" onError={(e) => { e.target.src = "/Images/noimage_new.png" }} id={`LineImg-${value.LINE_NBR}-${index}`} src={imgarr[0].original} onClick={() => this.imageclicked(imgarr)} style={{ "width": '120px', "height": '130px' }} /> : imgarr.length == 0 ? <img src="/Images/noimage_new.png" onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": '120px', "height": '130px' }} /> : <img src={imgarr[0].original} onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": '120px', "height": '130px' }} />}
                                    <div className="ord_img_icon"><img src="/Images/info-icon.png" id={`LineImg-${value.LINE_NBR}-${index}`} onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": "25px", "height": "25px" }} /></div>
                                </div>

                                <div className="col-md-10">

                                    <div className="row">
                                        {/* <div class="col-12 mobile-fieldscontainer p-0">
                                        <div class="col-12 mobile-fields">
                                                    <label className="catalog-label">Item ID:</label>
                                                    <label className="item-details-value">{value.INV_ITEM_ID}</label>
                                                </div>
                                                <div className="col-12 mobile-fields">
                                                    <label className="catalog-label">Work Order:</label>
                                                    <label className="item-details-value">{value.ISA_WORK_ORDER_NO}</label>
                                                </div>
                                                <div className="col-12 mobile-fields">
                                                    <label className="catalog-label">Business Unit:</label>
                                                    <label className="item-details-value">{value.BUSINESS_UNIT_OM}</label>
                                                </div>
                                                <div className="col-12 mobile-fields">
                                                    <label className="catalog-label">Priority:</label>
                                                    <label className="item-details-value priority-alert">{value.LINE_PRIOR}</label>
                                                </div>
                                                <div className="col-12 mobile-fields">
                                                    <label className="catalog-label">Order Entered by:</label>
                                                    <label className="item-details-value">{value.ENTEREDEMPNAME}</label>
                                                </div>
                                                <div className="col-12 mobile-fields">
                                                    <label className="catalog-label">Ordered For:</label>
                                                    <label className="item-details-value">{value.OPRID_ENTERED_BY}</label>
                                                </div>
                                                <div className="col-12 mobile-fields">
                                                    <label className="catalog-label">PO ID:</label>
                                                    <a href="#" className="order-id" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#po-details" onClick={(e) => this.PODetailPopup(value)}>{value.PO_ID1}</a>
                                                </div>
                                            </div> */}
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`Line#L-${value.LINE_NBR}-${index}`}><Trans>Line</Trans> <span> # :</span></label>
                                            <label className="item-details-value" id={`Line#-${value.LINE_NBR}-${index}`}>{value.LINE_NBR}</label>
                                        </div>

                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`ItemKeyL-${value.Item_NBR}-${index}`}><Trans>ItemKey</Trans><span> </span><Trans>ID</Trans><span> :</span></label>
                                            <label className="item-details-value" id={`ItemKey-${value.Item_NBR}-${index}`}>{value.INV_ITEM_ID}</label>
                                            {/*[2/16/22], WW-330, Dhevanesam R*/}
                                            {value.hasBenItemVal == "C" ? <span class="i-circlegridBlue">C</span> : value.hasBenItemVal == "T" ? <span class="i-circlegridYellow">T</span> : value.SUPPLIER == "SDI Warehouse" ? <span class="i-circlegrid">w</span> : null}
                                        </div>


                                        {/* <div className="col-md-2 pr-0 mb-2">
                                            <label className="catalog-label mr-2">Order Date :</label>
                                                <label className="item-details-value">{value.ORD_DATE}</label> 
                                        </div> */}

                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`QTYL${value.LINE_NBR}-${index}`}>Quantity :</label>
                                            <label className="item-details-value" id={`QTY${value.LINE_NBR}-${index}`}>{value.QTY_REQ}</label>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`QTYRecvL-${value.LINE_NBR}-${index}`}>Quantity Received :</label>
                                            <label className="item-details-value" id={`QTYRecv-${value.LINE_NBR}-${index}`}>{value.QTY_RECEIVED}</label>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`OrderForL-${value.LINE_NBR}-${index}`}><Trans>orderedfor_key</Trans><span> :</span></label>
                                            <label className="item-details-value " id={`OrderFor-${value.LINE_NBR}-${index}`}>{value.EMPNAME}</label>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`StatusL-${value.LINE_NBR}-${index}`}><Trans>Status</Trans><span> :</span></label>
                                            <label className="item-details-value" id={`Status-${value.LINE_NBR}-${index}`}>{value.LINE_STATUS == null || value.LINE_STATUS.trim() == "" ? '-' : value.LINE_STATUS}</label>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`PriorityL-${value.LINE_NBR}-${index}`}><Trans>Priority</Trans> <span> :</span></label>
                                            <label className="item-details-value priority-alert" id={`Priority-${value.LINE_NBR}-${index}`}> {value.LINE_PRIOR == null || value.LINE_PRIOR.trim() == "" ? '-' : value.LINE_PRIOR}</label>
                                        </div>
                                        {/* [12/22/21], PC_OS_13, WW-286, Dhevanesam R {checkboxL && value.hasCoreCharge == false ?*/}
                                        {/*[02/09/22, PC_01,WW-318], Priyanka D,Hide Buy Again for Enersys item */}
                                        {/*//[2/16/22], WW-330, Dhevanesam R*/}
                                        {checkboxL && value.hasCoreCharge == false && value.InvItemQtyCheck == false && (value.IMAGE_URL == null ? true : !(value.IMAGE_URL.indexOf('.pdf') != -1)) ?
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" htmlFor={`OrderStatus-${value.LINE_NBR}-${index + 1}`} id={`OrderStatus-${value.LINE_NBR}-${index + 1}`} ><Trans>Buy again </Trans><span>:</span></label>
                                                <input type="checkbox" className="item-details-value my-1" checked={value.checked} id={`OrderStatus-${value.LINE_NBR}-${index + 1}`} name="example1" onChange={() => this.selectOrder(value)} />

                                            </div> : null}

                                        {/* <div className="col-md-2 pr-0 mb-2">
                                            <label className="catalog-label mr-2">Currency :</label>
                                            <label className="item-details-value">{value.CURRENCY}</label>
                                        </div>
                                        <div className="col-md-2 pr-0 mb-2">
                                            <label className="catalog-label mr-2">Rev. Due date :</label>
                                            <label className="item-details-value ">{!value.REV_DUE_DT1 ? "-" : value.REV_DUE_DT1}</label>
                                        </div>
                                        <div className="col-md-2 pr-0 mb-2">
                                            <label className="catalog-label mr-2">Asset Tag ID :</label>
                                            <label className="item-details-value">{value.ISA_MACHINE_NO}</label>
                                        </div>*/}

                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`SignedByL${value.LINE_NBR}-${index}`}><Trans>Signed By</Trans><span> :</span></label>
                                            <label className="item-details-value" id={`SignedBy${value.LINE_NBR}-${index}`}>{SignedBy}</label>
                                        </div>
                                        {/* <div className="col-md-2 pr-0 mb-2">
                                            <label className="catalog-label mr-2">Ship Doc :</label>
                                            <label className="item-details-value"> {this.shiptobind(value)}</label>
                                        </div> */}


                                        {/*   <div className="col-md-2 pr-0 mb-2">
                                            <label className="catalog-label mr-2">Approved By :</label>
                                                <label className="item-details-value">{value.OPRID_APPROVED_BY}</label>
                                            </div> */}

                                        {/*[12/3/21], PC_OS_02, WW-279, Dhevanesam R - Check the state value Manager as DIRECTOR or SR_DIRECTOR to display division, region and sub region dropdowns*/}
                                        {this.state.Manager == "MANAGER" || this.state.Manager == "REGMANAGER" || this.state.Manager == "DIRECTOR" || this.state.Manager == "SR_DIRECTOR" ? <>
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`DivisionL-${value.LINE_NBR}-${index}`}><Trans>Division</Trans> <span> :</span></label>
                                                <label className="item-details-value" id={`Division-${value.LINE_NBR}-${index}`}> {value.DIVISION == null || value.DIVISION.trim() == "" ? '-' : value.DIVISION} </label>
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`RegionL-${value.LINE_NBR}-${index}`}><Trans>Region</Trans> <span> :</span></label>
                                                <label className="item-details-value" id={`Region-${value.LINE_NBR}-${index}`}>  {value.REGION == null || value.REGION.trim() == "" ? '-' : value.REGION} </label>
                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`SubRegionL-${value.LINE_NBR}-${index}`}><Trans>Sub Region</Trans> <span> :</span></label>
                                                <label className="item-details-value" id={`SubRegion-${value.LINE_NBR}-${index}`}>  {value.SUB_REGION == null || value.SUB_REGION.trim() == "" ? '-' : value.SUB_REGION}</label>
                                            </div>
                                        </> : null}

                                        {value.USER1 == "P" ? lable == "Pick-Up" ? <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`Pick-UpL-${value.LINE_NBR}-${index}`}><Trans>{lable}</Trans><span> :</span></label>
                                            <label className="item-details-value" id={`Pick-Up-${value.LINE_NBR}-${index}`}>{disp}</label>
                                        </div> : <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`Pick-UpL-${value.LINE_NBR}-${index}`}><Trans>Pick-Up</Trans><span> :</span></label>
                                                <label className="item-details-value Refrigerent-styles" id={`Pick-Up-${value.LINE_NBR}-${index}`}>(Refrigerant)</label>
                                            </div> : <div className="col-md-3 mb-2">
                                                <label className="catalog-label mr-2" id={`Pick-UpL-${value.LINE_NBR}-${index}`}><Trans>{lable}</Trans><span> :</span></label>
                                                <label className="item-details-value" id={`Pick-Up-${value.LINE_NBR}-${index}`}>{disp}</label>
                                            </div>}
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`FreightProviderL-${value.LINE_NBR}-${index}`}><Trans>Freight Provider :</Trans></label>
                                            <label className="item-details-value" id={`FreightProvider-${value.LINE_NBR}-${index}`}>{trackshipvia}</label>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`Tracking#-${value.LINE_NBR}-${index}`}><Trans>Tracking</Trans><span> # :</span></label>

                                            {tracking_num.length == 1 || tracking_link.length < 7 ?
                                                <label id={`TrackingL-${value.LINE_NBR}-${index}`} className="item-details-value">{tracking_num}</label> :
                                                /*Not able to navigate when we click on tracking number issue, Priyanka D */
                                                <a id={`Tracking-${value.LINE_NBR}-${index}`} href={tracking_link} target="_blank">{tracking_num} </a>
                                            }
                                            {/*[01/10/22, PC_03,WW-307], Priyanka D History button should be made as clickable*/}
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`HistoryL-${value.LINE_NBR}-${index}`}><Trans>History</Trans> <span> :</span></label>
                                            <a href="#" id={`History-${value.LINE_NBR}-${index}`} data-toggle="modal" data-target="#order-approval-history" data-backdrop="static" data-keyboard="false" className="history-icon ml-1" onClick={(e) => this.Approvalhistory(value)} />
                                        </div>

                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`supplierL-${value.LINE_NBR}-${index}`}><Trans>{value.SUPPLIER == " " || value.SUPPLIER == null ? "Suggested Supplier :" : "Supplier :"}</Trans></label>
                                            <label className="item-details-value" id={`supplier-${value.LINE_NBR}-${index}`}>{value.SUPPLIER == " " || value.SUPPLIER == null ? value.SUGGESTED_VNDR : value.SUPPLIER}</label>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <label className="catalog-label mr-2" id={`POIDL-${value.LINE_NBR}-${index}`}><Trans>PO ID:</Trans></label>
                                            <label className="item-details-value"><a href="#" id={`POID-${value.LINE_NBR}-${index}`} className="order-id" data-toggle="modal" data-target="#po-details" onClick={(e) => this.PODetailPopup(value)}>{value.PO_ID1}</a></label>
                                        </div>
                                        <div className="col-md-6 mb-2">
                                            <label className="catalog-label mr-2" id={`ExpectedDeliveryL-${value.LINE_NBR}${index}`}><Trans>Expected</Trans><span> </span><Trans>Delivery</Trans><span> </span><Trans>Date</Trans><span> :</span></label>
                                            <label className="item-details-value " id={`ExpectedDelivery-${value.LINE_NBR}${index}`}>{value.REQ_DATE}</label>
                                        </div>

                                        <div className="col-md-6 mb-2">
                                            <label className="catalog-label mr-2" id={`DescriptionL-${value.LINE_NBR}-${index}`}><Trans>Description</Trans><span> :</span></label>
                                            <label className="item-details-value desc-break" id={`Description-${value.LINE_NBR}-${index}`}>{valitemdesc} </label>

                                        </div>
                                        {/*{value.hasCoreCharge == true ?
                                            <div className="col-md-6 pr-0 mb-2">
                                                <label className="catalog-label mr-2"><Trans>Core Charge</Trans><span> :</span></label>
                                                <label className="item-details-value">Yes</label>
                                            </div> : <div className="col-md-6 pr-0 mb-2">
                                                <label className="catalog-label mr-2"><Trans>Core Charge</Trans><span> :</span></label>
                                                <label className="item-details-value">No</label>
                                            </div>}*/}
                                        {/*WW-305_PS_02 adding next approvar name in item detail (12/20/2021)**/}
                                        <div className="col-md-6 mb-2">
                                            <label className="catalog-label mr-2" id={`NextApproverL-${value.LINE_NBR}-${index}`}><Trans>Next Approver</Trans><span> :</span></label>
                                            <label className="item-details-value" id={`NextApprover-${value.LINE_NBR}-${index}`}>{'NA'} </label>
                                        </div>
                                        {value.IMAGE_URL == null ? null : value.IMAGE_URL.indexOf('.pdf') != -1 ? pdfarr.length > 0 ? <div className="col-md-3 pr-0 mb-2">

                                            <label className="catalog-label mr-2" id={`pdfarrL-${value.LINE_NBR}-${index}`}><Trans>Attachment</Trans><span> :</span></label>
                                            <label className="item-details-value">
                                                {pdfarr.map((x, Index) => {
                                                    return (
                                                        <a style={{ "marginRight": "5px", "textDecoration": "underLine" }} id={`pdfarr-${value.LINE_NBR}-${index}`} href={x} download target="_blank">File{Index + 1}</a>
                                                    )
                                                })}
                                            </label>
                                        </div> : <div className="col-md-6 mb-2">
                                                <label className="catalog-label mr-2" id={`AttachmentL-${value.LINE_NBR}-${index}`}><Trans>Attachments</Trans><span> :</span></label>
                                                <a style={{ "textDecoration": "underLine" }} href={value.IMAGE_URL} id={`Attachment-${value.LINE_NBR}-${index}`} download target="_blank">File</a>
                                            </div> : null}

                                        {/*value.ORDER_STATUS.length>0?<>
                                            <div className="col-md-8">
                                                <div className="float-left  mt-2">
                                                    <label className="catalog-label float-left mr-2">Status :</label>
                                                    <img src={imagePath} width="300" alt="status-img" className="status-img" />

                                                </div>
                                                <button className={`btn ${color} `}>{st}</button>
                                            </div>
                                       </>:null */ }

                                        {/*   <div className="col-md-12 mb-1 responsive-iphone-grid">
                                                <div className="row">
                                                    <div className="col-md-12 float-left  fav-maintence responsive-iphone-grid">

                                                        <div className="row">
                                                            <div className="col-md-2">
                                                                <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn float-left py-0 mr-2 mb-2 btn-continue" id="PassAuthe" onClick={() => this.PassAuthe()}><span className="btn-label"></span>Incident</button>
                                                            </div>
                                                        {checkboxL ?
                                                            <div className="col-md-2 pr-0 mb-2">
                                                                <label className="catalog-label mr-2" htmlFor={`OrderStatus${index + 1}`} >Buy again :</label>
                                                                <input type="checkbox" className="item-details-value my-1" id={`OrderStatus${index + 1}`} name="example1" onChange={() => this.selectOrder(index)} />

                                                            </div> : null}
                                                            <div className="col-md-8">
                                                                <div className="float-left  mt-2">
                                                                <label className="catalog-label float-left mr-2">Status :</label>
                                                                    <img src={imagePath} width="300" alt="status-img" className="status-img" />

                                                                </div>
                                                                <button className={`btn ${color} `}>{st}</button>
                                                            </div>
                                                        </div>
                                                         </div>
                                                          </div>
                                                </div>
                                            </div>
                                                        */}


                                    </div>

                                </div>

                                <div className="col-md-12 text-right mb-3">
                                    <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn mr-2" id={`Pass-${value.LINE_NBR}-${index}`} id="PassAuthe" onClick={() => this.PassAuthe(value)}>Incident</button>
                                    {/*[2/2/2022, PC_OS_01, WW-350, Dhevanesam R]*/}
                                    {value.hasCoreCharge == false ?
                                        <div class="d-inline-block">
                                            {value.LINE_STATUS != "Cancelled" && value.ISA_LINE_STATUS != "PNC" ? <div>
                                                <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn " id={`cancel-${value.LINE_NBR}-${index}`} id="CancelOrderBtn" onClick={() => this.CancelItemPopUpOpen(value, "Line")}>Cancel</button>
                                            </div> : null
                                            } </div> : null}
                                </div>

                            </div>
                        </div>

                    </td>
                </tr>

            )
        });


    }

    //WW-1230 - WO searvice channel navigation -Nandhini L
    WOClick = (e, WOServiceUrl) => {
        if (WOServiceUrl != "" && WOServiceUrl != undefined && WOServiceUrl != null) {
            window.open(WOServiceUrl);
            e.preventDefault();
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue. Please contact SDI customer care"
            });
        }
    }

    // Order Status Stored Procedure Integration Change - Deepthi

    bindHeaderDataGrid = () => {
        debugger
        console.log("headergrid", this.state.HeaderGridArray)
        if (this.state.HeaderGridArray.length > 0) {
            let locGridArr = this.state.HeaderGridArray.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === v.ORDER_NO.trim().toUpperCase())) === i);

            let status;
            let st;
            let color;
            let imagePath;
            return locGridArr.map((value, index) => {
                let orderNo = value.ORDER_NO;
                let orderArray = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == orderNo);
                let lineItem = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == orderNo);
                let hasCancelStatus = false;
                let hasApprovalChain = false;


                let cancelBtnStatuses = this.state.cancelBtnStatuses;
                orderArray.forEach((val, ind) => {
                    if (cancelBtnStatuses.includes(val.ISA_LINE_STATUS)) {
                        hasCancelStatus = true;
                    }
                })
                //22/11/2024, WW-1046 to find whether the order has all items in delivered status -Vishwa S
                let isRetunStatusValid = orderArray.every(val => val.ISA_LINE_STATUS === 'DLF' || val.ISA_LINE_STATUS === 'RCF');

                //[12/06/2024, WW-1221 to display quote order -Vishwa S]
                let isQuoteOrderValid = orderArray[0].ORDER_NO.startsWith('WQ')
                let QuoteOrderPlacedArr = orderArray.filter(val => val.ISA_LINE_STATUS === 'RFC' && val.LINEFIELD === 'RFQ');
                let isQuoteOrderCancled = orderArray.every(val => (val.ISA_LINE_STATUS === 'RFR' || val.ISA_LINE_STATUS === 'RFX') && val.LINEFIELD === 'RFQ');
                let QuoteOrderPartialCancled = orderArray.filter(val => (val.ISA_LINE_STATUS === 'RFR' || val.ISA_LINE_STATUS === 'RFX') && val.LINEFIELD === 'RFQ');
                let IsQuoteValidStatus = orderArray.every(val => val.ISA_LINE_STATUS === 'QRO' && val.LINEFIELD === 'RFQ');

                if (value.LINE_STATUS == 'QTW' && value.NEXTAPPROVER != null && value.NEXTAPPROVER.trim() != "") {
                    hasApprovalChain = true;
                }
                if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
                    let replcount = 0;
                    let isInv = false;
                    let InvItemArray = this.state.HeaderGridArray.filter((x) => x.ORDER_NO == value.ORDER_NO);
                    InvItemArray.map((value, index) => {
                        if (InvItemArray[index].LINEFIELD == "REPLN") {
                            replcount += 1;
                        }
                    });
                    if (InvItemArray.length == replcount) {
                        isInv = true;
                    }

                    if (value.ORDER_STATUS != "" && value.ORDER_STATUS != null) {
                        status = value.ORDER_STATUS;
                        st = status.split('^')[1];
                        color = status.split('^')[4];
                        if (color.toUpperCase() == "RED") {
                            color = "btn-red"
                        }
                        else if (color.toUpperCase() == "YELLOW") {
                            color = "btn-yellow"
                        }
                        else if (color.toUpperCase() == "GREEN") {
                            color = "btn-green"
                        }

                        imagePath = ((status.split('^')[3]) == 1 ? "images/chain0.png" :
                            (status.split('^')[3]) == 2 ? "images/chain1.png" :
                                (status.split('^')[3]) == 3 ? "images/chain2.png" :
                                    (status.split('^')[3]) == 4 ? "images/chain3.png" :
                                        (status.split('^')[3]) == 5 ? "images/chain4.png" : "images/chain6.png")

                    }
                    else {
                        imagePath = "images/chain0.png";
                        st = "Unknown";
                        color = "btn-gray";
                    }
                    return (
                        <React.Fragment key={value.ORDER_NO + index}>
                            {value.ORDER_NO != "" && !isQuoteOrderCancled && !QuoteOrderPlacedArr.length > 0 ? <>
                                <tr>
                                    <td className="text-center">

                                    </td>
                                    <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index, value.ORDER_NO)} >
                                        <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                                    </td>
                                    {/*WW-1230 - WO searvice channel navigation -Nandhini L*/}
                                    <td className="d-sm-none d-md-table-cell d-flex">
                                        <div className="d-flex align-items-center">
                                            <div className="mr-2" >{isQuoteOrderValid ? value.ORDER_NO : <a href="#" data-toggle="modal" id={`OrderNo-${index}`} data-backdrop="static" data-keyboard="false" data-target=".orderstatus-popup" onClick={(e) => this.OrderStatusPopup(value)} >{value.ORDER_NO}</a>}{isInv == true ? <span className="indicate-imp"> </span> : null}</div>
                                            {value.HEADER_NOTES ?
                                                <a href="#" className="orderNotes" id={`orderNotes-${index}`} onClick={(e) => this.getNotes(e, value.ORDER_NO, 0, "")}> <img src="Images/notes-icon.svg" alt="close"/></a> : null}
                                        </div>
                                    </td>

                                    <td className="d-none d-sm-none d-md-table-cell" ><div style={{ width: '80px' }}><a href="#" id={`WO#-${index}`} onClick={(e) => this.WOClick(e, value.TOKEN)} >{value.ISA_WORK_ORDER_NO}</a></div></td>


                                    <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '110px' }} id={`billtostore-${index}`}>{value.INSTALL_STORE}</div></td>

                                    {/* //pc-1138-03 changing the employee id to user name S.Sanjay 8/1/2024*/}
                                    <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '100px', wordBreak: "break-all" }} id={`ENTEREDEMPNAME-${index}`}>{value.ENTERED_EMPNAME}</div></td>
                                    <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }} id={`ORD_DATE-${index}`}>{value.ORD_DATE}</div></td>

                                    <>
                                        <td className="d-none d-sm-none d-md-table-cell">
                                            <div style={{ width: '430px' }} className="float-left  mt-2">

                                                <img src={imagePath} onError={(e) => { e.target.src = "/Images/noimage_new.png" }} id={`StatusImg-${index}`} width="100" alt="status-img" className="status-img" style={{ width: '240px', marginTop: '6px', marginRight: '0px' }} />

                                                <button className={`btn ${color} `} id={`StatusId-${index}`} style={{ pointerEvents: "none", fontSize: '13px', padding: '4px 15px' }}>{st}</button>
                                            </div>

                                        </td>
                                    </>
                                    <td className="d-none d-sm-none d-md-table-cell text-center">
                                        <div className="dropdown">
                                            <button className="btn dots-style" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <img src="images/3-dots.svg" alt="3-dots" />
                                            </button>
                                            <div className="dropdown-menu action-dropdown-style ml-5 px-2" aria-labelledby="dropdownMenuButton">
                                                {hasApprovalChain ? <a className="dropdown-item dropdown-style Font-14 font-medium cursor-pointer" onClick={(e) => this.GetApproversList(value.ISA_EMPLOYEE_ID, value.ORDER_NO, orderArray, value.ISA_WORK_ORDER_NO)}>
                                                    <img src="images/approver-chain.svg" className="approver-chain ps-1" alt="approver-chain" />
                                                    Approval Chain
                                                     </a> : null}
                                                {/*[21/12/2023] PS_OS-03 Zeus 235 added the incident button & it's functionalities - Harshitha */}
                                                <a className={`dropdown-item dropdown-style Font-14 font-medium cursor-pointer ${hasApprovalChain ? 'border-top' : ''}`} onClick={(e) => this.PassAutheLine(value, value)}>
                                                    <img src="images/Incident.svg" className="incident-style ps-1" alt="incident" />
                                                    Incident
                                                    </a>
                                                {!hasCancelStatus ? <a className={`dropdown-item dropdown-style Font-14 font-medium cursor-pointer ${!hasCancelStatus ? 'border-top' : ''}`} id={`${value.ORDER_NO}cancel-${index}`} onClick={(e) => this.CancelLineLevelItem(value, "Order")}>
                                                    <img src="images/cancel-order.svg" className="cancel-order ps-1" alt="cancel-order" />
                                                    Cancel Order
                                                    </a> : null}
                                                {isRetunStatusValid ? <a className={`dropdown-item dropdown-style Font-14 font-medium cursor-pointer ${!hasCancelStatus ? 'border-top' : ''}`} id={`${value.ORDER_NO}return-${index}`} onClick={(e) => this.startAReturnClick(value, "ORDER")}>
                                                    <img src="images/start-a-return-icon.svg" className="cancel-order ps-1" width={20} height={20} alt="Start-a-return" />
                                                    Start a return
                                                    </a> : null}
                                                {isQuoteOrderValid && !QuoteOrderPartialCancled.length > 0 && IsQuoteValidStatus ? <a className={`dropdown-item dropdown-style Font-14 font-medium cursor-pointer ${!hasCancelStatus || isRetunStatusValid ? 'border-top' : ''}`} id={`${value.ORDER_NO}return-${index}`}
                                                    onClick={(e) => {
                                                        OrderLevelQuoteClick = true;
                                                        this.onAccordianClick(e, index, value.ORDER_NO)
                                                    }}>
                                                    <img src="images/order-quote.svg" className="cancel-order ps-1" width={20} height={20} alt="Start-a-return" />
                                                    Order quote
                                                    </a> : null}
                                            </div>
                                        </div>
                                    </td>







                                    {/*<td className="d-none d-sm-none d-md-table-cell">
                                            <div className="text-nowrap">
                                                {value.LINE_STATUS == 'QTW' && value.NEXTAPPROVER != null && value.NEXTAPPROVER.trim() != "" ? <button className="btn btn-primary custom-btn-primary primary-btn" onClick={(e) => this.GetApproversList(value.USERID, value.ISA_EMPLOYEE_ID, value.NEXTAPPROVER, value.ORDER_NO, lineItem)}>Approval chain</button> : null}
                                            </div>
                                        </td>
                                    </>
                                    {/*[03/17/23, OS_PC_01-33178], Priyanka D-Showing Cancel icon based on line items 
                                    <td className="d-none d-sm-none d-md-table-cell"> <div>
                                        {hasCancelStatus == false ? <button id={`${value.ORDER_NO}cancel-${index}`} className="btn btn-labeled btn-primary custom-btn-primary primary-btn float-left py-0 mr-2 mb-2 mt-2 btn-continue" id="CancelOrderBtn" onClick={() => this.CancelLineLevelItem(value, "Order")}>Cancel</button> : null}
                                    </div></td>
                                    */}

                                </tr>
                                <tr className="p d-none content-row" id={`contentrow-${index}`}>
                                    <td colSpan="12" >
                                        {this.state.LineDetailsGrid.length > 0 ? <div className="accordian-body" id="order-row-1">
                                            <div className="row justify-content-center">
                                                <div className="col-md-12">
                                                    <table className="table ZEUS_Grid FOM-grid chk-ordertbl mt-3">
                                                        <tbody>

                                                            <h4 className="item-details-title mb-3"><Trans>ItemKey</Trans><span> </span><Trans>details</Trans></h4>
                                                            {this.bindLineGriddata(value.ORDER_NO, index)}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div> :
                                            <div style={{ "display": "flex", "justifyContent": "center" }} id="RotatingLinesId">
                                                <RotatingLines
                                                    strokeColor="#fcb913"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    width="50"
                                                    visible={true} />
                                            </div>}
                                    </td>
                                </tr>
                            </> : null}
                        </React.Fragment>
                    )


                }
            });

        }
    }






    //***********GridBind********************************
    bindDataGrid = () => {
        const uniqueTags = [];
        let countorder = 0;
        let OrderArray = [];
        console.log("GridArrOrder", this.state.GridArr)
        if (this.state.GridArr.length > 0) {

            let locGridArr = this.state.GridArr.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === v.ORDER_NO.trim().toUpperCase())) === i)
            //let InvItemArray1 = this.state.GridArr.filter((x) => x.LINEFIELD == "REPLN");
            //console.log("InvItemArrayGrid", this.state.InvGridArr);

            //if (this.state.toggleChecked) {

            //    OrderArray = this.state.InvGridArr;
            //}
            //else {
            //    OrderArray = this.state.GridArr;
            //}
            //WW-399_PC_07 (5/16/2022)-Aparna
            return locGridArr.map((value, index) => {
                console.log("locGridArr", this.state.GridArr)
                //WW-380 handleing pagination in front end -Aparna
                if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
                    let order_number = "";
                    let isInv = false;
                    let work_ordernumber = "";
                    let business_unit = "";
                    let priority = "";
                    let enterby = "";
                    let enterfor = "";
                    let poid = "";
                    let storenum = "";
                    let OrdNum = value.ORDER_NO;
                    if (uniqueTags.indexOf(value.ORDER_NO) == -1) {
                        uniqueTags.push(value.ORDER_NO);
                        order_number = value.ORDER_NO;
                        work_ordernumber = value.ISA_WORK_ORDER_NO;
                        business_unit = value.BUSINESS_UNIT_OM;
                        priority = value.LINE_PRIOR;
                        enterby = value.ENTEREDEMPNAME;
                        enterfor = value.OPRID_ENTERED_BY;
                        poid = value.PO_ID1;
                        storenum = value.SHIPTO_ID;
                    }
                    let checkboxL = false;
                    let lable = "Ship To";
                    let disp = value.SHIPTO_ID;
                    console.log("disp", disp);
                    let imagePath = "";
                    let status = "";
                    let st = "";
                    let color = "";
                    let apoinfo = "";
                    let tracking_num = "-";
                    let tracking_link = "-";
                    let carrier = "-";
                    let replcount = 0;
                    let InvItemArray = this.state.GridArr.filter((x) => x.ORDER_NO == value.ORDER_NO);
                    InvItemArray.map((value, index) => {
                        if (InvItemArray[index].LINEFIELD == "REPLN") {
                            replcount += 1;
                        }
                    });
                    if (InvItemArray.length == replcount) {
                        isInv = true;
                    }
                    if (value.APOINFO != null) {
                        apoinfo = value.APOINFO.split(',');
                        if (apoinfo[9].trim().length > 0) { tracking_num = apoinfo[9]; }
                        if (apoinfo[10].trim().length > 0) { carrier = apoinfo[10]; }
                        if (apoinfo[11].trim().length > 0) {
                            tracking_link = apoinfo[11];
                            console.log("tracking_link ", tracking_link);
                        }
                    }
                    // //;
                    debugger
                    if (Session_BUSUNIT == value.BUSINESS_UNIT_OM) {
                        //Bug 2737 removing checkbox for Stock issues order (10/12/2022)-Aparna
                        if ((value.LINEFIELD == "ZEUS") || (value.LINEFIELD == "PCH") || (value.LINEFIELD == "RFQ") || (value.LINEFIELD == "NSTK")) {

                            checkboxL = true;

                        }
                        //[12/15/21, PC_OS_03, WW-300, Dhevanesam R - To check null condition for the order status value] 
                        if (value.ORDER_STATUS != "" && value.ORDER_STATUS != null) {
                            status = value.ORDER_STATUS;
                            st = status.split('^')[1];
                            color = status.split('^')[4];
                            if (color.toUpperCase() == "RED") {
                                color = "btn-red"
                            }
                            else if (color.toUpperCase() == "YELLOW") {
                                color = "btn-yellow"
                            }
                            else if (color.toUpperCase() == "GREEN") {
                                color = "btn-green"
                            }

                            imagePath = ((status.split('^')[3]) == 1 ? "images/chain0.png" :
                                (status.split('^')[3]) == 2 ? "images/chain1.png" :
                                    (status.split('^')[3]) == 3 ? "images/chain2.png" :
                                        (status.split('^')[3]) == 4 ? "images/chain3.png" :
                                            (status.split('^')[3]) == 5 ? "images/chain4.png" : "images/chain6.png")

                        }
                        else {
                            imagePath = "images/chain0.png";
                            st = "Unknown";
                            color = "btn-gray";
                        }
                        /*********NEW**wal-158************/


                        if (this.state.Pickup_VendorList.length > 0) {

                            this.state.Pickup_VendorList.map((i) => {


                                if (value.SUPPLIER != "" && value.SUPPLIER != " " && value.SUPPLIER != undefined && value.SUPPLIER != null) {


                                    if ((value.LOCATION2 != "" && value.LOCATION2 != " " && value.LOCATION2 != undefined && value.LOCATION2 != null) || value.SUPPLIER.toUpperCase().includes("LOWE'S")) {

                                        lable = "Pickup"
                                        if (this.state.Pickup_store_tbl.length > 0) {
                                            this.state.Pickup_store_tbl.forEach((val, index) => {
                                                if (val.ADDRESS3 == value.LOCATION2 && val.NAME1.toUpperCase() == value.SUPPLIER.toUpperCase()) {
                                                    disp = val.ADDRESS1 + "," + val.CITY + "," + val.STATE;
                                                }
                                                if (disp == value.SHIPTO_ID) {
                                                    disp = "Pick-Up"
                                                }
                                            })

                                        }
                                        else {
                                            disp = "Pick-Up"
                                        }
                                    }



                                }

                            })

                        }
                        /*************END***************/


                    }
                    return (
                        <React.Fragment key={value.ORDER_NO + index}>
                            {order_number != "" ? <>
                                <tr>
                                    <td className="text-center">

                                        {/*checkboxL ?
                                        <div className="custom-control custom-checkbox item-custom-control">

                                            <input type="checkbox" className="custom-control-input" id={`OrderStatus${index + 1}`} name="example1" onChange={() => this.selectOrder(index)} />
                                            <label className="custom-control-label" htmlFor={`OrderStatus${index + 1}`} />
                                        </div> : null */}
                                    </td>
                                    <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
                                        <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                                    </td>
                                    <td className="d-sm-none d-md-table-cell"><div style={{ width: '100px' }}><a href="#" className="order-id" data-toggle="modal" id={`OrderNo-${index}`} data-backdrop="static" data-keyboard="false" data-target=".orderstatus-popup" onClick={(e) => this.OrderStatusPopup(value)} >{OrdNum}</a>{isInv == true ? <span className="indicate-imp"> </span> : null}</div></td>
                                    {/*<td>{value.LINE_NBR}</td>*/}
                                    {/* <td>{value.A_MY_STATUS}</td>*/}
                                    {/*<td className="d-none d-sm-none d-md-table-cell" >{value.INV_ITEM_ID}</td>*/}
                                    <td className="d-none d-sm-none d-md-table-cell" ><div style={{ width: '80px' }} id={`WO#-${index}`}>{value.ISA_WORK_ORDER_NO}</div></td>
                                    {/* <td className="d-none d-sm-none d-md-table-cell">{value.BUSINESS_UNIT_OM}</td>*/}

                                    <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '110px' }} id={`billtostore-${index}`}>{value.BILL_TO_STORE}</div></td>
                                    {/*<td className="d-none d-sm-none d-md-table-cell priority-alert">{value.LINE_PRIOR}</td>*/}
                                    {/* <td className="d-none d-sm-none d-md-table-cell">{value.ENTEREDEMPNAME}</td>*/}
                                    <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '100px' }} id={`ENTEREDEMPNAME-${index}`}>{value.ENTEREDEMPNAME}</div></td>
                                    <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }} id={`ORD_DATE-${index}`}>{value.ORD_DATE}</div></td>
                                    {/* <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }}><a href="#" className="order-id" data-toggle="modal" data-target="#po-details" onClick={(e) => this.PODetailPopup(value)}>{value.PO_ID1}</a></div></td>*/}
                                    {/* {value.ORDER_STATUS.length > 0 ? */}<>
                                        <td className="d-none d-sm-none d-md-table-cell">
                                            <div style={{ width: '430px' }} className="float-left  mt-2">

                                                <img src={imagePath} onError={(e) => { e.target.src = "/Images/noimage_new.png" }} id={`StatusImg-${index}`} width="100" alt="status-img" className="status-img" style={{ width: '240px', marginTop: '6px', marginRight: '0px' }} />

                                                <button className={`btn ${color} `} id={`StatusId-${index}`} style={{ pointerEvents: "none", fontSize: '13px', padding: '4px 15px' }}>{st}</button>
                                            </div>




                                        </td>
                                    </> {/*: null}*/}
                                    {/*[2/2/2022, PC_OS_01, WW-350, Dhevanesam R]*/}
                                    <td className="d-none d-sm-none d-md-table-cell">{value.ORDER_STATUS != null ? <div>{/*WW-350_PC_02 hiding cancel button for **/}
                                        {!value.ORDER_STATUS.includes("Cancelled") && value.ISA_LINE_STATUS != "PNC" ? <button id={`${OrdNum}cancel-${index}`} className="btn btn-labeled btn-primary custom-btn-primary primary-btn float-left py-0 mr-2 mb-2 mt-2 btn-continue" id="CancelOrderBtn" onClick={() => this.CancelItemPopUpOpen(value, "Order")}>Cancel</button> : null}
                                    </div> : null}</td>


                                </tr>
                                <tr className="p d-none content-row" id={`contentrow-${index}`}>
                                    <td colSpan="12" >
                                        <div className="accordian-body" id="order-row-1">
                                            <div className="row justify-content-center">
                                                <div className="col-md-12">
                                                    <table className="table ZEUS_Grid FOM-grid chk-ordertbl mt-3">
                                                        <tbody>
                                                            {/*   <tr className="p d-none content-row" id={`contentrow-${index}`}> */}
                                                            <h4 className="item-details-title mb-3"><Trans>ItemKey</Trans><span> </span><Trans>details</Trans></h4>
                                                            {this.linedatagrid(value.ORDER_NO, value.PO_ID1)}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                {/*<tr className="p ">
                                <td colSpan={12} className="hiddenRow">
                                    <div className="accordian-body  py-3 px-5" id="order-row-1">
                                        <div className="row justify-content-center">
                                            <div className="col-md-12">
                                                <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                                     <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th></th>
                                                            <th class="d-none d-sm-none d-md-table-cell position-sort-icon ">Line #<span class="sort-up ml-1"><img src="Images/sort2.svg"/></span><span class="sort-down ml-1"><img src="Images/sort1.svg"/></span></th>
                                                            <th class="d-none d-sm-none d-md-table-cell position-sort-icon ">Item ID <span class="sort-up ml-1"><img src="Images/sort2.svg" /></span><span class="sort-down ml-1"><img src="Images/sort1.svg" /></span></th>

                                                        <th className="position-sort-icon ">Status<span className="sort-up ml-1"><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" /></span></th>

                                                            <th className="d-sm-none d-md-table-cell position-sort-icon ">Priority<span className="sort-up ml-1"><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" /></span></th>
                                                            <th className="d-sm-none d-md-table-cell position-sort-icon ">Entered for<span className="sort-up ml-1"><img src="Images/sort2.svg" /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" /></span></th>

                                                        </tr>
                                                    </thead> 
                                                    {this.linelevelGrid(value.ORDER_NO, tracking_link, tracking_num, imagePath, color, st, lable,disp)}
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                        </tr>*/}  </> : null}




                            {/* <tr className="p d-none content-row" id={`contentrow-${index}`}>
                            <td colSpan={12} className="hiddenRow " id="order-row-1" >
                                <div className="py-1" id={`order-row-${index}`}>
                                    <h4 className="item-details-title pl-5 mt-3 mb-3">item details</h4>
                                    <div className="row mx-0 pb-3">
                                        <div className="col-md-12 pl-5">
                                            <div className="row">
                                                <div className="col-md-12 mb-1">
                                                <div className="col-md-7 mb-1 responsive-iphone-grid">
                                                    <div className="row">
                                                            <div className="col-12 mobile-fieldscontainer p-0">
                                                                <div className="col-12 mobile-fields">
                                                                <label className="catalog-label float-none">Item ID:</label>
                                                                    <label className="item-details-value">{value.INV_ITEM_ID}</label>
                                                            </div>
                                                            <div className="col-12 mobile-fields">
                                                                <label className="catalog-label float-none">Work Order:</label>
                                                                    <label className="item-details-value">{value.ISA_WORK_ORDER_NO}</label>
                                                            </div>
                                                            <div className="col-12 mobile-fields">
                                                                <label className="catalog-label float-none">Business Unit:</label>
                                                                    <label className="item-details-value">{value.BUSINESS_UNIT_OM}</label>
                                                            </div>
                                                            <div className="col-12 mobile-fields">
                                                                <label className="catalog-label float-none">Priority:</label>
                                                                    <label className="item-details-value priority-alert">{value.LINE_PRIOR}</label>
                                                            </div>
                                                            <div className="col-12 mobile-fields">
                                                                <label className="catalog-label float-none">Order Entered by:</label>
                                                                    <label className="item-details-value">{value.ENTEREDEMPNAME}</label>
                                                            </div>
                                                            <div className="col-12 mobile-fields">
                                                                <label className="catalog-label float-none">Ordered For:</label>
                                                                    <label className="item-details-value">{value.OPRID_ENTERED_BY}</label>
                                                            </div>
                                                            <div className="col-12 mobile-fields">
                                                                <label className="catalog-label float-none">PO ID:</label>
                                                                 <a href="#" className="order-id" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#po-details" onClick={(e) => this.PODetailPopup(value)}>{value.PO_ID1}</a>


                                                            </div>
                                                            </div>
                                                            </div>
                                                        <div className="col-md-3 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">Order Date:</label>
                                                            <label className="item-details-value float-none">{value.ORD_DATE}</label>
                                                        </div>
                                                        <div className="col-md-2 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">QTY:</label>
                                                            <label className="item-details-value float-none">{value.QTY_REQ}</label>
                                                        </div>
                                                        <div className="col-md-3 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">QTY Recv:</label>
                                                            <label className="item-details-value float-none">{value.QTY_RECEIVED}</label>
                                                        </div>
                                                        <div className="col-md-4 pr-0 fav-maintence responsive-iphone-grid">
                                                        {value.EXPECTED_DATE != "" || value.EXPECTED_DATE != null || value.EXPECTED_DATE != undefined ?
                                                            <label className="catalog-label float-none">Expected Delivery date:</label>
                                                            <label className="item-details-value float-none">{value.EXPECTED_DATE}</label>
                                                            }:null
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 mb-1 responsive-iphone-grid">
                                                    <div className="row">
                                                        <div className="col-md-4 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">Rev. Due date:</label>
                                                            <label className="item-details-value float-none">{!value.REV_DUE_DT1 ? "-" : value.REV_DUE_DT1}</label>
                                                        </div>
                                                        <div className="col-md-4 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">Approved By:</label>
                                                            <label className="item-details-value float-none pl-1">{value.OPRID_APPROVED_BY}</label>
                                                        </div>
                                                        <div className="col-md-4 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">Currency:</label>
                                                            <label className="item-details-value float-none pl-1">{value.CURRENCY}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 mb-1 pr-0 responsive-iphone-grid">
                                                    <div className="col-md-9 float-left p-0 fav-maintence responsive-iphone-grid">
                                                        <label className="catalog-label float-left p-0 descrip">Description:</label>
                                                        <label className="item-details-value col-md-8 pl-1 p-0 float-none">{value.DESCR254}</label>
                                                    </div>
                                                    <div className="col-md-3 float-left p-0 fav-maintence responsive-iphone-grid">
                                                        <label className="catalog-label float-none">Asset Tag ID:</label>
                                                        <label className="item-details-value float-none pl-1">{value.ISA_MACHINE_NO}</label>
                                                    </div>
                                                    {/*<div className="col-md-3 float-left p-0 fav-maintence responsive-iphone-grid">
                                                        <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn float-left py-0 mr-2 mb-2 btn-continue" id="PassAuthe" onClick={() => this.PassAuthe()}>
                                                            <span className="btn-label"></span>Incident</button>
                                                    </div>*/}
                            {/* </div>
                                                <div className="col-md-5 mb-1 responsive-iphone-grid">
                                                    <div className="row">
                                                        <div className="col-md-4 pr-0 fav-maintence responsive-iphone-grid">                                                         
                                                           <label className="catalog-label float-none">Ship Doc:</label> 
                                                            {this.shiptobind(value)}
                                                        </div>

                                                        <div className="col-md-4 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">Tracking #:</label>
                                                            {value.A_TRACK_SHIPVIA == "UPS" ?
                                                                <label className="item-details-value float-none">{value.A_TRACK_NO}</label> :
                                                                <a href={"http://wwwapps.ups.com/WebTracking/processInputRequest?HTMLVersion=5.0&sort_by=status&term_warn=yes&tracknums_displayed=5&TypeOfInquiryNumber=T&loc=en_US&InquiryNumber1= " + value.A_TRACK_NO + "&InquiryNumber2=&InquiryNumber3=&InquiryNumber4=&InquiryNumber5=&AgreeToTermsAndConditions=yes&track.x=25&track.y=9"} target="_blank">{value.A_TRACK_NO} </a>
                                                            }
                                                        </div>
                                                        <div className="col-md-4 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-none">History:</label>
                                                            <a href="#" data-toggle="modal" data-target="#order-approval-history" data-backdrop="static" data-keyboard="false" className="history-icon float-none" onClick={(e) => this.Approvalhistory(value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-1 responsive-iphone-grid">
                                                    <div className="row">
                                                        <div className="col-md-6 pr-0 fav-maintence responsive-iphone-grid">                                                          
                                                            <label className="catalog-label float-none">{lable}:</label>
                                                            <label className="item-details-value col-md-8 pl-1 p-0 float-none">{disp}</label>

                                                        </div>
                                                        <div className="col-md-6 pr-0 fav-maintence responsive-iphone-grid">
                                                            <label className="catalog-label float-left">Order Status:</label>
                                                            <img src={imagePath} width="300" alt="status-img" className="status-img" />
                                                            <button className={`btn  ${color}` }>{st}</button>
                                                        </div>
                                                        

                                                    </div>
                                                </div>
                                                {/****NEW**wal-158****/}
                            {/*  <div className="col-md-7 mb-1 pr-0 responsive-iphone-grid">
                                                    <div className="row">
                                                        <button className="btn btn-labeled btn-primary custom-btn-primary primary-btn float-left py-0 mr-2 mb-2 btn-continue" id="PassAuthe" onClick={() => this.PassAuthe()}>
                                                            <span className="btn-label"></span>Incident</button>
                                                        </div>
                                                    </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr> */ }
                        </React.Fragment>
                    )
                }
            });
        }
    }
    PassAuthe = (val) => {
        //
        let customFields = []
        //WW-216
        customFields.push({
            customFieldName: "order_number",
            customFieldValue: val.ORDER_NO
        })
        let PassAutheBO = {
            UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
            PassWord: "",
            OrderNumber: val.ORDER_NO,
            PONumber: val.PO_ID1,
            HomepageRequest: false,
            IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
            customFields: customFields
        }
        OrderStatusAction.getPassThroughAutheURl(PassAutheBO)
    }
    // Order Status Stored Procedure Integration Change - Deepthi
    PassAutheLine = (val, headerData) => {
        //
        let customFields = []
        //WW-216
        customFields.push({
            customFieldName: "order_number",
            customFieldValue: val.ORDER_NO//WW-656
        })
        let PassAutheBO = {
            UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
            IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
            PassWord: "",
            OrderNumber: val.ORDER_NO,//WW-656
            PONumber: val.PO_ID1,
            HomepageRequest: false,/*[03/23/23, WW-677_02], Priyanka D */
            customFields: customFields,
            WorkOrder: headerData.ISA_WORK_ORDER_NO
        }
        OrderStatusAction.getPassThroughAutheURl(PassAutheBO)
    }
    PassThroughAutheResponse = () => {
        console.log("OrderStatusStore.PassThroughAuthe", OrderStatusStore.PassThroughAuthe)
        let URl = JSON.parse(OrderStatusStore.PassThroughAuthe)
        console.log("URl", URl)
        window.open(URl);
        window.preventDefault();//WW-656
    }
    PoStatus = (val) => {


        ////;
        if (this.state.POData.length > 0) {
            let status = "Active";
            let value = val.CANCEL_STATUS;
            console.log("cancel status", value);
            // //;
            switch (value) {
                case "A":
                    status = "Active"
                    break;
                //return <td>Active</td>
                case 'C':
                    status = "Closed"
                    break;
                //return <td>Closed</td>
                case 'D':
                    status = "Denied"
                    break;
                case 'H':
                    status = "Hold"
                    break;
                case 'O':
                    status = "Open"
                    break;
                case 'P':
                    status = "Pending"
                    break;
                case 'X':
                    status = "Canceled"
                    break;

            }
            return (
                <td>{status}</td>
            );
        }
    }

    PoHdStatus = () => {

        if (this.state.POData.length > 0) {
            console.log("status", this.state.POData[0].PO_STATUS);
            let Hdstatus = "Initial";
            let val = this.state.POData[0].PO_STATUS;
            switch (val) {
                case 'A':
                    Hdstatus = "Approved"
                    break;
                case 'C':
                    Hdstatus = "Complete"
                    break;
                case 'D':
                    Hdstatus = "Dispatched"
                    break;
                case 'DA':
                    Hdstatus = "Denied"
                    break;
                case 'I':
                    Hdstatus = "Initial"
                    break;
                case 'LD':
                    Hdstatus = "Line Denied"
                    break;
                case 'O':
                    Hdstatus = "Open"
                    break;
                case 'PA':
                    Hdstatus = "Pend Appr"
                    break;
                case 'PX':
                    Hdstatus = "Pend Cncl"
                    break;
                case 'X':
                    Hdstatus = "Canceled"
                    break;


            }
            return (
                <label className="info-value pl-1">{Hdstatus}</label>

            );
        }
    }
    //WW-819_PC_04 -Aparna
    bindTracking_no = (val) => {
        return this.state.POTracking_no.map((value) => {
            if (val.LINE_NBR == value.LINE_NBR)
                return (
                    <>
                        <div className="col-md-3 pr-0 pl-2 responsive-iphone-grid">
                            <label className="catalog-label float-none  mr-2"><Trans>Tracking no</Trans><span>:</span></label>
                            <label className="item-details-value float-none"> <a href={value.ISA_NEW_URL} target="_blank" >{value.ISA_ASN_TRACK_NO} </a>
                            </label></div>
                        <div className="col-md-8 pr-0 pl-2 responsive-iphone-grid">
                            <label className="catalog-label float-none  mr-2"><Trans>Ship Date</Trans><span>:</span></label>
                            <label className="item-details-value float-none">{value.ISA_ASN_SHIP_DT}
                            </label></div>
                    </>
                )
        })
    }


    //*****************GridBind End****************************
    //************************************PoDettil grid bind********************
    bindPODataGrid = () => {
        ////;
        if (this.state.POData.length > 0) {


            return this.state.POData.map((value, index) => {
                /*Not able to navigate when we click on tracking number issue, Priyanka D */
                let TrackNo = value.ISA_ASN_TRACK_NO.split("||")
                let TrackNum
                if (TrackNo != undefined) {
                    TrackNum = TrackNo[0].replace("||", "")
                }
                return (
                    <>
                        <tr>
                            {/* <td data-toggle="collapse" data-target="#order-row-1-popup" className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)}>*/}
                            <td className="accordion-toggle" onClick={(e) => this.onAccordianPOClick(e, index)} >
                                <span className="accordion-arrow header-arrow tryH" id={`arrowPOHeader-${index}`} />
                            </td>
                            <td>{value.REQ_LINE_NBR}</td>
                            <td>{value.LINE_NBR}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.SCHED_NBR}</td>
                            {this.PoStatus(value)}
                            <td className="d-none d-sm-none d-md-table-cell">{value.ORIG_DUE_DT}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.DUE_DT}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.req_by_date}</td>
                            <td className="text-right d-none d-sm-none d-md-table-cell">{value.QTY_PO}</td>
                            <td className="text-right d-none d-sm-none d-md-table-cell">{value.QTY_LN_RECVD == " " ? "0.00" : value.QTY_LN_RECVD}</td>
                            <td className="text-right d-none d-sm-none d-md-table-cell">{value.QTY_LN_REJCT == " " ? "0.00" : value.QTY_LN_REJCT}</td>
                            {this.state.showprice != "0" && this.state.blockprice == "N" ? <td className="text-right">{value.purchase_price}</td> : null}
                        </tr>
                        <tr className="p d-none content-row try" id={`contentPOrow-${index}`}>
                            <td colSpan={12} className="hiddenRow">
                                <div className="py-1">
                                    <div className="row mx-0 pb-3">
                                        <div className="col-md-12 pl-5">
                                            <div className="row">
                                                <div className="col-md-12 mb-1">
                                                    <div className="row mx-0 pb-3">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-12 mb-1">
                                                                    <div className="row">
                                                                        {/*<div className="col-12 mobile-fieldscontainer p-0">*/}
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            {/*<div className="col-12 mobile-fields">*/}
                                                                            <label className="catalog-label mr-2">Sch #:</label>
                                                                            <label className="item-details-value">{value.SCHED_NBR}</label>
                                                                            {/*</div>*/}
                                                                        </div>
                                                                        {/*<div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                                <label className="catalog-label"><span>Orig. Due </span><Trans>Date</Trans><span>:</span></label>
                                                                                <label className="item-details-value">{value.ORIG_DUE_DT}</label>
                                                                            </div>*/}
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label  mr-2"><Trans>Delivery</Trans><span> </span><Trans>Date</Trans>:</label>
                                                                            <label className="item-details-value">{value.DUE_DT}</label>
                                                                        </div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label  mr-2"><Trans>Request by</Trans><span> </span><Trans>Date</Trans>:</label>
                                                                            <label className="item-details-value ">{value.req_by_date}</label>
                                                                        </div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label  mr-2">PO QTY:</label>
                                                                            <label className="item-details-value">{value.QTY_PO}</label>
                                                                        </div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label  mr-2"><Trans>Received</Trans><span> QTY:</span></label>
                                                                            <label className="item-details-value">{value.QTY_LN_RECVD == " " ? "0.00" : value.QTY_LN_RECVD}</label>
                                                                        </div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label  mr-2"><Trans>Reject</Trans><span> QTY:</span></label>
                                                                            <label className="item-details-value">{value.QTY_LN_REJCT == " " ? "0.00" : value.QTY_LN_REJCT}</label>
                                                                        </div>
                                                                        {/*</div>*/}
                                                                        {this.state.showprice != "0" && this.state.blockprice == "N" ?
                                                                            <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                                <label className="catalog-label float-none  mr-2"><span>Ext. </span><Trans>Price</Trans><span>:</span></label>
                                                                                <label className="item-details-value float-none pl-1">{value.ext_price}</label>
                                                                            </div> : null}
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none  mr-2"><Trans>Item ID</Trans><span>:</span></label>
                                                                            <label className="item-details-value float-none pl-1">{value.MFG_ITM_ID == " " ? "Non-Stock" : value.MFG_ITM_ID}</label>
                                                                        </div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none  mr-2">MFG:</label>
                                                                            <label className="item-details-value float-none pl-1">{value.MFG_ID}</label>
                                                                        </div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none  mr-2"><span>Supplier </span><Trans>Part</Trans><span> Num:</span></label>
                                                                            <label className="item-details-value float-none pl-1">{value.ISA_ITEM}</label>
                                                                        </div>
                                                                        {/* <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none"><Trans>Tracking</Trans><span> Num: </span><span>  </span></label>
                                                                            {/*Not able to navigate when we click on tracking number issue, Priyanka D */}
                                                                        {/* {TrackNo[1] != null && TrackNo[1] != undefined && TrackNo[1] != "" && TrackNo[1] != " " ?
                                                                                <a href={TrackNo[1]} target="_blank" >{TrackNum} </a> :
                                                                                <label className="catalog-label float-none">{TrackNum} </label>
                                                                                }

                                                                        </div>*/}
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none  mr-2"><Trans>Ship Via</Trans><span>:</span></label>
                                                                            <label className="item-details-value float-none">{value.ISA_ASN_SHIP_VIA}
                                                                            </label></div><div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none  mr-2"><Trans>Invoice</Trans><span>:</span></label>
                                                                            <label className="item-details-value float-none">{value.invoice_id}
                                                                            </label></div><div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none  mr-2"><Trans>Invoice</Trans><span> Amt:</span></label>
                                                                            <label className="item-details-value float-none" >{value.invoice_amt}</label></div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid"><label className="catalog-label float-none mr-2"><Trans>Invoice</Trans><span> </span><Trans>Date</Trans><span>:</span></label>
                                                                            <label href="#" className="item-details-value float-none">{value.invoice_date}</label></div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid"><label className="catalog-label float-none mr-2"><Trans>Packing Slips</Trans><span>:</span></label>
                                                                            {this.packingSlip(value)}
                                                                        </div>
                                                                        <div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none  mr-2"><span>Emp.</span><Trans>Name</Trans><span>:</span></label>
                                                                            <label className="item-details-value float-none">{value.OPRID_ENTERED_BY}</label>
                                                                        </div>
                                                                        {/**
                                                                         *WW-819_PC_01 */}
                                                                        <div className="col-md-12 pr-0  responsive-iphone-grid">
                                                                            <div className="row">

                                                                                {this.bindTracking_no(value)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 mb-1 ">
                                                                    <div className="row">
                                                                        <div className="col-md-12 pr-0">
                                                                            <label className="item-details-value w-100">{value.DESCR254_MIXED}</label>
                                                                        </div>
                                                                    </div></div>
                                                            </div>
                                                        </div></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </>
                )
            });
        }
        if (this.state.POData.length == 0) {
            return (
                <span className="noitemdisplay" id="StatusMsg"><Trans>No records to display</Trans></span>
            );
        }
    }

    packingSlip = (OrderDetail) => {
        let packingSlip = this.state.packingSlip.filter((item, index) => item.INV_ITEM_ID == OrderDetail.INV_ITEM_ID);
        return packingSlip.map((Item, index) => {
            //;
            if (Item.Packslip == true) {
                return (
                    <label className="item-details-value"><a href="#"><img src="Images/history.png" /></a></label>
                );
            }
        })
    }
    PODetailhd = () => {
        //;
        if (this.state.VenderDetail.length > 0) {

            let VenderDetail = this.state.VenderDetail;
            console.log("address", this.state.VenderDetail);
            let separatedArray = [];
            let Phone = [];
            Phone = this.state.VenderDetail[0].lblPOVendorPhoneData.split('<br />');
            separatedArray = this.state.VenderDetail[0].sAddress.split('<br />');
            console.log("splice arr", separatedArray);
            //for (let value in VenderDetail) {
            //    let addr = VenderDetail[value].sAddress;

            return (<div>

                <div className="col-md-12 col-lg-3 float-left">
                    <div className="row">
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span> </span><Trans>ID</Trans><span>:</span></label>
                            <label className="info-value pl-0">{this.state.VenderDetail[0].sVendorID}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span> LOC :</span></label>
                            <label className="info-value pl-0">{this.state.VenderDetail[0].sVndrLoc}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2">Addr Seq<span> :</span></label>
                            <label className="info-value pl-0" >{this.state.VenderDetail[0].lblPOVendorAddrSeqData}</label>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-3 float-left">
                    <div className="row">

                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span>:</span></label>
                            <label className="info-value pl-0">{this.state.VenderDetail[0].lblPOVendorNameData}</label>


                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span> </span><Trans>Address</Trans><span>:</span></label>
                            <label className="info-value pl-0" >{separatedArray}</label>
                        </div>

                    </div>
                </div>

                <div className="col-md-12 col-lg-3 float-left">
                    <div className="row">

                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Contact</Trans><span>:</span></label>
                            {/*WAL-724_PC_01 changing contanct no to 855-446-9423 -Aparna**/}
                            {/*<label className="info-value pl-0">{Phone}</label>*/}
                            <label className="info-value pl-0">855-446-9423</label>


                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Name</Trans><span>:</span></label>
                            <label className="info-value pl-0" >{this.state.VenderDetail[0].lblPOVendorContactData}</label>
                        </div>

                    </div>
                </div>

            </div>
            );
            //}
        }
    }

    POData = () => {
        //return this.state.POData.map((value, index) => {
        if (this.state.POData.length > 0) {


            return (
                <div className="col-md-12 col-lg-4 float-left">
                    <div className="row">
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label">SDI PO:</label>
                            <label className="info-value pl-1">{this.state.POData[0].PO_ID}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label"><Trans>order_key</Trans><span> No</span><span>:</span></label>
                            <label className="info-value pl-1">{this.state.POData[0].ORDER_NO}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label"><Trans>workorder_key</Trans><span> </span><Trans>Number</Trans><span>:</span></label>
                            <label className="info-value pl-1" >{this.state.POData[0].ISA_WORK_ORDER_NO}</label>
                        </div>
                    </div>
                </div>
            );
        }
        //})
    }
    onselect = (value, index) => {
        let emlist = [];
        let string = "";

        emlist.push({
            EmpId: value
        });
        //;
    }

    shipmentAdd = () => {
        return this.state.shipmentAddr.map((value, index) => {
            return (<div className="row mb-3">
                <div className="col-md-3"><p className="cc-help-info"><Trans>From</Trans><span>:</span></p>
                    <label className="col-md-12 quick-label p-0">{value.lblShipFromDesc}</label>
                    <p className="col-md-12 quick-value p-0">{value.lblShipFromAdd}</p>
                </div>
                <div className="col-md-6"><p className="cc-help-info"><Trans>To</Trans><span>:</span></p>
                    <div className="row"><span className="col-md-2 float-left" /><label className="col-md-10 quick-label float-left">{value.lblShipToDesc}</label></div>
                    <div className="row"> <span className="col-md-2 float-left"><Trans>Address</Trans><span>:</span></span><p className="col-md-10 quick-value float-left">{value.lblShipToAdd}</p>
                    </div>
                </div>
                <div className="col-md-3"><p className="cc-help-info float-right"><Trans>Stop ID</Trans><span>:</span>{value.SHIPTO_ID}</p></div>
            </div>);
        })
    }

    bindShipmentBol = () => {
        let ship = this.state.shipmentBOL[0];
        //ship = this.state.shipmentBOL[0];
        //;
        let LOAD_ID = "";
        //if (this.state.shipmentBOL.length > 0) {
        //     LOAD_ID = this.state.shipmentBOL[0].LOAD_ID;

        //    //;
        //    console.log("ship", LOAD_ID);
        //}
        //if (this.state.shipmentAddr.length > 0) {
        //    LOAD_ID = this.state.shipmentBOL[0].LOAD_ID;

        //    //;
        //    console.log("ship", LOAD_ID);
        //}
        let proof = this.state.shipmentAddr[0].strURLForI0260;
        console.log("ship", this.state.shipmentAddr[0].strURLForI0260);
        console.log("ship", proof);
        //return this.state.shipmentBOL.map((value, index) => {
        return (
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <span className="float-left cc-help-info"><Trans>Load ID</Trans><span>:</span> </span>
                        <span className="float-right cc-help-info"><Trans>Trucking / Delivery From</Trans></span>
                    </div>
                    <div className="col-12 mb-4">

                        <div className="row mb-3">
                            <div className="col-md-3"><p className="cc-help-info"><Trans>From</Trans><span>:</span></p>
                                <label className="col-md-12 quick-label p-0">{this.state.shipmentAddr[0].lblShipFromDesc}</label>
                                <p className="col-md-12 quick-value p-0">{this.state.shipmentAddr[0].lblShipFromAdd}</p>
                            </div>
                            <div className="col-md-6"><p className="cc-help-info"><Trans>To</Trans><span>:</span></p>
                                <div className="row"><span className="col-md-2 float-left" /><label className="col-md-10 quick-label float-left">{this.state.shipmentAddr[0].lblShipToDesc}</label></div>
                                <div className="row"> <span className="col-md-2 float-left"><Trans>Address</Trans><span>:</span></span><p className="col-md-10 quick-value float-left">{this.state.shipmentAddr[0].lblShipToAdd}</p>
                                </div>
                            </div>
                            <div className="col-md-3"><p className="cc-help-info float-right"><Trans>Stop ID</Trans><span>:</span>{this.state.shipmentAddr[0].SHIPTO_ID}</p></div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-borderless shipment-tblborderless">
                                <thead>
                                    <tr>
                                        <th><Trans>Shipping</Trans><span> </span><Trans>Date</Trans><span>:</span></th>
                                        <th><Trans>Priority</Trans><span>:</span></th>
                                        <th>ROC</th>
                                        <th>Dist</th>
                                        <th>BLDG#:</th>
                                        <th><Trans>Trade</Trans><span>:</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{this.state.shipmentBOL[0].LOAD_DT}</td>
                                        <td />
                                        <td />
                                        <td />
                                        <td />
                                        <td />
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row my-4">
                            <div className="col-md-6">
                                <label><Trans>Notes</Trans></label>
                                <textarea className="form-control" readOnly defaultValue={""} />
                            </div>
                            <div className="col-md-6">
                                <label><Trans>Delivery</Trans></label>
                                <textarea className="form-control" readOnly defaultValue={""} value={this.state.shipmentBOL[0].NOTES_1000} />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table shipment-table">
                                <thead>
                                    <tr>
                                        <th>Order No &amp; WO No</th>
                                        <th><Trans>Ordered By</Trans></th>
                                        <th><Trans>Ship Container</Trans></th>
                                        <th><Trans>Type</Trans></th>
                                        <th><Trans>Comments</Trans></th>
                                        <th><Trans>Fragile Item Signature</Trans></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.shipmentGrid()}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-12 p-0 shipment-content">
                            <div className="col-md-3 col-12">
                                <p className="cc-help-info"><Trans>Summary</Trans><span>:</span></p>
                                <div className="row">
                                    <label className="col-md-5 col-5"><Trans>Truck</Trans><span> No:</span></label>
                                    <label className="col-md-7 col-7"></label>
                                </div>
                                <div className="row">
                                    <label className="col-md-5 col-5"><Trans>Driver</Trans><span>:</span></label>
                                    <label className="col-md-7 col-7">{this.state.shipmentBOL[0].DRIVER_ID}</label>
                                </div>
                                <div className="row">
                                    <label className="col-md-5 col-5">RCVD By:</label>
                                    <div className="col-md-7 col-7">
                                        <label className="d-block">{this.state.shipmentAddr[0].lblReceiver}</label>
                                        {this.state.shipmentAddr[0].lnkPOD ? <>
                                            <a href={`${proof}`} target="_blank" >[proof-of-delivery]</a> </> : null}
                                    </div>
                                </div>
                            </div>
                            <div className="float-left">
                                <label></label>
                            </div>
                            <div className="float-right">
                                <Trans>Date</Trans><span> </span><Trans>Delivered</Trans><span>:</span> {this.state.shipmentBOL[0].DELIVERED_DT}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 text-right mb-2">
                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal"><Trans>Close</Trans></button>
                    </div>
                </div>
            </div>);
        //})
    }
    proofD = (e) => {
        e.preventDefault();
        let proof = this.state.shipmentAddr[0].strURLForI0260;
        var handle = window.open('proof');
    }

    shipmentGrid = () => {
        return this.state.shipmentBOL.map((value, index) => {
            return (
                <tr>
                    <td><p>{value.ORDER_NO}</p>
                        <p>{value.WORK_ORDER_NUM}</p></td>
                    <td>{value.OPRID_ENTERED_BY}</td>
                    <td>{value.SHIP_CNTR_ID}</td>
                    <td>{value.CONTAINER_TYPE}</td>
                    <td ></td>
                    <td></td>
                </tr>);

        })
    }

    convertdate = (date) => {
        var dateConverted;
        if (date != null && date != "" && date != " ") {
            var dateString = date;
            var dataSplit = dateString.split('/');
            console.log("Dateformated", dataSplit);
            //;
            if (dataSplit[2].split(" ").length > 1) {

                var hora = dataSplit[2].split(" ")[1].split(':');
                dataSplit[2] = dataSplit[2].split(" ")[0];
                dateConverted = new Date(dataSplit[2], dataSplit[0] - 1, dataSplit[1], hora[0], hora[1]);

            } else {
                dateConverted = new Date(dataSplit[2], dataSplit[0] - 1, dataSplit[1]);
            }
        }
        console.log("Dateformated01", dateConverted);
        return (dateConverted)
    }
    FromOrderDate = e => {
        //;
        let dateOL = this.handledate(e);
        if (e != "") {
            this.setState({ OFromDate: dateOL, OrderDateBoolean: true });
        }
        console.log("formateDate", dateOL);
        console.log("Date", this.state.isFilter);
        console.log("Date", e);
    }
    ToOrderDate = e => {
        //;
        //  let formateddate = this.convertdate(e);
        let dateOL = this.handledate(e);
        if (e !== null) {
            this.setState({ OToDate: dateOL, OrderDateBoolean: true });
        }
        //this.setState({ OToDate: dateOL, OrderDateBoolean: true });
        console.log("formatetODate", dateOL);

    }
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    FromNeedDate = e => {
        let dateOL = this.handledate(e);
        if (dateOL !== null) {
            this.setState({ NFromDate: dateOL, NeedByDateBoolean: true });
        }
        console.log("formatefromDate", dateOL);

    }
    ToNeedDate = e => {
        let dateOL = this.handledate(e);
        if (dateOL !== null) {
            this.setState({ NToDate: dateOL, NeedByDateBoolean: true });
        }
        console.log("formatetODate", dateOL);
    }
    AdvancedFilter = () => {
        $('advanced-filter').modal('show');


        //$(".dropdown-menu").click(function (event) {
        //    event.stopPropagation();
        //});




        //this.setState({ isFilter: true });
        //;
    }
    ApplyButtonClick = () => {

        if (this.state.OrderDateBoolean || this.state.NeedByDateBoolean) {
            FilterPopupBoolean = true;
        }
        else {
            FilterPopupBoolean = false;
        }
        let searchCol = this.state.searchColumn
        if (searchTxt != "") {
            searchCol = this.state.searchColumn;
            if (searchCol == "LINE_PRIOR") {
                if (this.state.priorityFlag == 1) {
                    searchTxt = `R`;
                }
                else if (this.state.priorityFlag == 2) {
                    searchTxt = ` `;
                }
                else {
                    searchCol = "";
                    searchTxt = ` `;
                }

            }
            else {
                searchTxt = $(`#searchTxt`).val();
            }
        }
        console.log("buttonclick", FilterPopupBoolean);

        let pageNo = 1;
        this.setState({ PageNo: pageNo });//****NEW***ADDED(2/10/2021)***
        this.ApplyFilter(pageNo,
            this.state.RecCount,
            "",
            "", searchTrBy, searchTrCriteria,
            this.state.sortColumn,
            this.state.sortType, FilterPopupBoolean, this.state.toggleChecked
        );
        //this.clearButtonClick();
        this.filtertoggle();
    }
    clearButtonClick = () => {
        this.setState({ NeedByDateBoolean: false, OrderDateBoolean: false, OFromDate: "", OToDate: "", NFromDate: "", NToDate: "", PageNo: 1 });
        FilterPopupBoolean = false;
        let sortColumn = "ORD_DATE_FILTER";//"ORDER_NO";
        let sortType = "DESC";//"ASC";
        let pageNo = 1;
        //;

        //$("#searchTxt").val('');
        if (this.state.ReportDateField == "99") {
            //this.dateCheck();
        }

        //searchTxt = $(`#searchTxt`).val().trim();
        let searchCol = "";
        if (searchTxt != "") {
            searchCol = this.state.searchColumn;
            if (searchCol == "LINE_PRIOR") {
                if (this.state.priorityFlag == 1) {
                    searchTxt = `R`;
                }
                else if (this.state.priorityFlag == 2) {
                    searchTxt = ` `;
                }
                else {
                    searchCol = "";
                    searchTxt = ` `;
                }

            }
            else {
                searchTxt = $(`#searchTxt`).val();
            }
        }

        //this.setState({ searchColumn: "" });
        this.ApplyFilter(pageNo,
            this.state.RecCount,
            searchCol,
            searchTxt, searchTrBy, searchTrCriteria,
            sortColumn,
            sortType, FilterPopupBoolean, this.state.toggleChecked
        );
        //this.setState({ sortColumn: sortColumn, sortType: sortType, searchAval: false, PageNo: pageNo });
        this.filtertoggle();
    }



    handleRadioButton = (value) => {
        //e.preventDefault();
        let sFD = new Date();
        let sTD = new Date();
        let val = [];
        //;
        if (value == "dateRange") {
            //document.getElementById("dateRag1").checked = true;
            //document.getElementById("6month").checked = false;
            //document.getElementById("exval").checked = false;
            //$("#6month").attr('disabled', true);
            //$("#exval").attr('disabled', true);

            //document.getElementById("6month").disabled = true;
            //document.getElementById("dateRag").Checked = true;
            radio = "dateRange"
            radiochange = true;
            this.setState({ EV: false, MN: false, DR: true });
            //radio = "ExactValue"
            //val = this.abovemonth()
            //sFD = val[0];
            //sTD = val[1];
            //sFD = Date.parse(val[0]);
            //sFD = new Date(sFD);
            //sTD = Date.parse(val[1]);
            //sTD = new Date(sTD);
            //this.setState({ SearchTrFromDate: sFD, SearchTrToDate: sTD });
            //this.abovemonth()

            //sFD = val[0] ? this.handledate(val[0]) : "";
            //sTD = val[1] ? this.handledate(val[1]) : "";
            //this.setState({ SearchTrFromDate: sFD, SearchTrToDate: sTD });

        }
        else if (value == "6month") {
            //document.getElementById("6month1").checked = true;
            //document.getElementById("6month").checked = false;
            //document.getElementById("exval").checked = false;
            //$("#6month").attr('disabled', true);
            //$("#exval").attr('disabled', true);
            //$('.6m').addClass('.disable-radio-label');
            //document.getElementById("6month").disabled = true;
            //document.getElementById("dateRag").defaultChecked = true;
            radio = "6month"
            radiochange = true;
            this.setState({ EV: false, MN: true, DR: false });
            //val = this.abovemonth()
            //sFD = val[0];
            //sTD = val[1];
            //sFD = Date.parse(val[0]);
            //sFD = new Date(sFD);
            //sTD = Date.parse(val[1]);
            //sTD = new Date(sTD);
            this.setState({ SearchTrFromDate: "", SearchTrToDate: "" });


        }
        else {
            // document.getElementById("exval1").checked = true;
            radiochange = true;
            this.setState({ EV: true, MN: false, DR: false });
            this.setState({ SearchTrFromDate: "", SearchTrToDate: "" });
        }
        console.log("SEARCHoPTION", value);
        this.setState({ SearchOption: value });

    }
    SearchTrToDatebind = (e) => {
        let dateOL = this.handledate(e);
        if (dateOL !== null) {
            this.setState({ SearchTrToDate: dateOL });
        }
        console.log("formatefromDate", dateOL);
    }
    SearchTrFromDatebind = (e) => {
        let dateOL = this.handledate(e);
        if (dateOL !== null) {
            this.setState({ SearchTrFromDate: dateOL });
        }
        console.log("formatefromDate", dateOL);
    }


    STrDropDown = (event, displayName, columnName) => {
        event.preventDefault();
        searchTrBy = columnName;
        radiochange = false;
        //;
        let sFD = new Date();
        let sTD = new Date();
        let val = [];
        this.setState({ STrDisplayName: displayName });
        console.log("searchColumn", columnName);
        //;
        if (displayName == "Order Status") {
            //document.getElementById("dateRag").checked = true;


            //$('#6month').addClass('hide');
            //$('#exval').addClass('hide');
            radiochange = true;
            $("#SearchTrTxt").val('');
            $("#SearchTrTxt").hide();
            $("#status-dropdown").show();
            searchTrCriteria = "";
            $("#status-dropdown").val('select');
            $('#6m').addClass('disable-radio-label');
            $('#dr').addClass('disable-radio-label');
            $('#ex').addClass('disable-radio-label');
            $("#6month").attr('disabled', true);
            $("#exval").attr('disabled', true);

            //document.getElementById("6month").disabled = true;
            //document.getElementById("exval").disabled = true;
            //$("#6month").attr('disabled', true);
            //$("#exval").attr('disabled', true);
            //document.getElementById("dateRag").defaultChecked = true;
            radio = "dateRange"
            val = this.abovemonth()
            sFD = val[0];
            sTD = val[1];
            sFD = Date.parse(val[0]);
            sFD = new Date(sFD);
            sTD = Date.parse(val[1]);
            sTD = new Date(sTD);
            this.setState({ SearchTrFromDate: sFD, SearchTrToDate: sTD, EV: false, MN: false, DR: true });
            //let val = this.abovemonth();
            //this.setState({ SearchTrFromDate: val[0], SearchTrToDate: val[1] });
            //;
        }
        else if (displayName == "Priority Orders") {
            searchTrCriteria = "Priority";
            radiochange = true;
            $("#SearchTrTxt").val('Priority');
            $("#status-dropdown").hide();
            $("#SearchTrTxt").show();
            $('#ex').removeClass('disable-radio-label');
            $('#6m').addClass('disable-radio-label');
            $('#dr').addClass('disable-radio-label');

            //document.getElementById("SearchTrTxt").value = "Priority";

            //document.getElementById("exval").checked = true;

            //document.getElementById("6month").disabled = true;
            //document.getElementById("dateRag").disabled = true;
            $("#6month").attr('disabled', true);
            $("#dateRag").attr('disabled', true);
            //document.getElementById("dateRag").checked = true;

            //this.setState({ SearchOption: "ExactValue" });
            radio = "ExactValue"
            val = this.abovemonth()
            sFD = val[0];
            sTD = val[1];
            sFD = Date.parse(val[0]);
            sFD = new Date(sFD);
            sTD = Date.parse(val[1]);
            sTD = new Date(sTD);
            this.setState({ SearchTrFromDate: sFD, SearchTrToDate: sTD, EV: true, MN: false, DR: false });
            console.log("from", sFD);
            console.log("to", sTD);
            //let val = this.abovemonth();
            //this.setState({ SearchTrFromDate: val[0], SearchTrToDate: val[1] });
        }
        else {
            $('#SearchTrTxt').val('');
            $("#status-dropdown").hide();
            $("#SearchTrTxt").show();
            searchTrCriteria = "";
            radio = "ExactValue"

            //document.getElementById("exval").defaultChecked = true;
            //document.getElementById("6month").disabled = false;
            //document.getElementById("dateRag").disabled = false;
            $('#ex').removeClass('disable-radio-label');
            $('#6m').removeClass('disable-radio-label');
            $('#dr').removeClass('disable-radio-label');

            // document.getElementById("exval").checked = true;

            //document.getElementById("exval").disabled = false;
            $("#6month").attr('disabled', false);
            $("#dateRag").attr('disabled', false);
            $("#exval").attr('disabled', false);
            this.setState({ SearchTrFromDate: "", SearchTrToDate: "", EV: true, MN: false, DR: false });

        }
    }
    handleOrderStatus = (event) => {
        searchTrCriteria = event.target.value;
        console.log("handleChange", searchTrCriteria);
    }

    handleOrderCategory = (event) => {
        this.setState({ OrderCategory: event.target.value })
    }
    handlemainOrderStatus = (event) => {
        this.setState({ MainOrderStatus: event.target.value })
    }
    //WW-366_PC_03

    /*[07/25/22, PC_WW-455-03]Priyanka D*/
    handleOrderstatusSearch = (event) => {
        debugger
        if (event != undefined) {
            if (event.target.value != "") {
                this.setState({ OrderStatusSearch: event.target.value })
                //$(`#RegId`).prop('disabled', true);
                //$(`#SubRegId`).prop('disabled', true);
                //$(`#ordertype`).prop('disabled', true);
                //$(`#Date`).prop('disabled', true);
                //$(`#Division`).prop('disabled', true);
                //$(`#ClearID`).prop('disabled', true);
            } else {
                this.setState({ OrderStatusSearch: event.target.value })
                //$(`#RegId`).prop('disabled', false);
                //$(`#SubRegId`).prop('disabled', false);
                //$(`#ordertype`).prop('disabled', false);
                //$(`#Date`).prop('disabled', false);
                //$(`#Division`).prop('disabled', false);
                //$(`#ClearID`).prop('disabled', false);
            }
        } else {
            $(`#RegId`).prop('disabled', false);
            $(`#SubRegId`).prop('disabled', false);
            $(`#ordertype`).prop('disabled', false);
            $(`#Date`).prop('disabled', false);
            $(`#Division`).prop('disabled', false);
            $(`#ClearID`).prop('disabled', false);
            $(`#OrdCatId`).prop('disabled', false);
            $(`#mainorderstatusid`).prop('disabled', false);
        }
    }

    handleTrSearch = () => {
        let pageNo = 1;
        let sortColumn = "ORD_DATE_FILTER";
        let sortType = "DESC";
        searchTrCriteria = $(`#SearchTrTxt`).val().trim();
        this.ApplyFilter(pageNo,
            this.state.RecCount,
            this.state.searchColumn,
            searchTxt, searchTrBy, searchTrCriteria,
            sortColumn,
            sortType, FilterPopupBoolean, this.state.toggleChecked
        );
        //;
        console.log("search", searchTrCriteria);
        this.setState({ PageNo: pageNo, isSearch: true, searchAval: true });
        console.log("search", this.state.searchAval);
    }

    handleEmplist = (values) => {
        //;
        let selectedEmp = [];

        values.forEach((val) => {
            selectedEmp.push(val);
        })

        //;
        this.setState({ EmpListPush: selectedEmp });
        console.log("seleEmp", this.state.EmpListPush);
        //console.log("MultisiteValue", values)
    }

    filtertoggle = (e) => {
        if (e)
            e.preventDefault();
        this.setState({ isFilterOpen: this.state.isFilterOpen == true ? false : true });
    };

    expandAll = () => {
        if (this.state.isExpand == false) {
            this.setState({ isExpand: true });
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
        } else {
            this.setState({ isExpand: false });
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');

        }
    }

    POExpandAll = () => {
        if (this.state.isPOExpand == false) {
            this.setState({ isPOExpand: true });
            $('.tryH').removeClass('accordion-arrow-change');
            $('.try').addClass('d-none');
            $('.tryH').addClass('accordion-arrow-change');
            $('.try').removeClass('d-none');
        }
    }
    POCollapseAll = () => {
        this.setState({ isPOExpand: false });
        $('.tryH').addClass('accordion-arrow-change');
        $('.try').removeClass('d-none');
        $('.tryH').removeClass('accordion-arrow-change');
        $('.try').addClass('d-none');
    }
    AnykeyPress(e) {
        if (e.keyCode == 13) {
            this.handleSearch(false, "");
        }
    };
    // Order Status Stored Procedure Integration Change - Deepthi
    AnykeyHeaderPress(e) {
        debugger
        if (e.keyCode == 13) {
            this.handleHeaderSearch(false, "");
        }
    };
    //WW-366_PC_04
    SearchApplyfilter = () => {
        // let searchTxt = $(`#searchTxt`).val();
        //If the user selected search transaction but didnot select from and todate, Thrwo alert message WW_366-Priyanka D
        if (this.state.ReportDateField == "99" && (this.state.SearchTrFromDate == "" || this.state.SearchTrToDate == "")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select From and To date"
            });
            //alert("Please select From and To date");
        } else {
            this.handleSearch(false, "");
        }


    }
    BindASNdata = () => {
        console.log("ASNLineDeepthi", this.state.ASNlineData)
        if (this.state.ASNlineData.length > 0) {
            return this.state.ASNlineData.map((value, ID) => {
                //pc-1164-01 an condition statement for appearing grey page while clicking on tracking number S.Sanjay
                if (value.TRACKING_NUMBER != null) {
                    return (
                        <tr>
                            {/*pc-1164-02 an condition statement for appearing grey page while clicking on tracking number S.Sanjay*/}
                            <td data-label="Form Name" className="font-12">{value.TRACKING_URL != null ? (value.TRACKING_URL.length < 7 || value.TRACKING_NUMBER.length == 1) ? (value.TRACKING_NUMBER) : (<a href={value.TRACKING_URL} target="_blank">{value.TRACKING_NUMBER}</a>) : (value.TRACKING_NUMBER)}</td>
                            <td data-label="Status" className="font-12">{value.SHIP_STATUS != null && value.SHIP_STATUS != "" ? value.SHIP_STATUS : "-"}</td>
                            <td data-label="Date" className="font-12">{value.SHIP_DATE != null && value.SHIP_DATE != "" ? value.SHIP_DATE : "-"}</td>
                            <td className="text-right font-12" data-label="Quantity">{value.SHIP_QTY != null && value.SHIP_QTY != "" ? value.SHIP_QTY : "-"}</td>
                        </tr>
                    )
                }

            });
        }
    }
    historyGridBind = () => {
        if (this.state.ApprovalhistoryArr) {
            return this.state.ApprovalhistoryArr.map((value, ID) => {
                return (
                    <tr>
                        <td>{value.Approved_By_USERID}</td>
                        <td>{value.Approved_By}</td>
                        <td>{value.Approval_Status}</td>
                        <td>{value.Approval_Type}</td>
                        <td>{value.Date_DT}</td>
                    </tr>
                )

            });
        }
    }
    shippopup = () => {
        if (this.state.usernamedetail) {
            return (
                <div className="col-12 edit-desc-field mb-4">
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label">First Name</label>
                        <label className="col-md-7 quick-value">{this.state.usernamedetail.sFirstName}</label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label">Last Name</label>
                        <label className="col-md-7 quick-value">{this.state.usernamedetail.sLastName}</label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label">Loaded Container</label>
                        <label className="col-md-7 quick-value">{this.state.usernamedetail.LoadedContainer}</label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label">Total Count</label>
                        <label className="col-md-7 quick-value">{this.state.usernamedetail.TotalCnt}</label>
                    </div>


                </div>
            )
        }
    }
    empdivclear = () => {


        let values = this.state.EmpListPush;
        values.forEach((val) => {
            values.splice(val);
        });

        this.setState({
            EmpListPush: values, Division: " ", Region: " ", SubRegion: " ", ReportDateField: "X", OrderTypeField: "All", SearchTrFromDate: "", SearchTrToDate: "", MainOrderStatus: " ", OrderCategory: " "
        });

    }

    handleDatePicker = (date, name) => {
        //date.preventDefault();
        //;
        if ((name == "OFromDate" || name == "OToDate") && (date != "")) {
            this.setState({ OrderDateBoolean: true });
        }
        else if ((name == "NFromDate" || name == "NToDate") && (date != "")) {

            this.setState({ NeedByDateBoolean: true });
        }
        let dateOL = this.handledate(date);
        this.setState({
            [name]: date
        });

        console.log("Date", date);
        console.log("Date", dateOL);
    };
    //WW-380_PC_ -Aparna
    SortingFront = (sort, name) => {
        debugger
        let data = []
        if (sort == "DESC") {
            switch (name) {
                case "ORDER_NO": {
                    data = this.state.HeaderGridArray.sort((a, b) => (a.ORDER_NO > b.ORDER_NO) ? 1 : -1);
                    break;
                }
                case "ISA_WORK_ORDER_NO": {
                    data = this.state.HeaderGridArray.sort((a, b) => (a.ISA_WORK_ORDER_NO > b.ISA_WORK_ORDER_NO) ? 1 : -1)
                    break;
                }
                case "BILL_TO_STORE": {
                    data = this.state.HeaderGridArray.sort((a, b) => (a.INSTALL_STORE > b.INSTALL_STORE) ? 1 : -1)
                    break;
                }
                case "ENTEREDEMPNAME": {
                    data = this.state.HeaderGridArray.sort((a, b) => (a.OPRID_ENTERED_BY > b.OPRID_ENTERED_BY) ? 1 : -1)
                    break;
                }

            }
        }
        else {
            switch (name) {
                case "ORDER_NO": {
                    data = this.state.HeaderGridArray.sort((a, b) => (b.ORDER_NO > a.ORDER_NO) ? 1 : -1);
                    break;
                }
                case "ISA_WORK_ORDER_NO": {
                    data = this.state.HeaderGridArray.sort((a, b) => (b.ISA_WORK_ORDER_NO > a.ISA_WORK_ORDER_NO) ? 1 : -1)
                    break;
                }
                case "BILL_TO_STORE": {
                    data = this.state.HeaderGridArray.sort((a, b) => (b.INSTALL_STORE > a.INSTALL_STORE) ? 1 : -1)
                    break;
                }
                case "ENTEREDEMPNAME": {
                    data = this.state.HeaderGridArray.sort((a, b) => (b.OPRID_ENTERED_BY > a.OPRID_ENTERED_BY) ? 1 : -1)
                    break;
                }

            }

        }
        this.setState({ GridArr: data })
    }

    //WW-1046 Start a return -Vishwa S
    bindReturnReasonDD = () => {
        if (this.state.RMAReasonDDOpt.length > 0) {
            return this.state.RMAReasonDDOpt.map((value, ID) => {
                return (
                    <option key={ID + 1} value={value.REASONS}>{value.REASONS}</option>
                )

            });
        }
    }

    //WW-1046 Start a return -Vishwa S
    handleRMAReasonChange = (e) => {
        let DDValue = e.target.value;
        this.setState({ RMAReasonDD: DDValue });
        if (DDValue == "Others") {
            if (this.state.RMAReasonComment != "") {
                this.setState({ returnSubmitBtn: true });
            }
            else {
                this.setState({ returnSubmitBtn: false });
            }
        }
        else {
            this.setState({ returnSubmitBtn: true })
        }
    }

    //WW-1046 Start a return -Vishwa S
    handleRMACommentChange = (e) => {
        let CmtValue = e.target.value;
        this.setState({ RMAReasonComment: CmtValue });

        if (this.state.RMAReasonDD != "Select") {
            if (this.state.RMAReasonDD == "Others") {
                if (CmtValue != "") {
                    this.setState({ returnSubmitBtn: true });
                }
                else {
                    this.setState({ returnSubmitBtn: false });
                }
            }
        }
    }

    //WW-1046 Start a return -Vishwa S
    RMAReasonClearBtn = () => {
        this.setState({ RMAReasonDD: "Select", RMAReasonComment: "", returnSubmitBtn: false });
    }

    //WW-1046 Start a return -Vishwa S
    startAReturnClick = (val, type) => {
        let locReturBO = {
            OrderNumber: val.ORDER_NO,
            LineNo: type == "ORDER" ? "" : val.LINE_NBR,
            PONumber: type == "ORDER" ? val.PO_ID : val.PO_ID1,
            IsOrderLevel: type == "ORDER" ? true : false,
        }
        this.setState({ startAReturnBODetail: locReturBO });
        $('#RMAReasonPopUp').modal('show');
    }

    //WW-1046 Start a return -Vishwa S
    returnSubmitBtnClick = () => {
        let locReturnSubmitBO = {
            ORDER_NUMBER: this.state.startAReturnBODetail.OrderNumber,
            LINE_NO: this.state.startAReturnBODetail.LineNo,
            IsOrderLevel: this.state.startAReturnBODetail.IsOrderLevel,
            PO_ID: this.state.startAReturnBODetail.PONumber,
            Reason: this.state.RMAReasonDD,
            Comments: this.state.RMAReasonComment
        }
        OrderStatusAction.SendMailForStartAReturn(locReturnSubmitBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ RMAReasonDD: "Select", RMAReasonComment: "", returnSubmitBtn: false });
        $('#RMAReasonPopUp').modal('hide');
    }

    //WW-1046 Start a return -Vishwa S
    startAReturnResponse = () => {
        let returnResponse = OrderStatusStore.StartAReturn;
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (returnResponse.toUpperCase() == "SUCCESS") {
            $('#StartAReturnSuccessPopUp').modal('show');
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue. Please contact SDI Customer care"
            })
        }
    }

    getNotes = (e, orderNo, lineNo, ItemID) => {
        e.preventDefault()
        let getNotesBO = {
            OrderNO: orderNo,
            Line_No: lineNo,
            BU: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.GetNotesAction(getNotesBO)
        this.setState({ notesHeader: lineNo == 0 ? "Order Notes - " + orderNo : "Item Notes - " + ItemID })
    }

    getNotesResponse = () => {

        const notesResponse = JSON.parse(OrderStatusStore.notesList);

        if (notesResponse.ErrorTable && notesResponse.ErrorTable[0].error) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue try again"
            })
        } else {
            const orderNotes = notesResponse.orderNotes && notesResponse.orderNotes.length > 0 ? notesResponse.orderNotes : [];
            const reqApprvNotes = notesResponse.requestorNotes && notesResponse.requestorNotes.length > 0 ? notesResponse.requestorNotes : [];
            const budApprvNotes = notesResponse.budgetaryNotes && notesResponse.budgetaryNotes.length > 0 ? notesResponse.budgetaryNotes : [];
            const ordCncNotes = notesResponse.cancelNotes && notesResponse.cancelNotes.length > 0 ? notesResponse.cancelNotes : [];
            this.setState({ orderNotes: orderNotes, requestorNotes: reqApprvNotes, budgetaryNotes: budApprvNotes, cancelNotes: ordCncNotes });
            $('#NotesPopup').modal('show');
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    bindNotes = (notes) => {
        return notes.map((val, index) => {
            return (
                <>
                    {val.NOTES_LABEL && (index == 0 || (notes[index - 1].NOTES_LABEL != val.NOTES_LABEL)) ?
                        <div className="col-md-12 mb-1">
                            <h5 className="font-14 font-bold">{val.NOTES_LABEL}</h5>
                        </div> : null}
                    <div className="col-md-4 mb-2">
                        <span className="mr-1">
                            <img src="images/date-time-icon.svg" alt="date/time" />
                        </span>
                        <span className="font-12 font-regular color-light-black">
                            {new Date(val.DATEANDTIME).toLocaleString()}
                        </span>
                    </div>
                    <div className="col-md-8 mb-2">
                        <span className="mr-1">
                            <img src="images/user-id-icon.svg" alt="user-id" />
                        </span>
                        <span className="font-12 font-regular color-light-black">{val.USERID}</span>
                    </div>
                    <div className="col-md-12">
                        <label className="w-100 font-14 font-medium mb-1">Notes:</label>
                        <span className="font-14 font-regular color-light-black">
                            {val.ORDERNOTES}
                        </span>
                    </div>
                    {(notes.length > 1) && (index != notes.length - 1) ? <span class="border-bottom w-100 my-3 mx-3"></span> : null}
                </>
            )
        })
    }

    render() {
        const { t } = this.props;
        let region = this.state.Region;
        //WW-366_PC_03
        let searchtxt = $(`#searchTxt`).val()
        let statuscondtion = this.state.OrderStatusSearch != "" || (searchtxt != "" && searchtxt != undefined) ? true : false;
        console.log("statuscondtion", statuscondtion);
        let lastNotes = ""
        if (this.state.budgetaryNotes && this.state.budgetaryNotes.length > 0) {
            lastNotes= 'budgetaryNotes';
        }
        else if (this.state.requestorNotes && this.state.requestorNotes.length > 0) {
            lastNotes= 'requestorNotes';
        }
        else if(this.state.orderNotes && this.state.orderNotes.length > 0) {
            lastNotes= 'orderNotes';
        }
        //debugger
        return (

            <div>


                <div className="container-fluid content-section custom-mb">
                    <div className="row">

                        {/* Check Order Status starts */}
                        <div className="container-fluid content-margin" style={{ "paddingRight": "5px", "paddingLeft": "5px" }}>
                            <div className="row">
                                <div className="col-md-12 page-heading mb-3 Ord-title">
                                    <h5 className="page-title"><Trans>Check</Trans><span> </span><Trans>order_status</Trans></h5>
                                    {/*5627 - added a margin top for my approver [4/17/2025] Nachiappan */}
                                    {this.state.ApproverPopupFlag ? <button className="btn btn-primary custom-btn-primary primary-btn mr-2 ml-3 float-right" data-toggle="modal" data-target=".my-approver-details" style={{ marginTop: '10px' }} >My Approver</button> : null}

                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                        <label htmlFor="checkbox-OrdStatus">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="row align-items-center mb-3">
                                        <div className="col-md-2 mb-3">
                                            <label className="catalog-label"><Trans>Order Date</Trans></label>
                                            <select className="form-control" name="ReportDateField" id="Date" value={this.state.ReportDateField} onChange={this.handleChange}>

                                                <option value="X">{t("Select ReportKey")}</option>
                                                <option value="7">{t("Last 7 Days")}</option>
                                                <option value="15">{t("Last 15 Days")}</option>
                                                <option value="30">{t("Last 30 Days")}</option>
                                                <option value="0">{t("This Month")}</option>
                                                <option value="-1">{t("Last Month")}</option>
                                                <option value="99">Custom Dates</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label className="catalog-label"><Trans>Order</Trans><span> </span><Trans>Type</Trans></label>
                                            <select className="form-control" name="OrderTypeField" id="ordertype" value={this.state.OrderTypeField} onChange={this.handleChange}>
                                                <option value="All">{t("All")} {t("Orders")}</option>
                                                <option value="My">{t("my")} {t("Orders")}</option>
                                                <option value="Open">{t("Open")} {t("Orders")}</option>
                                                <option value="Group">{t("Group")} {t("Orders")}</option>
                                            </select>
                                        </div>


                                        {this.state.BusUnitDropDown.length > 1 ? <>
                                            <div className="col-md-2 mb-3">
                                                <label className="catalog-label"><Trans>Report</Trans><span> </span><Trans>type</Trans></label> <select className="form-control" name="ReportTypeField" value={this.state.ReportTypeField} onChange={this.handleChange}>
                                                    <option value="Site"><Trans>Site</Trans><span> </span><Trans> Report</Trans></option>
                                                    <option value="Company">Company-Consolidated Report</option>
                                                </select>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <label className="catalog-label"><Trans>Site</Trans><span> </span> <Trans>Business</Trans> <span> </span><Trans>Unit</Trans></label>
                                                <select className="form-control" name="BusUnitField" value={this.state.BusUnitField} onChange={this.handleChange}>
                                                    {/*<option value="Site">Select Business Unit</option>*/}
                                                    {this.BusUnitDropdownmap()}
                                                </select>
                                            </div></> : null}


                                        {this.state.OrderTypeField == "Group" ?
                                            <div className="col-md-2 mb-3">
                                                <label className="catalog-label"><Trans>Employee</Trans><span> </span><Trans>Id</Trans></label>
                                                {/*<DropdownMultiselectModule
                                                    options={this.state.EmpIdDropDown}
                                                    displayName="ISA_EMPLOYEE_NAME"
                                                    id="EMP_ID"
                                                    value={this.state.EmpListPush}
                                                    onChange={this.handleEmplist}
                                                    labelledBy={"Select"}
                                                    className="w-100 DropDown-Font-Size float-left custom-height eid"
                                                />*/}
                                                {/* <MultiSelect
                                                    options={this.state.EmpIdDropDown}
                                                    displayName="ISA_EMPLOYEE_NAME"
                                                    id="EMP_ID"
                                                    value ={this.state.EmpListPush}
                                                    onChange={this.handleEmplist}
                                                    labelledBy={"Select"}
                                                    className="w-100 DropDown-Font-Size float-left custom-height eid"
                                                />*/}
                                                <ReactMultiSelectCheckboxes
                                                    options={this.state.EmpIdDropDown}
                                                    className="multi multiDDWidth"
                                                    id="EMP_ID"
                                                    value={this.state.EmpListPush}
                                                    onChange={this.handleEmplist}
                                                    labelledBy={"Select"}

                                                />


                                            </div>

                                            : null}
                                        {/*Added the clear button for Employee ID Dropdown*/}
                                        {/*{this.state.OrderTypeField == "Group" ?
                                            <div className="col-md-2 mb-3  mrg-btm">
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" style={{ width: '90px' }} onClick={this.empdivclear}><Trans>Clear</Trans></button>
                                            </div> : null}*/}
                                        {/*[12/3/21], PC_OS_02, WW-279, Dhevanesam R - Check the state value Manager as DIRECTOR or SR_DIRECTOR to display division, region and sub region dropdowns*/}
                                        {this.state.OrderTypeField == "All" ?

                                            "MANAGER".startsWith(this.state.Manager) || "REGMANAGER".startsWith(this.state.Manager) || "DIRECTOR".startsWith(this.state.Manager) || "SR_DIRECTOR".startsWith(this.state.Manager) ? <>
                                                {/**  {this.state.DivisionDD.length > 0 ? <>*/}
                                                <div className="col-md-2 mb-3">
                                                    <label className="catalog-label"><Trans>Division</Trans></label>
                                                    {/*[07/25/22, PC_WW-455-02]Priyanka D*/}
                                                    <select className="form-control" name="Division" id="Division" disabled={!this.state.isSearch} value={this.state.Division} onChange={this.handleChange}>
                                                        <option value=" ">All</option>
                                                        {this.DivisionDDmap()}
                                                    </select>
                                                </div>
                                                {/** </> : null}*/}
                                                {/** {this.state.RegionDD.length > 0 ? <>*/}
                                                <div className="col-md-2 mb-3">
                                                    <label className="catalog-label"><Trans>Region</Trans></label>
                                                    {/*[07/25/22, PC_WW-455-02]Priyanka D*/}
                                                    <select className="form-control" name="Region" id="RegId" disabled={!this.state.isSearch} value={this.state.Region} onChange={this.handleChange}>
                                                        <option value=" ">All</option>
                                                        {this.RegionDDmap()}
                                                    </select>
                                                </div>
                                                {/**</> : null}
                                                {/**{this.state.SubRegionDD.length > 0 ? <>*/}
                                                <div className="col-md-2 mb-3">
                                                    <label className="catalog-label"><Trans>Sub Region</Trans></label>
                                                    {/*[07/25/22, PC_WW-455-02]Priyanka D*/}
                                                    <select className="form-control" name="SubRegion" id="SubRegId" disabled={!this.state.isSearch} value={this.state.SubRegion} onChange={this.handleChange}>
                                                        <option value=" ">All</option>
                                                        {this.SubRegionDDmap()}
                                                    </select>
                                                </div>

                                                {/**</> : null}*/}


                                            </> : null :
                                            null
                                        }
                                        <div className="col-md-2 mb-3">
                                            <label className="catalog-label"><Trans>Order Status</Trans></label>
                                            <select className="form-control search-color" name="OrderStatusSearch" id="mainorderstatusid" value={this.state.MainOrderStatus} onChange={this.handlemainOrderStatus}>
                                                <option value=" " >--Select Status--</option>
                                                {this.OrderStatusDropdown()}
                                            </select>
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label className="catalog-label"><Trans>Order Category</Trans></label>
                                            <select className="form-control search-color" name="OrderStatusSearch" id="OrdCatId" value={this.state.OrderCategory} onChange={this.handleOrderCategory}>
                                                <option value=" ">--Select Category--</option>
                                                <option value="PICKUP">Pick-Up</option>
                                                <option value="CALLIN">Supplier Call-in</option>
                                                <option value="SHIP">Shipment</option>
                                                {/*WW-546 Add HAL as an order category on 'check order status' page - Deepthi*/}
                                                {/*PC-1256-01 removing HAL 11/14/2024 -S.Sanjay*/}
                                                {/* <option value="HAL">Hold At Location</option>*/}
                                            </select>
                                        </div>
                                        <div className="col-md-12 mt-2 text-right">

                                            <button className="btn btn-primary custom-btn-primary primary-btn" id="applyfilterid" style={{ "marginRight": "5px" }} onClick={() => this.GetHeaderDetailes(true, "", this.state.toggleChecked, "No")}><Trans>Apply</Trans><span> </span> <Trans>Filter</Trans></button>
                                            {this.state.isSearch ? <button className="btn btn-secondary custom-btn-secondary secondary-btn" id="ClearID" style={{ width: '90px' }} onClick={this.divclear}><Trans>Clear</Trans></button> : null}
                                        </div>
                                    </div>

                                    {/*Disabled the Division,Region and Sub Region DropDown for other orders except ALL Orders*/}

                                    {/***search text box for all search**7/14/2021*****/}
                                    {/****END**/}
                                    <div className="row border-bottom border-top mb-3" >
                                        {/*[07/25/22, PC_WW-455-01]Priyanka D*/}
                                        {this.state.ReportDateField == "99" ?
                                            <>
                                                <div className="col-md-3 pr-0 middle-field mb-3" id="sFT" style={{ marginTop: "1%" }}>
                                                    <div className="col-md-6 float-left mb-4 p-0 ssd">
                                                        <label className="catalog-label"><Trans>From</Trans></label>
                                                        {/*<DatePicker className="form-control "
                                                        id="OrderByFromDate"
                                                        fixedHeight
                                                      
                                                        placeholderText="MM/DD/YYYY"
                                                        dateFormat="MM/dd/yyyy"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        //dropdownMode="select"
                                                        //minDate={new Date()}
                                                        value={this.state.SearchTrFromDate}
                                                        onChange={this.SearchTrFromDatebind}

                                                    />*/}
                                                        <DatePicker className="form-control place datepicker-class "
                                                            id="stFrom"
                                                            fixedHeight
                                                            placeholderText="MM/DD/YYYY"
                                                            dateFormat="MM/dd/yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            selected={this.state.SearchTrFromDate}
                                                            maxDate={this.state.SearchTrToDate}
                                                            onChange={(e) => this.handleDatePicker(e, "SearchTrFromDate")}
                                                        //value={this.state.FromDate}
                                                        />
                                                        <span className="calendar-icon filter-calendar-icon custom-datepicker float-left" style={{ "top": "37px" }} onClick={() => $(`#stFrom`).focus()} />

                                                    </div>
                                                    <div className="col-md-6 float-left mb-4 pr-0 pl-1 ssd section-content-padding">
                                                        {/*bug 4080 - Yuvarani K*/}
                                                        <label className="catalog-label">To <span className="info-container"><img className="info-searchpage" src="Images/info-icon.png" /><span className="info-content info-position"><Trans>Date range is limited to 3 months</Trans></span></span></label>
                                                        {/*<DatePicker className="form-control "
                                                        id="OrderByToDate"
                                                        fixedHeight
                                                        
                                                        placeholderText="MM/DD/YYYY"
                                                        dateFormat="MM/dd/yyyy"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        //dropdownMode="select"
                                                        //minDate={new Date()}
                                                        value={this.state.SearchTrToDate}
                                                        onChange={this.SearchTrToDatebind}

                                                    />*/}
                                                        <DatePicker className="form-control place datepicker-class"
                                                            id="stTo"
                                                            fixedHeight
                                                            placeholderText="MM/DD/YYYY"
                                                            dateFormat="MM/dd/yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            selected={this.state.SearchTrToDate}
                                                            minDate={this.state.SearchTrFromDate}
                                                            onChange={(e) => this.handleDatePicker(e, "SearchTrToDate")}
                                                        //value={this.state.ToDate}
                                                        />
                                                        <span className="calendar-icon filter-calendar-icon custom-datepicker float-left" style={{ "top": "37px" }} onClick={() => $(`#stTo`).focus()} />

                                                    </div>
                                                </div>
                                                {/*<div className="col-md-3 middle-field mt-4 mb-3 text-center" id="OR">(OR)
                                        </div>*/} </>
                                            : null}
                                        {/*  {this.state.ReportDateField == "99" ?*/}
                                        <div className="col-md-3 pr-0 left-field mb-3" id="sdrp">
                                            {/*<label className="catalog-label"><Trans>Search by</Trans></label>*/}
                                            <div className="input-group dropdown-search float-left mb-2 w-100">
                                                {/* <div className="input-group-prepend">
                                                    <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >{this.state.STrDisplayName}</button>
                                                    <div className="dropdown-menu" style={{}}>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Order Number", "OrderNo")}><Trans>order_key</Trans><span> </span> <Trans>Number</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Work Order Number", "WorkOrderNumberPenn")}><Trans>workorder_key</Trans><span> </span> <Trans>Number</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Item Description", "ItemDescription")}><Trans>Item</Trans><span> </span> <Trans>Description</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Ordered For", "OrderedFor")}><Trans>orderedfor_key</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Priority Orders", "PriorityOrders")}><Trans>Priority</Trans> <span> </span><Trans>Orders</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Order Status", "OrderStatus")}><Trans>order_key</Trans><span> </span> <Trans>Status</Trans></a>
                                                    </div>
                                                </div>*/}
                                                {/*{searchTrBy != "OrderStatus" ?*/}
                                                {/* <input type="text" className="form-control " placeholder="Search" aria-label="Text input with dropdown button" onBlur={this.handleSTrTxt} id="SearchTrTxt" />*/}

                                                {/*<select className="form-control search-color" name="searchTrCriteria" id="status-dropdown" value={this.state.searchTrCriteria} onChange={this.handleOrderStatus}>
                                                    <option value="select">--Select Status--</option>
                                                    {this.OrderStatusDropdown()}
                                                </select>*/}

                                            </div>
                                            {/* <div className="col-md-12 p-0 float-left">
                                                <label className="custom-radiobtn" id="ex"><Trans>Search exact value</Trans>
              <input type="radio" name="searchoption" id="exval" checked={this.state.EV} onChange={() => this.handleRadioButton("ExactValue")} />
                                                    <span className="checkmark checkmark-org" />
                                                </label>
                                                <label className="custom-radiobtn" id="6m"><Trans>Search containing value but limit to last 6 months</Trans>
              <input type="radio" name="searchoption" id="6month" className="6month" checked={this.state.MN} onChange={() => this.handleRadioButton("6month")} />
                                                    <span className="checkmark checkmark-org " />
                                                </label>
                                                <label className="custom-radiobtn" id="dr"><Trans>Search containing value limit to date range entered above</Trans>
              <input type="radio" name="searchoption" id="dateRag" checked={this.state.DR} onChange={() => this.handleRadioButton("dateRange")} />
                                                    <span className="checkmark checkmark-org" />
                                                </label>
                                            </div>*/}
                                            {/*<div className="col-md-12 p-0 float-left">
                                                <label className="custom-radiobtn" id="ex1">Search exact value
              <input type="radio" name="radio" id="exval1" checked={this.state.ExactValueRR} onChange={(e) => this.handleRadio(e, "ExactValue")} />
                                                    <span className="checkmark checkmark-org" />
                                                </label>
                                                <label className="custom-radiobtn" id="6m1">Search containing value but limit to last 6 months
              <input type="radio" name="radio" id="6month1" checked={this.state.MonthRR} onChange={(e) => this.handleRadio(e, "6month")} />
                                                    <span className="checkmark checkmark-org " />
                                                </label>
                                                <label className="custom-radiobtn" id="dr1">Search containing value limit to date range entered above
              <input type="radio" name="radio" id="dateRag1" checked={this.state.dateRangeRR} onChange={(e) => this.handleRadio(e, "dateRange")} />
                                                    <span className="checkmark checkmark-org" />
                                                </label>
                                            </div>*/}
                                        </div>  {/* :null}*/}




                                        <div className="col-md-12 ">
                                            <div className="row justify-content-between align-items-center">{/*WW-399_PC_05 (5/12/2022)-Aparna**/}
                                                <div className="col-md-auto col-12 col-sm-12 my-3">
                                                    {/***search text box for all search**7/14/2021*****/}
                                                    <div className="mt-2 " >

                                                        {/* <div className="dropdown float-left">
                                                    <a href="#" className="float-left filter-icon mt-1 mx-1" title="Advanced Filter" onClick={(e) => this.filtertoggle(e)} ><img src="images/filter-icon.png" alt="Filter Icon" />
                                                    </a> */}
                                                        {/*<div className={`dropdown-menu order-maintenance-filter-added m-0 mobile-filter-ch-new advancealign ${this.state.isFilterOpen ? 'd-block' : ''}`} id="advanced-filter">
                                                        <div className="container-fluid">
                                                            <div className="row">
                                                                <div className="col-md-12 p-0 pb-2 border-bottom  mb-3">
                                                                    <span className="filter-title pl-3"><Trans>Advanced</Trans><span> </span> <Trans>Filter</Trans></span>
                                                                    <button type="button" className="filter-close close pr-2 filter-btn" onClick={(e) => this.filtertoggle(e)}><span className="filter-close-icon" /></button>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <label className="catalog-label col-md-12 float-left mb-0"><Trans>Order</Trans><span> </span><Trans>Date</Trans></label>
                                                                    <div className="col-md-6 float-left mb-4">
                                                                        <label className="catalog-label mb-0"><Trans>From</Trans></label>
                                                                        <DatePicker className="form-control"
                                                                            id="OF"
                                                                            fixedHeight
                                                                            placeholderText="MM/DD/YYYY"
                                                                            dateFormat="MM/dd/yyyy"
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            selected={this.state.OFromDate}
                                                                            maxDate={this.state.OToDate}
                                                                            onChange={(e) => this.handleDatePicker(e, "OFromDate")}
                                                                        //value={this.state.FromDate}
                                                                        />
                                                                        <span className="calendar-icon filter-calendar-icon" onClick={() => $(`#OF`).focus()} />

                                                                    </div>
                                                                    <div className="col-md-6 float-left mb-4">
                                                                        <label className="catalog-label mb-0 w-100"><Trans>To</Trans></label>
                                                                        <DatePicker className="form-control"
                                                                            id="OT"
                                                                            fixedHeight
                                                                            placeholderText="MM/DD/YYYY"
                                                                            dateFormat="MM/dd/yyyy"
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            selected={this.state.OToDate}
                                                                            minDate={this.state.OFromDate}
                                                                            onChange={(e) => this.handleDatePicker(e, "OToDate")}
                                                                        //value={this.state.ToDate}
                                                                        />
                                                                        <span className="calendar-icon filter-calendar-icon" onClick={() => $(`#OT`).focus()} />

                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <label className="catalog-label col-md-12 float-left mb-0"><Trans>Delivery date</Trans></label>
                                                                    <div className="col-md-6 float-left mb-4">
                                                                        <label className="catalog-label mb-0"><Trans>From</Trans></label>
                                                                        {/*<DatePicker className="form-control "
                                                                                id="FromNeedDate"
                                                                                fixedHeight
                                                                                name="NFromDate"
                                                                                placeholderText="MM/DD/YYYY"
                                                                                dateFormat="MM/dd/yyyy"
                                                                                showMonthDropdown
                                                                                showYearDropdown
                                                                                //dropdownMode="select"
                                                                                
                                                                                //selected={this.state.NFromDate}
                                                                                onChange={this.FromNeedDate}
                                                                                value={this.state.NFromDate}
                                                                            />*/}
                                                        {/*    <DatePicker className="form-control "
                                                                            id="NF"
                                                                            fixedHeight
                                                                            placeholderText="MM/DD/YYYY"
                                                                            dateFormat="MM/dd/yyyy"
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            selected={this.state.NFromDate}
                                                                            maxDate={this.state.NToDate} 
                                                                            onChange={(e) => this.handleDatePicker(e, "NFromDate")}
                                                                        //value={this.state.FromDate}
                                                                        />
                                                                        <span className="calendar-icon filter-calendar-icon" onClick={() => $(`#NF`).focus()} />

                                                                    </div>
                                                                    <div className="col-md-6 float-left mb-4 ">
                                                                        <label className="catalog-label mb-0 w-100"><Trans>To</Trans></label>
                                                                        {/*<DatePicker className="form-control "
                                                                                id="ToNeedDate"
                                                                                fixedHeight
                                                                                name="NToDate"
                                                                                placeholderText="MM/DD/YYYY"
                                                                                dateFormat="MM/dd/yyyy"
                                                                                showMonthDropdown
                                                                                showYearDropdown
                                                                                //dropdownMode="select"
                                                                                
                                                                                //selected={this.state.NToDate}
                                                                                onChange={this.ToNeedDate}
                                                                                value={this.state.NToDate}

                                                                            />*/}
                                                        {/*  <DatePicker className="form-control "
                                                                            id="NT"
                                                                            fixedHeight
                                                                            placeholderText="MM/DD/YYYY"
                                                                            dateFormat="MM/dd/yyyy"
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            selected={this.state.NToDate}
                                                                            minDate={this.state.NFromDate}
                                                                            onChange={(e) => this.handleDatePicker(e, "NToDate")}
                                                                        //value={this.state.ToDate}
                                                                        />
                                                                        <span className="calendar-icon filter-calendar-icon" onClick={() => $(`#NT`).focus()} />

                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12 mb-2">
                                                                    <div className="float-right">
                                                                        <button className="btn btn-primary filter-clear-btn px-4 mr-2 filter-btn" onClick={this.clearButtonClick}><Trans>Clear</Trans></button>
                                                                        <button className="btn btn-primary custom-btn-primary filter-btn primary-btn wallet-btn px-4" onClick={this.ApplyButtonClick}><Trans>Apply</Trans></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                        {/*  </div>  */}
                                                        <div className="input-group dropdown-search float-left mb-2 order-filter-width" style={{ "width": "100%" }}>

                                                            <input type="text" className="form-control newsearchborderright" placeholder="WO/Order #" aria-label="Text input with dropdown button" id="searchTxt" onKeyDown={this.AnykeyHeaderPress} onChange={this.handleSearchTxt} />

                                                            <span className={this.state.SearchedTxt != null && this.state.SearchedTxt != "" && this.state.SearchedTxt != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left", "marginRight": "10px" }} onClick={() => this.ClearSearch()}></span>

                                                            <div className="input-group-append" style={{ "marginLeft": "-4px" }}>
                                                                <span className="input-group-text OrderStatus-SrchBar" onClick={(e) => this.handleHeaderSearch(false, "")} >
                                                                    <span className="shopping-search-icon" />
                                                                </span>
                                                            </div>
                                                        </div>

                                                    </div>{/****END**/}
                                                </div>
                                                <div className="col-md-auto col-auto col-sm-auto text-right my-3">
                                                    {/*<button className="btn btn-primary custom-btn-primary primary-btn mr-2" id="applyfilterid" onClick={() => this.GetHeaderDetailes(true, "", this.state.toggleChecked,"No")}><Trans>Apply</Trans><span> </span> <Trans>Filter</Trans></button>*/}
                                                    {this.state.isSearch ? <button className="btn btn-secondary custom-btn-secondary secondary-btn" id="savepreferences" onClick={this.SavePrefCheckForGroup}><Trans>Save</Trans><span> </span> <Trans>Preference</Trans></button> : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*this.state.searchAval || this.state.toggleChecked?*/}{/**WW-366_PC_11 to display 'no search result' page when there is not data(5/31/2022)-Aparna*/}
                                    {this.state.ApplyFilterClick ?
                                        <div className="row">
                                            <div className="col-md-12 mb-2">
                                                <div className="row justify-content-between align-items-center">
                                                    <div className="indicate-alert col-sm-12 col-12 col-md-3 col-lg-3 my-2">
                                                        <Trans>Indicates Replen Order</Trans>
                                                        {/*<div className="round-slider-container"><div className="round-slider"></div></div>
                                                     <span>
                                                        <div className="round-slider-container"></div>
                                                      <input type="checkbox" id="toggle-checkbox" />
                                                        <label className="round-slider-container"><div className="round-slider"></div></label>
                                                    </span>*/}

                                                        <span><label>
                                                            <Switch
                                                                onChange={() => this.handleToggleChange(!this.state.toggleChecked)}
                                                                checked={this.state.toggleChecked}
                                                                color="primary"
                                                            />
                                                        </label></span>

                                                    </div>
                                                    <div className="col-sm-12 col-md-auto">{this.state.totalCount > 0 ? <>{/*WW-366_PC_11*/}
                                                        {this.state.toggleChecked == false ? <button className="btn btn-primary custom-btn-primary mb-2 mr-3" id="buycheckeditems" onClick={e => this.addFavItemsToCart(false, false)}><Trans>Buy Checked Items</Trans></button> : null}
                                                        {/* <button className="btn btn-primary custom-btn-primary mb-2 mr-3" id="expanorcollapseall" onClick={this.expandAll}><Trans>{!this.state.isExpand ? `Expand All` : `Collapse All`}</Trans></button>*/}
                                                        <button className="btn btn-primary custom-btn-primary mb-2 " id="exporttoexcel" onClick={this.ExportToExcel}><Trans>Export to Excel</Trans></button></> : null}

                                                        {/***Item Removed (search text and advanced filter****/}

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-lg-12">
                                                <div className="table-responsive">
                                                    <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                                        <thead>
                                                            <tr>
                                                                <th />
                                                                <th />
                                                                <th className="d-sm-none d-md-table-cell position-sort-icon"><Trans>Order</Trans> <span>#</span><span className="sort-up ml-1" onClick={(e) => this.SortingFront("ASC", "ORDER_NO")}><img src="Images/sort2.svg" /></span><span className="sort-downi ml-1" onClick={(e) => this.SortingFront("DESC", "ORDER_NO")}><img src="Images/sort1.svg" /></span></th>
                                                                {/*<th className="position-sort-icon">Line #<span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "LINE_NBR")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "LINE_NBR")}><img src="Images/sort1.svg" /></span></th>*/}
                                                                {/* <th className="d-sm-none d-md-table-cell position-sort-icon">Status<span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "LINE_STATUS")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "LINE_STATUS")}><img src="Images/sort1.svg" /></span></th>*/}
                                                                {/* <th className="d-none d-sm-none d-md-table-cell position-sort-icon">Item ID<span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "ISA_ITEM")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "ISA_ITEM")}><img src="Images/sort1.svg" /></span></th>*/}
                                                                <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>workorder_key</Trans><span className="sort-up ml-1" onClick={(e) => this.SortingFront("ASC", "ISA_WORK_ORDER_NO")}><img src="Images/sort2.svg" /></span><span className="sort-downi ml-1" onClick={(e) => this.SortingFront("DESC", "ISA_WORK_ORDER_NO")}><img src="Images/sort1.svg" /></span></th>
                                                                {/*<th className="d-none d-sm-none d-md-table-cell position-sort-icon">Business Unit<span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "BUSINESS_UNIT_OM")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "BUSINESS_UNIT_OM")}><img src="Images/sort1.svg" /></span></th>*/}

                                                                <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Install</Trans><span> </span> <Trans>Store</Trans><span className="sort-up ml-1" onClick={(e) => this.SortingFront("ASC", "BILL_TO_STORE")}><img src="Images/sort2.svg" /></span><span className="sort-downi ml-1" onClick={(e) => this.SortingFront("DESC", "BILL_TO_STORE")}><img src="Images/sort1.svg" /></span></th>
                                                                {/*<th className="d-none d-sm-none d-md-table-cell position-sort-icon">Priority<span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "LINE_PRIOR")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "LINE_PRIOR")}><img src="Images/sort1.svg" /></span></th>*/}
                                                                <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>orderenteredby_key</Trans><span className="sort-up ml-1" onClick={(e) => this.SortingFront("ASC", "ENTEREDEMPNAME")}><img src="Images/sort2.svg" /></span><span className="sort-downi ml-1" onClick={(e) => this.SortingFront("DESC", "ENTEREDEMPNAME")} ><img src="Images/sort1.svg" /></span></th>
                                                                <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Order</Trans><span> </span> <Trans>Date</Trans></th>
                                                                {/* <th className="d-none d-sm-none d-md-table-cell position-sort-icon">Ordered For<span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "OPRID_ENTERED_BY")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "OPRID_ENTERED_BY")}><img src="Images/sort1.svg" /></span></th>*/}
                                                                {/* <th className="d-none d-sm-none d-md-table-cell position-sort-icon"> <span>PO </span><Trans>ID</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "PO_ID1")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "PO_ID1")}><img src="Images/sort1.svg" /></span></th>*/}
                                                                <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Status</Trans></th>
                                                                <th className="d-none d-sm-none d-md-table-cell position-sort-icon"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.totalCount > 0 ? this.bindHeaderDataGrid() :
                                                                (

                                                                    <tr>
                                                                        <td colSpan={11}>
                                                                            <section className="site-undercontruction container text-center center-panel pt-4">
                                                                                <div className="img-section">
                                                                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                                                                </div>
                                                                                <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                                                </p>
                                                                            </section>
                                                                        </td>
                                                                    </tr>)}
                                                            {/*{this.bindDataGrid()}*/}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {this.state.OrdertotalCount > 0 ? <>
                                                <div className="col-md-12">
                                                    <span className="total-records mt-2 d-inline-block">
                                                        <Trans>Number of Records</Trans><span>:</span><span className="ml-2">{this.state.totalCount}</span>
                                                    </span>
                                                    {this.state.OrdertotalCount > this.state.RecCount ? <ReactPaginate
                                                        previousLabel={<span className="right-pagination-arrow" />}
                                                        nextLabel={<span className="left-pagination-arrow" />}
                                                        previouClassName={'page-item'}
                                                        nextClassName={'page-item'}
                                                        previousLinkClassName={'page-link'}
                                                        nextLinkClassName={'page-link'}
                                                        disabledClassName={'disabled'}
                                                        breakLabel={'...'}
                                                        breakClassName={'page-item'}
                                                        breakLinkClassName={'page-link'}
                                                        pageCount={this.state.pageCount}
                                                        marginPagesDisplayed={1}
                                                        pageRangeDisplayed={2}
                                                        onPageChange={this.handlePageClick}
                                                        containerClassName={'custom-pagination pagination float-right'}
                                                        pageClassName={'page-item'}
                                                        pageLinkClassName={'page-link'}
                                                        activeClassName={'active'}
                                                        hrefBuilder={() => '#'}
                                                        forcePage={this.state.PageNo - 1}
                                                    /> : null}
                                                </div></> : null}

                                        </div> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" id="tracking-details" >
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title mt-1 sdi-font-18">Tracking Details</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            <div className="modal-body terms-scroll">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="table-responsive">
                                            <table className="pl-5 table ">
                                                <thead>
                                                    <tr className="table-active sdi-bg-th-color">
                                                        <th className="border-0 font-12">Tracking ID</th>
                                                        <th className="border-0 font-12">Ship Status</th>
                                                        <th className="border-0 font-12">Date</th>
                                                        <th className="text-right border-0 font-12">Ship Qty</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.BindASNdata()}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="text-center">
                                            <button type="button" className="btn btn-primary custom-btn-primary primary-btn" data-dismiss="modal">
                                                Close
                    </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" id="order-approval-history">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Item</Trans><span> </span> <Trans>Details</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                               </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 mb-5">
                                        {/* <span className="float-left cc-help-info"><Trans>Order</Trans><span> </span> <Trans>Details</Trans></span>*/}
                                        <span className="float-right cc-help-info">{CookieService.getLocalStorageValues("Session_CONAME")} </span>
                                    </div>
                                    <div className="row" style={{ flexWrap: 'nowrap', width: '70%' }}>
                                        <div className="col-md-12 edit-desc-field mb-4 " style={{ marginLeft: '5%', marginRight: '0%' }}>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Business</Trans> <span> </span><Trans>unit</Trans> <span> :</span> </label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.BUSINESS_UNIT_OM == null || this.state.ApprovalHistoryL.BUSINESS_UNIT_OM == "" || this.state.ApprovalHistoryL.BUSINESS_UNIT_OM == " " ? "-" : this.state.ApprovalHistoryL.BUSINESS_UNIT_OM}</label>
                                            </div>
                                            {/*WW-1347 OrderStatus field removal -Vishwa S*/}
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>unitofmeasure_key</Trans></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.UNIT}</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Price</Trans><span>/</span><Trans>Unit</Trans> <span> :</span></label>
                                                <label className="col-md-7 quick-value">$ 0</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Supplier</Trans> <span> :</span></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.SUPPLIER}</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Manufacturer</Trans> <span> :</span></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.MFG}</label>
                                            </div>

                                        </div>
                                        <div className="col-md-12 edit-desc-field mb-4" style={{ margin: '0%' }}>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Currency</Trans></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.CURRENCY == null || this.state.ApprovalHistoryL.CURRENCY == "" || this.state.ApprovalHistoryL.CURRENCY == " " ? "-" : this.state.ApprovalHistoryL.CURRENCY}</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><span>Rev. </span><Trans>Due date</Trans></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.REV_DUE_DATE == null || this.state.ApprovalHistoryL.REV_DUE_DATE == "" || this.state.ApprovalHistoryL.REV_DUE_DATE == " " ? "-" : this.state.ApprovalHistoryL.REV_DUE_DATE}</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Approved by</Trans></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.APPROVALBY == null || this.state.ApprovalHistoryL.APPROVALBY == "" || this.state.ApprovalHistoryL.APPROVALBY == " " ? "-" : this.state.ApprovalHistoryL.APPROVALBY}</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Ship doc</Trans></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.SHIPDOC == null || this.state.ApprovalHistoryL.SHIPDOC == "" || this.state.ApprovalHistoryL.SHIPDOC == " " ? "-" : this.state.ApprovalHistoryL.SHIPDOC}</label>
                                            </div>
                                            {/*WW-1347 OrderStatus field removal -Vishwa S*/}
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Asset tag ID</Trans></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.ASSET_TAG == null || this.state.ApprovalHistoryL.ASSET_TAG == "" || this.state.ApprovalHistoryL.ASSET_TAG == " " ? "-" : this.state.ApprovalHistoryL.ASSET_TAG}</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Asset</Trans><span> </span> <Trans>Type</Trans></label>
                                                <label className="col-md-7 quick-value">{this.state.ApprovalHistoryL.ASSET_TYPE == null || this.state.ApprovalHistoryL.ASSET_TYPE == "" || this.state.ApprovalHistoryL.ASSET_TYPE == " " ? "-" : this.state.ApprovalHistoryL.ASSET_TYPE}</label>
                                            </div>


                                        </div>
                                    </div>
                                    {this.state.ApprovalhistoryArr.length > 0 ?
                                        <div className="col-lg-12 float-left ">
                                            <div className="table-responsive">
                                                <table className="table ZEUS_Grid FOM-grid">
                                                    <thead>
                                                        <tr>
                                                            <th><Trans>Approved By</Trans><span> </span> <Trans>User Id</Trans></th>
                                                            <th><Trans>Approved BY</Trans></th>
                                                            <th><Trans>Approval</Trans><span> </span> <Trans>Status</Trans></th>
                                                            <th><Trans>Approval</Trans> <span> </span><Trans>Type</Trans></th>
                                                            <th><Trans>Date</Trans></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.historyGridBind()}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> : null}

                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal"><Trans>Close</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal" id="image_modal">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Item image detail</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                               </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <ImageGallery items={this.state.imagearray} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" id="shipmentpopup">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Proof of delivery</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                               </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 mb-5">
                                        <span className="float-left cc-help-info"></span>
                                        <span className="float-right cc-help-info">{CookieService.getLocalStorageValues("Session_CONAME")} </span>
                                    </div>
                                    {this.state.usernamedetail.length > 0 ? this.shippopup() : null}


                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="modal" id="po-details" data-backdrop="static" data-keyboard="false" >
                    <div className="modal-dialog modal-xl custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><span>PO </span><Trans>Details</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="col-md-12 p-0">
                                    <span className="float-right cc-help-info ">{CookieService.getLocalStorageValues("Session_CONAME")} </span>
                                </div>
                                <div className="col-md-12 p-0 float-left my-3">
                                    <div className="row mb-3">
                                        <h5 className="col-md-12 info-label "><span>PO </span><Trans>Details</Trans></h5>
                                    </div>
                                    {this.state.VenderDetail[0] != undefined || this.state.VenderDetail.length > 0 ?

                                        this.POData() : null}

                                    {this.state.VenderDetail[0] != undefined || this.state.VenderDetail.length > 0 ?


                                        this.PODetailhd() : null}
                                </div>
                                <div className="col-md-12 float-left mb-3 p-0">
                                    <label className="info-label pl-1 "><Trans>PO Header Status:</Trans></label>
                                    {this.PoHdStatus()}

                                </div>
                                <div className="col-md-12 mb-2 float-left p-0">
                                    <button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.POExpandAll}><Trans>Expand All</Trans></button>
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn float-left px-4 mr-3" onClick={this.POCollapseAll} ><Trans>Collapse All</Trans></button>
                                </div>
                                <div className="col-lg-12 float-left p-0">
                                    <div className="table-responsive">
                                        <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                            <thead>
                                                <tr>
                                                    <th />
                                                    <th>Req Ln #</th>
                                                    <th>Ln #</th>
                                                    <th className="d-none d-sm-none d-md-table-cell">Sch #</th>
                                                    <th><Trans>Line</Trans><span> </span><Trans>Status</Trans></th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><span>Orig. </span><Trans>Due</Trans><span> </span><Trans>Date</Trans></th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><Trans>Expected</Trans><span> </span><Trans>Delivery</Trans><span> </span><Trans>Date</Trans></th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><Trans>Request by</Trans><span> </span><Trans>Date</Trans></th>
                                                    <th className="text-right d-none d-sm-none d-md-table-cell ">PO QTY</th>
                                                    <th className="text-right d-none d-sm-none d-md-table-cell "><Trans>Received</Trans><span> QTY</span></th>
                                                    <th className="text-right d-none d-sm-none d-md-table-cell "><Trans>Reject</Trans><span> QTY</span></th>
                                                    {this.state.showprice != "0" && this.state.blockprice == "N" ? <th className="text-right"><Trans>Purchase</Trans><span> </span><Trans>Price</Trans></th> : null}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.bindPODataGrid()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center float-left mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal"><Trans>Close</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div className="modal" id="shipmentBOL">
                    <div className="modal-dialog modal-xl custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Shipment BOL</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            {this.state.shipmentBOL[0] != undefined ?
                                this.bindShipmentBol() : null}
                        </div>
                    </div>
                </div>
                <div className="modal orderstatus-popup" id="pdfPreview" data-backdrop="static" data-keyboard="false">
                    <PDFPreviewComponent key={OrderSuccessCOunt} base64URL={this.state.base64URL} pdfTitle="Order Status Report" {...this.props} />
                </div>
                {/*[2/2/2022, WW-350, Dhevanesam R]*/}
                <div className="modal" id="CancelItem-confirmation">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Cancel</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.CancelItemClosePopUp("LineItem")}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-12 mb-4">
                                        {this.state.IsConfirm ? <label className="confirm-label d-block"><Trans>Confirm</Trans></label> : null}
                                        <label className="confirm-content d-block"><Trans>{this.state.IprAlertMsge}</Trans></label>
                                    </div>
                                    {this.state.IsConfirm ? <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.CancelItemClosePopUp("LineItem")}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.CancelItemConfirmed("LineItem")}><Trans>Yes</Trans></button>
                                    </div> :
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.CancelItemClosePopUp("LineItem")}><Trans>Ok</Trans></button>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="CancelOrder-confirmation">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Cancel</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.CancelItemClosePopUp("OrderItem")}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-12 mb-4">
                                        {this.state.IsConfirm ? <label className="confirm-label d-block"><Trans>Confirm</Trans></label> : null}
                                        <label className="confirm-content d-block"><Trans>{this.state.IprAlertMsge}</Trans></label>
                                    </div>
                                    {this.state.IsConfirm ? <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.CancelItemClosePopUp("OrderItem")}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.CancelItemConfirmed("OrderItem")}><Trans>Yes</Trans></button>
                                    </div> :
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.CancelItemClosePopUp("OrderItem")}><Trans>Ok</Trans></button>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="CanceledItemSuccess">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">Cancel</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.CancelItemSuccessClosePopUp()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Order Cancellation</Trans></label>
                                        <label className="confirm-content d-block"><Trans>SDI will make every effort to cancel your order before it Ships. Please contact Support for any inquiries about this order.</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.CancelItemSuccessClosePopUp()}><Trans>Ok</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="CanceledItemReason">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h5 class="modal-title" >{this.state.reasonModal ? "Reason for cancel" : "Cancel comments" }</h5>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.CancelItemReasonClosePopUp()}>
                                    X
                                </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row">
                                    {this.state.reasonModal ? <div className="col-12">
                                        <label className="catalog-label"><Trans>Reason</Trans></label>
                                        <span className="color-manditory" id="CmntsMandatory">*</span>
                                        <select className="form-control" name="CancelItemReasonDrop" id="CancelItemReasonDrop" value={this.state.CancelItemReasonDrop} onChange={this.handleReasonChange} >
                                            <option value="Select">Select reason</option>
                                            <option value="Part is no longer needed">Part is no longer needed</option>
                                            <option value="Wrong Item Ordered">Wrong Item Ordered</option>
                                            <option value="Located part elsewhere?">Located part elsewhere?</option>
                                            <option value="Other, please describe">Other, please describe</option>
                                        </select>
                                        <br></br>
                                    </div> : null}

                                    <div class="col-md-12 mb-3">
                                        <label class="catalog-label" for="comments">Comments</label><span className="color-manditory">*</span>
                                        <textarea class={`form-control ${this.state.inValidComments && this.state.CancelItemReasonText.length < 5 ? 'border-color-red' : ''}`} id="CancelComment" placeholder="Enter comments" rows="3" maxLength="254" value={this.state.CancelItemReasonText} onChange={(e) => this.getReasonText(e)}></textarea>
                                        {this.state.inValidComments && this.state.CancelItemReasonText.length < 5 ? <label style={{ 'font-size': '15px', 'color': 'red' }} id="NotesLAbel">Please enter minimum 5 characters</label> : null}
                                    </div>
                                </div>
                            </div>

                            <div class="modal-footer border-0 pt-1 mb-2 px-4">
                                <button class="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 py-2" data-dismiss="modal" onClick={() => this.CancelItemReasonClosePopUp()}><Trans>Dismiss</Trans></button>
                                <button class="btn btn-custom-primary font-15 font-medium px-4 py-2" id="SaveCancelComments" disabled={(this.state.reasonModal && this.state.CancelItemReasonDrop == "Select") || !this.state.CancelItemReasonText} onClick={(e) => this.CancelItemReasonConfirmPopUp()}><Trans>Save</Trans></button>
                            </div>

                        </div>
                    </div>
                </div>
                {/**A1QA-248_PC_07**/}
                <div className="modal" id="CoreChargePopUp">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            {/* <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}>
                                    X
              </button>
                            </div>*/}
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.</Trans></label>
                                        <label className="confirm-content d-block"><Trans>By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.addFavItemsToCart(true, false)}><Trans>Cancel</Trans></button>{/**Added SelectedItemForCheaper to addtocart (which throwed exception)(9/5/2022)-Aparna*/}
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.addFavItemsToCart(true, true)}><Trans>Proceed</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal" id="PickupConfirmation" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered" style={{ width: "370px" }}>
                        <div className="modal-content">
                            {/* Modal Header */}
                            {/*<div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>*/}
                            {/* Modal body */}
                            <div className="col-md-12 my-1">
                                <span data-dismiss="modal" className="float-right" style={{ "cursor": "pointer" }} onClick={() => this.OnPickupCancelBtnClick()}>X</span>
                            </div>
                            <div className="modal-body">
                                <div className="row text-center">

                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon PickupOrder-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        {/*<label className="confirm-label d-block"><Trans>Confirm</Trans></label>*/}
                                        <label className="confirm-content d-block"><Trans>Did you pickup the item?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.OnPickupCancelBtnClick()}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.OnPickupOkBtnClick()}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--Modal Starts here-->*/}
                <div class="modal fade success-tracking-id" id="ReprintSucess" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div class="modal-content py-2">
                            {/* <!--Success Starts here-->*/}
                            <div class="modal-body pb-2">
                                <div class="row">

                                    <div class="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img class="mb-2" src="images/tick.svg" alt="tick" />
                                        <h5 class="mb-2 font-16 font-bold color-light-black">Success</h5>
                                        <p class="mb-1 font-13 font-regular color-light-black">{this.state.reprintSuccessmsg}</p>  </div>

                                </div>
                            </div>
                            {/*<!--Success end here-->*/}
                            <div class="modal-footer border-0 d-flex justify-content-center">
                                <button class="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">OK</button>
                            </div>

                        </div>
                    </div>
                </div>
                {/*<!--Modal Ends here-->*/}
                {/* <!--Modal Starts here-->*/}
                <div class="modal" id="submitreturnresponse" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div class="modal-content py-2">
                            {/* <!--Success Starts here-->*/}
                            <div class="modal-body pb-2">
                                <div class="row">

                                    <div class="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img class="mb-2" src="images/tick.svg" alt="tick" />
                                        <h5 class="mb-2 font-16 font-bold color-light-black">Success</h5>
                                        <p class="mb-1 font-13 font-regular color-light-black">Your Tracking# is generated successfully!</p>
                                        <p class="mb-0 font-13 font-medium color-light-black">{this.state.returnTrackingNumber} <a href><img class="ml-1 mb-1" src="images/copy.svg" alt="copy" onClick={() => this.CopyMessage()} style={{ cursor: "pointer" }} /></a></p>
                                    </div>

                                </div>
                            </div>
                            {/*<!--Success end here-->*/}
                            <div class="modal-footer border-0 d-flex justify-content-center">
                                <button class="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">OK</button>
                            </div>

                        </div>
                    </div>
                </div>
                {/*<!--Modal Ends here-->*/}
                <div class="modal fade return-core-item" id="coreDetails" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" onHide={this.clearCoreDetails}>
                    <div class="modal-dialog modal-dialog-centered shipping-detail-custom-width" role="document">
                        <div class="modal-content" style={{ width: "99%", left: "4px" }}>
                            <div class="modal-header sp-delv-header align-items-center">
                                <h5 class="modal-title" id="exampleModalLongTitle">Shipping Details</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.clearCoreDetails()}><img src="images/close-icon.svg" alt="close" /></button>
                            </div>
                            <div class="modal-body corereturn" >
                                <div class="row">

                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                                        <div class="row">
                                            <label class="col-md-3 font-14 font-medium text-black  px-0 mandatory-after">Pickup Type</label>
                                            <div class="col-md-9 px-0">

                                                <div class="form-check form-check-inline">
                                                    <label className="custom-radiobtn pb-3 mb-0"><Trans>Dropoff at FedEx</Trans>
                                                        <input type="radio" name="inlineRadioOptions" id="Dropoff" checked={this.state.isDropOff} onClick={(e) => this.handlePickupType(true)} />
                                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                                                    </label>
                                                    <label className="custom-radiobtn pb-3 mb-0"><Trans>Schedule Pickup</Trans>
                                                        <input type="radio" name="inlineRadioOptions" id="Schedule" checked={!this.state.isDropOff} onClick={(e) => this.handlePickupType(false)} />
                                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                                                    </label>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                                        <div class="row">
                                            <label class="col-md-3 font-14 font-medium text-black custom-radiobtn  px-0 mandatory-after">Service Type</label>
                                            <div class="col-md-9 px-0">
                                                {this.bindServiceType()}
                                            </div>
                                        </div>

                                    </div>


                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 mb-3">
                                        <div class="row">
                                            <label id="Weight" class="col-md-3 font-14 font-medium text-black  px-0 mandatory-after">Weight</label>
                                            <div class="col-md-8 px-0">
                                                <div class="input-group">
                                                    <input type="text" class="form-control slider-txtbox " min="0" id="weight"
                                                        placeholder="Enter weight" value={this.state.weightText} maxLength="6" onChange={(e) => this.weightChange(e)} />
                                                    <div class="input-group-append">
                                                        <button class="btn custom-bg-toggle py-1 font-13 font-regular custom-form-style" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">lbs</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {this.bindPackageType()}
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                        <div class="row">
                                            <label id="ship-date" class="col-md-3 font-14 font-medium text-black  px-0 mandatory-after">Ship Date</label>
                                            <div class="col-md-8 px-0">
                                                <DatePicker className="form-control datepicker"
                                                    id="ShipDate"
                                                    fixedHeight
                                                    placeholderText="YYYY-MM-DD"
                                                    dateFormat="yyyy-MM-dd"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selected={this.state.selectedShipdate}
                                                    minDate={new Date()}
                                                    maxDate={this.state.maxDate}
                                                    onChange={(e) => this.handleShipDate(e)}
                                                />
                                                <span className="calendar-icon OA-filter-calendar-icon" style={{ top: "9px" }} onClick={() => $(`#ShipDate`).focus()} />
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <span className="float-right err-msg text-danger font-14 mt-5">{this.state.coreResponseErr}</span>
                            </div>
                            <div class="modal-footer border-0 pt-0">
                                <button class="btn btn-custom-secondary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={(e) => this.clearCoreDetails()}>Cancel</button>
                                <button class="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" disabled={this.state.weightText == "" || parseInt(this.state.weightText) > 150 || this.state.selectedPackage.length == 0 || this.state.selectedService == "" || this.state.selectedShipdate == "" || this.state.selectedShipdate == null} onClick={() => this.SubmitReturn()}>Submit</button>
                            </div>
                        </div>
                    </div>


                </div>

                {/* My Approver Modal Starts here*/}
                <div
                    className="modal fade my-approver-details"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered custom-success-width"
                        role="document"
                    >
                        <div className="modal-content">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Approver Info
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <img src="Images/close-icon.svg" alt="close" />
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center d-flex flex-column justify-content-center align-items-center mt-2">
                                            {/*Current user start here*/}
                                            <p className="Font-14 font-bold mb-2 text-black">
                                                Current User
                                            </p>
                                            <div className="custom-approver-card-style next-approver-card-after w-55 pr-4 pl-4">
                                                <div className="d-flex align-items-center justify-content-center float-left">
                                                    <div className="d-block mr-2">
                                                        <img
                                                            className=""
                                                            src="Images/user-icon.svg"
                                                            alt="user-icon"
                                                        />
                                                    </div>
                                                    <div className="d-block text-left">
                                                        <p className="font-medium font-12 mb-0 mt-3 text-black order-status-workorder">
                                                            {this.state.CurrentUserName}
                                                        </p>
                                                        <p className="mb-3">
                                                            <span className="font-regular font-10 color-grey mr-1">
                                                                Budgetary Limit:
                                                            </span>
                                                            <span className="Font-14 font-bold text-black">
                                                                ${this.state.CurrentUserLimit}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*Current user ends here*/}
                                            {/*Next Approver starts here*/}
                                            <p className="Font-14 font-bold mb-2 text-black">
                                                Next Approver
                                            </p>
                                            <div className="custom-approver-card-style w-55 pr-4 pl-4">
                                                <div className="d-flex align-items-center justify-content-center float-left">
                                                    <div className="d-block mr-2">
                                                        <img
                                                            className=""
                                                            src="Images/user-icon.svg"
                                                            alt="user-icon"
                                                        />
                                                    </div>
                                                    <div className="d-block text-left">
                                                        <p className="font-medium font-12 mb-0 mt-3 text-black order-status-workorder">
                                                            {this.state.NextApprover}
                                                        </p>
                                                        <p className="mb-3">
                                                            <span className="font-regular font-10 color-grey mr-1">
                                                                Budgetary Limit:
                                                            </span>
                                                            <span className="Font-14 font-bold text-black">
                                                                {this.state.NextApproverLimit != null ? `$${this.state.NextApproverLimit}` : "-"}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*Next Approver ends here*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*My Approver Modal Ends here*/}
                {/*Header notes popup starts here*/}
                <div className="modal fade work-order-info" id="header-notes" tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog custom-work-order-width modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header sp-delv-header">
                                <h6 className="modal-title font-medium font-16" id="exampleModalLongTitle">Order Notes</h6>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            <div className="modal-body py-4">
                                <div className="row">
                                    {/*Header notes starts here*/}
                                    <div className="col-md-12" style={{ "float": 'right' }}>
                                        <span style={{ "margin-top": "7px" }} onClick={() => this.copyNotes(this.state.headerNotes)}><img className="px-1" src="Images/CopyImage.png" alt="Copy" title="Copy" style={{ height: '20px', "float": 'right' }} /></span>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="font-16 font-regular modal-inner-label-value" style={{ "word-wrap": 'break-word', "width": '100%' }}>{this.state.headerNotes}</label>
                                    </div>
                                    {/*Header notes ends here*/}
                                </div>
                            </div>
                            {/*footer starts here*/}
                            <div className="modal-footer d-flex justify-content-center border-0 pt-0 pb-4">
                                <button type="button" className="btn custom-btn-primary px-4 font-16 font-medium" data-dismiss="modal">OK</button>
                            </div>
                            {/*footer starts here*/}
                        </div>
                    </div>
                </div>
                {/*Header Notes popup end here*/}

                {/*!--Approver List Modal Starts here-->*/}
                <div className="modal fade approver-chain-details pl-0" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered approver-custom-width modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Approval Chain
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => this.closeApproverspopup("approval-chain")}
                                >
                                    <img src="Images/close-icon.svg" alt="close" />
                                </button>
                            </div>
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center d-flex flex-column justify-content-center align-items-center mt-2">
                                            {this.bindApproverList()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*!--Approver List Modal Ends here-->*/}

                {/*!--Remainder Modal Starts here-->*/}
                <div
                    className="modal fade remaind-alternate-approver"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered "
                        role="document"
                    >
                        <div className="modal-content py-2">
                            {/*Delete Starts here*/}
                            <div className="modal-body pb-0">
                                <div className="row">
                                    <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img
                                            className="mb-3"
                                            src="images/question-icon.svg"
                                            alt="question-icon"
                                        />
                                        <h5 className="mb-2 font-16 font-bold color-light-black">
                                            Confirm
                                        </h5>
                                        <p className="mb-1 font-13 font-regular color-light-black">
                                            Are you sure you want to notify this approver?
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/*Delete ends here*/}
                            <div className="modal-footer border-0 d-flex justify-content-center">
                                <button
                                    className="btn btn-custom-secondary font-15 font-medium mr-2 mb-2 px-4 py-2"
                                    data-dismiss="modal" onClick={() => this.closeApproverspopup("remainder")}
                                >
                                    No
                                </button>
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => this.sendRemiander()}>
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*!--Remainder Modal Ends here-->*/}


                {/* Start a return modal starts here */}
                <div className="modal fade p-0" id="RMAReasonPopUp" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog modal-m modal-dialog-centered" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Please provide the reason for return
                                </h5>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.RMAReasonClearBtn()}>
                                    X
                                </button>
                            </div>
                            <div className="modal-body col-12 mb-4">
                                <label className="catalog-label"><Trans>Reason</Trans> <Trans>type</Trans> </label>
                                <select className="form-control mb-3" name="ReturnReasonDropdown" value={this.state.RMAReasonDD} onChange={this.handleRMAReasonChange}>
                                    {/*5628 - select option only display when no other options is selected [4/18/2025] Nachiappan */}
                                    {this.state.RMAReasonDD === "Select" && (
                                        <option key={0} value={"Select"} disabled>Select</option>
                                    )}
                                    { this.bindReturnReasonDD()}
                                </select>

                                <label className={this.state.RMAReasonDD == "Others" ? "catalog-label mandatory-after" : "catalog-label"}><Trans>Comments</Trans></label>
                                <textarea type="text" className="form-control float-left" id="ReturnReasonComments" placeholder="Enter comments" maxLength="254" rows={2} value={this.state.RMAReasonComment} onChange={(e) => this.handleRMACommentChange(e)} defaultValue={""} />
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                    type="button" onClick={() => this.RMAReasonClearBtn()}>Clear</button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" disabled={!this.state.returnSubmitBtn} onClick={(e) => this.returnSubmitBtnClick()}
                                    type="button">Submit</button>
                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/* Start a return modal ends here */}

                {/* <!--Start a return Success popup Modal Starts here-->*/}
                <div class="modal" id="StartAReturnSuccessPopUp" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div class="modal-content py-2">
                            {/* <!--Success Starts here-->*/}
                            <div class="modal-body pb-2">
                                <div class="row">

                                    <div class="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img class="mb-3" src="images/tick.svg" alt="tick" />
                                        <p class="mb-1 font-13 font-regular color-light-black">The ticket has been submitted to process the return.</p>
                                    </div>

                                </div>
                            </div>
                            {/*<!--Success end here-->*/}
                            <div class="modal-footer border-0 d-flex justify-content-center pt-2">
                                <button class="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">OK</button>
                            </div>

                        </div>
                    </div>
                </div>
                {/*<!--Start a return Success popup Modal Ends here-->*/}


                {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                <div className="modal fade p-0" id="MixedOrderConfirmPopup" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Confirmation
                                    </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                {this.state.cartConfirmationPopupTxt}
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  >No</button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                    type="button">Yes</button>

                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}
                {/*Notes display modal starts here*/}
                <div class="modal fade order-notes pl-0" tabindex="-1" role="dialog" id="NotesPopup" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered ordernotes-custom-width  modal-dialog-scrollable" role="document">
                        <div class="modal-content border-0">
                            <div class="modal-header sp-delv-header align-items-center">
                                <h5 class="modal-title" id="exampleModalLongTitle">{this.state.notesHeader}</h5>
                                <button type="button" className="btn close-btn" data-dismiss="modal" >X</button>
                            </div>

                            <div class="modal-body pt-4">
                                <div class="row">
                                    {this.state.orderNotes && this.state.orderNotes.length > 0 ?
                                        <div className="col-md-12 mb-3">
                                            <div className={`${lastNotes == "orderNotes" ? 'current-user-style' : 'border' } rounded px-3 py-3`}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-2">
                                                        <h5 className="font-16 font-bold">{this.state.notesHeader.includes("Order") ? 'Order notes' : 'Item notes'}</h5>
                                                    </div>
                                                    {this.bindNotes(this.state.orderNotes)}
                                                </div>
                                            </div>
                                        </div> : null}
                                    {this.state.requestorNotes && this.state.requestorNotes.length > 0 ?
                                        <div className="col-md-12 mb-3">
                                            <div className={`${lastNotes == "requestorNotes" ? 'current-user-style' : 'border' } rounded px-3 py-3`}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-2">
                                                        <h5 className="font-16 font-bold">Requestor notes</h5>
                                                    </div>
                                                    {this.bindNotes(this.state.requestorNotes)}
                                                </div>
                                            </div>
                                        </div> : null}
                                    {this.state.budgetaryNotes && this.state.budgetaryNotes.length > 0 ?
                                        <div className="col-md-12 mb-3">
                                            <div className={`${lastNotes == "budgetaryNotes" ? 'current-user-style' : 'border' } rounded px-3 py-3`}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-2">
                                                        <h5 className="font-16 font-bold">Budgetary notes</h5>
                                                    </div>
                                                    {this.bindNotes(this.state.budgetaryNotes)}
                                                </div>
                                            </div>
                                        </div> : null}
                                    {this.state.cancelNotes && this.state.cancelNotes.length > 0 ?
                                        <div className="col-md-12 mb-3">
                                            <div className="border-red rounded px-3 py-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-2">
                                                        <h5 className="font-16 font-bold">{this.state.notesHeader.includes("Order") ? 'Order cancel notes' : 'Item cancel notes'}</h5>
                                                    </div>
                                                    {this.bindNotes(this.state.cancelNotes)}
                                                </div>
                                            </div>
                                        </div> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Notes display modal ends here*/}
                {/*// WW-1339- Order Status Attachments popup - Dhinesh]*/}
                <div className="modal fade attachments-popup" id="Attachments" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-l custom-popup modal-dialog-centered" role="document">
                        <div className="modal-content custom-container">
                            <div className="modal-header align-items-center">
                                <h4 className="modal-title mt-1 font-18 font-semibold"><Trans>Attachments</Trans></h4>
                                <button type="button" className="btn py-0" data-dismiss="modal">
                                    <img src="images/close-icon.svg" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body terms-scroll py-0 pt-2">
                                <p className="font-14 font-medium mt-2">
                                    <Trans>Documents</Trans><span>{'(' + this.state.pdfarray.length + ')'}</span>
                                </p>
                                <div className="row mb-2 documents-section">
                                    {this.state.pdfarray.length > 0 ? this.bindAttachments() : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Modal Ends here*/}
            </div>
        );




    };


}
export default withTranslation()(OrderStatusComponent);
